(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9HB6H", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fy1yK"));

});
parcelRegister("fy1yK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b51b3dabc534165f$export$ffb0004e005737fa; }, function (v) { return $b51b3dabc534165f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $b51b3dabc534165f$export$34b9dba7ce09269b; }, function (v) { return $b51b3dabc534165f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $b51b3dabc534165f$export$25062201e9e25d76; }, function (v) { return $b51b3dabc534165f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b51b3dabc534165f$export$ffb0004e005737fa;
var $b51b3dabc534165f$export$34b9dba7ce09269b;
var $b51b3dabc534165f$export$25062201e9e25d76;
'use strict';

var $iD6kw = parcelRequire("iD6kw");
var $b51b3dabc534165f$var$k = Symbol.for("react.element"), $b51b3dabc534165f$var$l = Symbol.for("react.fragment"), $b51b3dabc534165f$var$m = Object.prototype.hasOwnProperty, $b51b3dabc534165f$var$n = $iD6kw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b51b3dabc534165f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b51b3dabc534165f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b51b3dabc534165f$var$m.call(a, b) && !$b51b3dabc534165f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b51b3dabc534165f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b51b3dabc534165f$var$n.current
    };
}
$b51b3dabc534165f$export$ffb0004e005737fa = $b51b3dabc534165f$var$l;
$b51b3dabc534165f$export$34b9dba7ce09269b = $b51b3dabc534165f$var$q;
$b51b3dabc534165f$export$25062201e9e25d76 = $b51b3dabc534165f$var$q;

});
parcelRegister("iD6kw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jowWt"));

});
parcelRegister("jowWt", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e1e9cfd39d0569dc$export$dca3b0875bd9a954; }, function (v) { return $e1e9cfd39d0569dc$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e1e9cfd39d0569dc$export$16fa2f45be04daa8; }, function (v) { return $e1e9cfd39d0569dc$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e1e9cfd39d0569dc$export$ffb0004e005737fa; }, function (v) { return $e1e9cfd39d0569dc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e1e9cfd39d0569dc$export$e2c29f18771995cb; }, function (v) { return $e1e9cfd39d0569dc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e1e9cfd39d0569dc$export$221d75b3f55bb0bd; }, function (v) { return $e1e9cfd39d0569dc$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e1e9cfd39d0569dc$export$5f8d39834fd61797; }, function (v) { return $e1e9cfd39d0569dc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e1e9cfd39d0569dc$export$74bf444e3cd11ea5; }, function (v) { return $e1e9cfd39d0569dc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e1e9cfd39d0569dc$export$ae55be85d98224ed; }, function (v) { return $e1e9cfd39d0569dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e1e9cfd39d0569dc$export$3ba232387fd5d6dd; }, function (v) { return $e1e9cfd39d0569dc$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e1e9cfd39d0569dc$export$e530037191fcd5d7; }, function (v) { return $e1e9cfd39d0569dc$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e1e9cfd39d0569dc$export$fd42f52fd3ae1109; }, function (v) { return $e1e9cfd39d0569dc$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e1e9cfd39d0569dc$export$c8a8987d4410bf2d; }, function (v) { return $e1e9cfd39d0569dc$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e1e9cfd39d0569dc$export$d38cd72104c1f0e9; }, function (v) { return $e1e9cfd39d0569dc$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43; }, function (v) { return $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e1e9cfd39d0569dc$export$257a8862b851cb5b; }, function (v) { return $e1e9cfd39d0569dc$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e1e9cfd39d0569dc$export$a8257692ac88316c; }, function (v) { return $e1e9cfd39d0569dc$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e1e9cfd39d0569dc$export$488013bae63b21da; }, function (v) { return $e1e9cfd39d0569dc$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e1e9cfd39d0569dc$export$7c73462e0d25e514; }, function (v) { return $e1e9cfd39d0569dc$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e1e9cfd39d0569dc$export$7568632d0d33d16d; }, function (v) { return $e1e9cfd39d0569dc$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e1e9cfd39d0569dc$export$88948ce120ea2619; }, function (v) { return $e1e9cfd39d0569dc$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e1e9cfd39d0569dc$export$35808ee640e87ca7; }, function (v) { return $e1e9cfd39d0569dc$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e1e9cfd39d0569dc$export$fae74005e78b1a27; }, function (v) { return $e1e9cfd39d0569dc$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e; }, function (v) { return $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf; }, function (v) { return $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e1e9cfd39d0569dc$export$6d9c69b0de29b591; }, function (v) { return $e1e9cfd39d0569dc$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e1e9cfd39d0569dc$export$f680877a34711e37; }, function (v) { return $e1e9cfd39d0569dc$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e1e9cfd39d0569dc$export$d5a552a76deda3c2; }, function (v) { return $e1e9cfd39d0569dc$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e1e9cfd39d0569dc$export$aaabe4eda9ed9969; }, function (v) { return $e1e9cfd39d0569dc$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e1e9cfd39d0569dc$export$e5c5a5f917a5871c; }, function (v) { return $e1e9cfd39d0569dc$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e1e9cfd39d0569dc$export$1538c33de8887b59; }, function (v) { return $e1e9cfd39d0569dc$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e1e9cfd39d0569dc$export$13e3392192263954; }, function (v) { return $e1e9cfd39d0569dc$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e1e9cfd39d0569dc$export$b8f5890fc79d6aca; }, function (v) { return $e1e9cfd39d0569dc$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e1e9cfd39d0569dc$export$60241385465d0a34; }, function (v) { return $e1e9cfd39d0569dc$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e1e9cfd39d0569dc$export$306c0aa65ff9ec16; }, function (v) { return $e1e9cfd39d0569dc$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e1e9cfd39d0569dc$export$7b286972b8d8ccbf; }, function (v) { return $e1e9cfd39d0569dc$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e1e9cfd39d0569dc$export$83d89fbfd8236492; }, function (v) { return $e1e9cfd39d0569dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $e1e9cfd39d0569dc$export$dca3b0875bd9a954;
var $e1e9cfd39d0569dc$export$16fa2f45be04daa8;
var $e1e9cfd39d0569dc$export$ffb0004e005737fa;
var $e1e9cfd39d0569dc$export$e2c29f18771995cb;
var $e1e9cfd39d0569dc$export$221d75b3f55bb0bd;
var $e1e9cfd39d0569dc$export$5f8d39834fd61797;
var $e1e9cfd39d0569dc$export$74bf444e3cd11ea5;
var $e1e9cfd39d0569dc$export$ae55be85d98224ed;
var $e1e9cfd39d0569dc$export$3ba232387fd5d6dd;
var $e1e9cfd39d0569dc$export$e530037191fcd5d7;
var $e1e9cfd39d0569dc$export$fd42f52fd3ae1109;
var $e1e9cfd39d0569dc$export$c8a8987d4410bf2d;
var $e1e9cfd39d0569dc$export$d38cd72104c1f0e9;
var $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43;
var $e1e9cfd39d0569dc$export$257a8862b851cb5b;
var $e1e9cfd39d0569dc$export$a8257692ac88316c;
var $e1e9cfd39d0569dc$export$488013bae63b21da;
var $e1e9cfd39d0569dc$export$7c73462e0d25e514;
var $e1e9cfd39d0569dc$export$7568632d0d33d16d;
var $e1e9cfd39d0569dc$export$88948ce120ea2619;
var $e1e9cfd39d0569dc$export$35808ee640e87ca7;
var $e1e9cfd39d0569dc$export$fae74005e78b1a27;
var $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e;
var $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf;
var $e1e9cfd39d0569dc$export$6d9c69b0de29b591;
var $e1e9cfd39d0569dc$export$f680877a34711e37;
var $e1e9cfd39d0569dc$export$d5a552a76deda3c2;
var $e1e9cfd39d0569dc$export$aaabe4eda9ed9969;
var $e1e9cfd39d0569dc$export$e5c5a5f917a5871c;
var $e1e9cfd39d0569dc$export$1538c33de8887b59;
var $e1e9cfd39d0569dc$export$13e3392192263954;
var $e1e9cfd39d0569dc$export$b8f5890fc79d6aca;
var $e1e9cfd39d0569dc$export$60241385465d0a34;
var $e1e9cfd39d0569dc$export$306c0aa65ff9ec16;
var $e1e9cfd39d0569dc$export$7b286972b8d8ccbf;
var $e1e9cfd39d0569dc$export$83d89fbfd8236492;
'use strict';
var $e1e9cfd39d0569dc$var$l = Symbol.for("react.element"), $e1e9cfd39d0569dc$var$n = Symbol.for("react.portal"), $e1e9cfd39d0569dc$var$p = Symbol.for("react.fragment"), $e1e9cfd39d0569dc$var$q = Symbol.for("react.strict_mode"), $e1e9cfd39d0569dc$var$r = Symbol.for("react.profiler"), $e1e9cfd39d0569dc$var$t = Symbol.for("react.provider"), $e1e9cfd39d0569dc$var$u = Symbol.for("react.context"), $e1e9cfd39d0569dc$var$v = Symbol.for("react.forward_ref"), $e1e9cfd39d0569dc$var$w = Symbol.for("react.suspense"), $e1e9cfd39d0569dc$var$x = Symbol.for("react.memo"), $e1e9cfd39d0569dc$var$y = Symbol.for("react.lazy"), $e1e9cfd39d0569dc$var$z = Symbol.iterator;
function $e1e9cfd39d0569dc$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) return null;
    a = $e1e9cfd39d0569dc$var$z && a[$e1e9cfd39d0569dc$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e1e9cfd39d0569dc$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $e1e9cfd39d0569dc$var$C = Object.assign, $e1e9cfd39d0569dc$var$D = {};
function $e1e9cfd39d0569dc$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1e9cfd39d0569dc$var$D;
    this.updater = e || $e1e9cfd39d0569dc$var$B;
}
$e1e9cfd39d0569dc$var$E.prototype.isReactComponent = {};
$e1e9cfd39d0569dc$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e1e9cfd39d0569dc$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e1e9cfd39d0569dc$var$F() {}
$e1e9cfd39d0569dc$var$F.prototype = $e1e9cfd39d0569dc$var$E.prototype;
function $e1e9cfd39d0569dc$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1e9cfd39d0569dc$var$D;
    this.updater = e || $e1e9cfd39d0569dc$var$B;
}
var $e1e9cfd39d0569dc$var$H = $e1e9cfd39d0569dc$var$G.prototype = new $e1e9cfd39d0569dc$var$F;
$e1e9cfd39d0569dc$var$H.constructor = $e1e9cfd39d0569dc$var$G;
$e1e9cfd39d0569dc$var$C($e1e9cfd39d0569dc$var$H, $e1e9cfd39d0569dc$var$E.prototype);
$e1e9cfd39d0569dc$var$H.isPureReactComponent = !0;
var $e1e9cfd39d0569dc$var$I = Array.isArray, $e1e9cfd39d0569dc$var$J = Object.prototype.hasOwnProperty, $e1e9cfd39d0569dc$var$K = {
    current: null
}, $e1e9cfd39d0569dc$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e1e9cfd39d0569dc$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e1e9cfd39d0569dc$var$J.call(b, d) && !$e1e9cfd39d0569dc$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e1e9cfd39d0569dc$var$K.current
    };
}
function $e1e9cfd39d0569dc$var$N(a, b) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e1e9cfd39d0569dc$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && a.$$typeof === $e1e9cfd39d0569dc$var$l;
}
function $e1e9cfd39d0569dc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e1e9cfd39d0569dc$var$P = /\/+/g;
function $e1e9cfd39d0569dc$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && null != a.key ? $e1e9cfd39d0569dc$var$escape("" + a.key) : b.toString(36);
}
function $e1e9cfd39d0569dc$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e1e9cfd39d0569dc$var$l:
                case $e1e9cfd39d0569dc$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e1e9cfd39d0569dc$var$Q(h, 0) : d, $e1e9cfd39d0569dc$var$I(c) ? (e = "", null != a && (e = a.replace($e1e9cfd39d0569dc$var$P, "$&/") + "/"), $e1e9cfd39d0569dc$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e1e9cfd39d0569dc$var$O(c) && (c = $e1e9cfd39d0569dc$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e1e9cfd39d0569dc$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e1e9cfd39d0569dc$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e1e9cfd39d0569dc$var$Q(k, g);
        h += $e1e9cfd39d0569dc$var$R(k, b, e, f, c);
    }
    else if (f = $e1e9cfd39d0569dc$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e1e9cfd39d0569dc$var$Q(k, g++), h += $e1e9cfd39d0569dc$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e1e9cfd39d0569dc$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e1e9cfd39d0569dc$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e1e9cfd39d0569dc$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e1e9cfd39d0569dc$var$U = {
    current: null
}, $e1e9cfd39d0569dc$var$V = {
    transition: null
}, $e1e9cfd39d0569dc$var$W = {
    ReactCurrentDispatcher: $e1e9cfd39d0569dc$var$U,
    ReactCurrentBatchConfig: $e1e9cfd39d0569dc$var$V,
    ReactCurrentOwner: $e1e9cfd39d0569dc$var$K
};
function $e1e9cfd39d0569dc$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e1e9cfd39d0569dc$export$dca3b0875bd9a954 = {
    map: $e1e9cfd39d0569dc$var$S,
    forEach: function forEach(a, b, e) {
        $e1e9cfd39d0569dc$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $e1e9cfd39d0569dc$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $e1e9cfd39d0569dc$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$e1e9cfd39d0569dc$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e1e9cfd39d0569dc$export$16fa2f45be04daa8 = $e1e9cfd39d0569dc$var$E;
$e1e9cfd39d0569dc$export$ffb0004e005737fa = $e1e9cfd39d0569dc$var$p;
$e1e9cfd39d0569dc$export$e2c29f18771995cb = $e1e9cfd39d0569dc$var$r;
$e1e9cfd39d0569dc$export$221d75b3f55bb0bd = $e1e9cfd39d0569dc$var$G;
$e1e9cfd39d0569dc$export$5f8d39834fd61797 = $e1e9cfd39d0569dc$var$q;
$e1e9cfd39d0569dc$export$74bf444e3cd11ea5 = $e1e9cfd39d0569dc$var$w;
$e1e9cfd39d0569dc$export$ae55be85d98224ed = $e1e9cfd39d0569dc$var$W;
$e1e9cfd39d0569dc$export$3ba232387fd5d6dd = $e1e9cfd39d0569dc$var$X;
$e1e9cfd39d0569dc$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e1e9cfd39d0569dc$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e1e9cfd39d0569dc$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e1e9cfd39d0569dc$var$J.call(b, f) && !$e1e9cfd39d0569dc$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e1e9cfd39d0569dc$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e1e9cfd39d0569dc$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e1e9cfd39d0569dc$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e1e9cfd39d0569dc$export$c8a8987d4410bf2d = $e1e9cfd39d0569dc$var$M;
$e1e9cfd39d0569dc$export$d38cd72104c1f0e9 = function(a) {
    var b = $e1e9cfd39d0569dc$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e1e9cfd39d0569dc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e1e9cfd39d0569dc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$v,
        render: a
    };
};
$e1e9cfd39d0569dc$export$a8257692ac88316c = $e1e9cfd39d0569dc$var$O;
$e1e9cfd39d0569dc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e1e9cfd39d0569dc$var$T
    };
};
$e1e9cfd39d0569dc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e1e9cfd39d0569dc$export$7568632d0d33d16d = function(a) {
    var b = $e1e9cfd39d0569dc$var$V.transition;
    $e1e9cfd39d0569dc$var$V.transition = {};
    try {
        a();
    } finally{
        $e1e9cfd39d0569dc$var$V.transition = b;
    }
};
$e1e9cfd39d0569dc$export$88948ce120ea2619 = $e1e9cfd39d0569dc$var$X;
$e1e9cfd39d0569dc$export$35808ee640e87ca7 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useCallback(a, b);
};
$e1e9cfd39d0569dc$export$fae74005e78b1a27 = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useContext(a);
};
$e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e = function() {};
$e1e9cfd39d0569dc$export$6a7bc4e911dc01cf = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useDeferredValue(a);
};
$e1e9cfd39d0569dc$export$6d9c69b0de29b591 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useEffect(a, b);
};
$e1e9cfd39d0569dc$export$f680877a34711e37 = function() {
    return $e1e9cfd39d0569dc$var$U.current.useId();
};
$e1e9cfd39d0569dc$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useImperativeHandle(a, b, e);
};
$e1e9cfd39d0569dc$export$aaabe4eda9ed9969 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useInsertionEffect(a, b);
};
$e1e9cfd39d0569dc$export$e5c5a5f917a5871c = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useLayoutEffect(a, b);
};
$e1e9cfd39d0569dc$export$1538c33de8887b59 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useMemo(a, b);
};
$e1e9cfd39d0569dc$export$13e3392192263954 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useReducer(a, b, e);
};
$e1e9cfd39d0569dc$export$b8f5890fc79d6aca = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useRef(a);
};
$e1e9cfd39d0569dc$export$60241385465d0a34 = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useState(a);
};
$e1e9cfd39d0569dc$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useSyncExternalStore(a, b, e);
};
$e1e9cfd39d0569dc$export$7b286972b8d8ccbf = function() {
    return $e1e9cfd39d0569dc$var$U.current.useTransition();
};
$e1e9cfd39d0569dc$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("5djcY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cbd10fe5fe1c504$export$71511d61b312f219; });
function $3cbd10fe5fe1c504$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("kwI20", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $ef18f37ed0802d0c$export$882461b6382ed46c; }, function (v) { return $ef18f37ed0802d0c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ef18f37ed0802d0c$export$757ceba2d55c277e; }, function (v) { return $ef18f37ed0802d0c$export$757ceba2d55c277e = v; });
var $ef18f37ed0802d0c$export$882461b6382ed46c;
var $ef18f37ed0802d0c$export$757ceba2d55c277e;
'use strict';

var $kqzqZ = parcelRequire("kqzqZ");
var $ef18f37ed0802d0c$var$i;
$ef18f37ed0802d0c$export$882461b6382ed46c = $kqzqZ.createRoot;
$ef18f37ed0802d0c$export$757ceba2d55c277e = $kqzqZ.hydrateRoot;

});
parcelRegister("kqzqZ", function(module, exports) {
'use strict';
function $edf1b8dfeeff597d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($edf1b8dfeeff597d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$edf1b8dfeeff597d$var$checkDCE();

module.exports = (parcelRequire("gr7iX"));

});
parcelRegister("gr7iX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bf74d58b74973e6b$export$ae55be85d98224ed; }, function (v) { return $bf74d58b74973e6b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bf74d58b74973e6b$export$d39a5bbd09211389; }, function (v) { return $bf74d58b74973e6b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bf74d58b74973e6b$export$882461b6382ed46c; }, function (v) { return $bf74d58b74973e6b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bf74d58b74973e6b$export$466bfc07425424d5; }, function (v) { return $bf74d58b74973e6b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bf74d58b74973e6b$export$cd75ccfd720a3cd4; }, function (v) { return $bf74d58b74973e6b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bf74d58b74973e6b$export$fa8d919ba61d84db; }, function (v) { return $bf74d58b74973e6b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bf74d58b74973e6b$export$757ceba2d55c277e; }, function (v) { return $bf74d58b74973e6b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bf74d58b74973e6b$export$b3890eb0ae9dca99; }, function (v) { return $bf74d58b74973e6b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bf74d58b74973e6b$export$502457920280e6be; }, function (v) { return $bf74d58b74973e6b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bf74d58b74973e6b$export$c78a37762a8d58e1; }, function (v) { return $bf74d58b74973e6b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bf74d58b74973e6b$export$dc54d992c10e8a18; }, function (v) { return $bf74d58b74973e6b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bf74d58b74973e6b$export$83d89fbfd8236492; }, function (v) { return $bf74d58b74973e6b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $5djcY = parcelRequire("5djcY");
var $bf74d58b74973e6b$export$ae55be85d98224ed;
var $bf74d58b74973e6b$export$d39a5bbd09211389;
var $bf74d58b74973e6b$export$882461b6382ed46c;
var $bf74d58b74973e6b$export$466bfc07425424d5;
var $bf74d58b74973e6b$export$cd75ccfd720a3cd4;
var $bf74d58b74973e6b$export$fa8d919ba61d84db;
var $bf74d58b74973e6b$export$757ceba2d55c277e;
var $bf74d58b74973e6b$export$b3890eb0ae9dca99;
var $bf74d58b74973e6b$export$502457920280e6be;
var $bf74d58b74973e6b$export$c78a37762a8d58e1;
var $bf74d58b74973e6b$export$dc54d992c10e8a18;
var $bf74d58b74973e6b$export$83d89fbfd8236492;
'use strict';

var $iD6kw = parcelRequire("iD6kw");

var $ojHeY = parcelRequire("ojHeY");
function $bf74d58b74973e6b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bf74d58b74973e6b$var$da = new Set, $bf74d58b74973e6b$var$ea = {};
function $bf74d58b74973e6b$var$fa(a, b) {
    $bf74d58b74973e6b$var$ha(a, b);
    $bf74d58b74973e6b$var$ha(a + "Capture", b);
}
function $bf74d58b74973e6b$var$ha(a, b) {
    $bf74d58b74973e6b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bf74d58b74973e6b$var$da.add(b[a]);
}
var $bf74d58b74973e6b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bf74d58b74973e6b$var$ja = Object.prototype.hasOwnProperty, $bf74d58b74973e6b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bf74d58b74973e6b$var$la = {}, $bf74d58b74973e6b$var$ma = {};
function $bf74d58b74973e6b$var$oa(a) {
    if ($bf74d58b74973e6b$var$ja.call($bf74d58b74973e6b$var$ma, a)) return !0;
    if ($bf74d58b74973e6b$var$ja.call($bf74d58b74973e6b$var$la, a)) return !1;
    if ($bf74d58b74973e6b$var$ka.test(a)) return $bf74d58b74973e6b$var$ma[a] = !0;
    $bf74d58b74973e6b$var$la[a] = !0;
    return !1;
}
function $bf74d58b74973e6b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bf74d58b74973e6b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bf74d58b74973e6b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bf74d58b74973e6b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bf74d58b74973e6b$var$ra = /[\-:]([a-z])/g;
function $bf74d58b74973e6b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bf74d58b74973e6b$var$z.xlinkHref = new $bf74d58b74973e6b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bf74d58b74973e6b$var$ta(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$z.hasOwnProperty(b) ? $bf74d58b74973e6b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bf74d58b74973e6b$var$qa(b, c, e, d) && (c = null), d || null === e ? $bf74d58b74973e6b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bf74d58b74973e6b$var$ua = $iD6kw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bf74d58b74973e6b$var$va = Symbol.for("react.element"), $bf74d58b74973e6b$var$wa = Symbol.for("react.portal"), $bf74d58b74973e6b$var$ya = Symbol.for("react.fragment"), $bf74d58b74973e6b$var$za = Symbol.for("react.strict_mode"), $bf74d58b74973e6b$var$Aa = Symbol.for("react.profiler"), $bf74d58b74973e6b$var$Ba = Symbol.for("react.provider"), $bf74d58b74973e6b$var$Ca = Symbol.for("react.context"), $bf74d58b74973e6b$var$Da = Symbol.for("react.forward_ref"), $bf74d58b74973e6b$var$Ea = Symbol.for("react.suspense"), $bf74d58b74973e6b$var$Fa = Symbol.for("react.suspense_list"), $bf74d58b74973e6b$var$Ga = Symbol.for("react.memo"), $bf74d58b74973e6b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bf74d58b74973e6b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $bf74d58b74973e6b$var$Ja = Symbol.iterator;
function $bf74d58b74973e6b$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) return null;
    a = $bf74d58b74973e6b$var$Ja && a[$bf74d58b74973e6b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bf74d58b74973e6b$var$A = Object.assign, $bf74d58b74973e6b$var$La;
function $bf74d58b74973e6b$var$Ma(a) {
    if (void 0 === $bf74d58b74973e6b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bf74d58b74973e6b$var$La = b && b[1] || "";
    }
    return "\n" + $bf74d58b74973e6b$var$La + a;
}
var $bf74d58b74973e6b$var$Na = !1;
function $bf74d58b74973e6b$var$Oa(a, b) {
    if (!a || $bf74d58b74973e6b$var$Na) return "";
    $bf74d58b74973e6b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bf74d58b74973e6b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bf74d58b74973e6b$var$Ma(a) : "";
}
function $bf74d58b74973e6b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bf74d58b74973e6b$var$Ma(a.type);
        case 16:
            return $bf74d58b74973e6b$var$Ma("Lazy");
        case 13:
            return $bf74d58b74973e6b$var$Ma("Suspense");
        case 19:
            return $bf74d58b74973e6b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bf74d58b74973e6b$var$Oa(a.type, !1), a;
        case 11:
            return a = $bf74d58b74973e6b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bf74d58b74973e6b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bf74d58b74973e6b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bf74d58b74973e6b$var$ya:
            return "Fragment";
        case $bf74d58b74973e6b$var$wa:
            return "Portal";
        case $bf74d58b74973e6b$var$Aa:
            return "Profiler";
        case $bf74d58b74973e6b$var$za:
            return "StrictMode";
        case $bf74d58b74973e6b$var$Ea:
            return "Suspense";
        case $bf74d58b74973e6b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) switch(a.$$typeof){
        case $bf74d58b74973e6b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bf74d58b74973e6b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bf74d58b74973e6b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bf74d58b74973e6b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bf74d58b74973e6b$var$Qa(a.type) || "Memo";
        case $bf74d58b74973e6b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bf74d58b74973e6b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bf74d58b74973e6b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bf74d58b74973e6b$var$Qa(b);
        case 8:
            return b === $bf74d58b74973e6b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bf74d58b74973e6b$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bf74d58b74973e6b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bf74d58b74973e6b$var$Ua(a) {
    var b = $bf74d58b74973e6b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bf74d58b74973e6b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bf74d58b74973e6b$var$Ua(a));
}
function $bf74d58b74973e6b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bf74d58b74973e6b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bf74d58b74973e6b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bf74d58b74973e6b$var$Ya(a, b) {
    var c = b.checked;
    return $bf74d58b74973e6b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bf74d58b74973e6b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bf74d58b74973e6b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bf74d58b74973e6b$var$ab(a, b) {
    b = b.checked;
    null != b && $bf74d58b74973e6b$var$ta(a, "checked", b, !1);
}
function $bf74d58b74973e6b$var$bb(a, b) {
    $bf74d58b74973e6b$var$ab(a, b);
    var c = $bf74d58b74973e6b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bf74d58b74973e6b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bf74d58b74973e6b$var$cb(a, b.type, $bf74d58b74973e6b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bf74d58b74973e6b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bf74d58b74973e6b$var$cb(a, b, c) {
    if ("number" !== b || $bf74d58b74973e6b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bf74d58b74973e6b$var$eb = Array.isArray;
function $bf74d58b74973e6b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bf74d58b74973e6b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bf74d58b74973e6b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bf74d58b74973e6b$var$p(91));
    return $bf74d58b74973e6b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bf74d58b74973e6b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bf74d58b74973e6b$var$p(92));
            if ($bf74d58b74973e6b$var$eb(c)) {
                if (1 < c.length) throw Error($bf74d58b74973e6b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bf74d58b74973e6b$var$Sa(c)
    };
}
function $bf74d58b74973e6b$var$ib(a, b) {
    var c = $bf74d58b74973e6b$var$Sa(b.value), d = $bf74d58b74973e6b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bf74d58b74973e6b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bf74d58b74973e6b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bf74d58b74973e6b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bf74d58b74973e6b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bf74d58b74973e6b$var$mb, $bf74d58b74973e6b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bf74d58b74973e6b$var$mb = $bf74d58b74973e6b$var$mb || document.createElement("div");
        $bf74d58b74973e6b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bf74d58b74973e6b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bf74d58b74973e6b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bf74d58b74973e6b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bf74d58b74973e6b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bf74d58b74973e6b$var$pb).forEach(function(a) {
    $bf74d58b74973e6b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bf74d58b74973e6b$var$pb[b] = $bf74d58b74973e6b$var$pb[a];
    });
});
function $bf74d58b74973e6b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bf74d58b74973e6b$var$pb.hasOwnProperty(a) && $bf74d58b74973e6b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bf74d58b74973e6b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bf74d58b74973e6b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bf74d58b74973e6b$var$tb = $bf74d58b74973e6b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bf74d58b74973e6b$var$ub(a, b) {
    if (b) {
        if ($bf74d58b74973e6b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bf74d58b74973e6b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bf74d58b74973e6b$var$p(60));
            if ("object" !== (0, $5djcY._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bf74d58b74973e6b$var$p(61));
        }
        if (null != b.style && "object" !== (0, $5djcY._)(b.style)) throw Error($bf74d58b74973e6b$var$p(62));
    }
}
function $bf74d58b74973e6b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bf74d58b74973e6b$var$wb = null;
function $bf74d58b74973e6b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bf74d58b74973e6b$var$yb = null, $bf74d58b74973e6b$var$zb = null, $bf74d58b74973e6b$var$Ab = null;
function $bf74d58b74973e6b$var$Bb(a) {
    if (a = $bf74d58b74973e6b$var$Cb(a)) {
        if ("function" !== typeof $bf74d58b74973e6b$var$yb) throw Error($bf74d58b74973e6b$var$p(280));
        var b = a.stateNode;
        b && (b = $bf74d58b74973e6b$var$Db(b), $bf74d58b74973e6b$var$yb(a.stateNode, a.type, b));
    }
}
function $bf74d58b74973e6b$var$Eb(a) {
    $bf74d58b74973e6b$var$zb ? $bf74d58b74973e6b$var$Ab ? $bf74d58b74973e6b$var$Ab.push(a) : $bf74d58b74973e6b$var$Ab = [
        a
    ] : $bf74d58b74973e6b$var$zb = a;
}
function $bf74d58b74973e6b$var$Fb() {
    if ($bf74d58b74973e6b$var$zb) {
        var a = $bf74d58b74973e6b$var$zb, b = $bf74d58b74973e6b$var$Ab;
        $bf74d58b74973e6b$var$Ab = $bf74d58b74973e6b$var$zb = null;
        $bf74d58b74973e6b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bf74d58b74973e6b$var$Bb(b[a]);
    }
}
function $bf74d58b74973e6b$var$Gb(a, b) {
    return a(b);
}
function $bf74d58b74973e6b$var$Hb() {}
var $bf74d58b74973e6b$var$Ib = !1;
function $bf74d58b74973e6b$var$Jb(a, b, c) {
    if ($bf74d58b74973e6b$var$Ib) return a(b, c);
    $bf74d58b74973e6b$var$Ib = !0;
    try {
        return $bf74d58b74973e6b$var$Gb(a, b, c);
    } finally{
        if ($bf74d58b74973e6b$var$Ib = !1, null !== $bf74d58b74973e6b$var$zb || null !== $bf74d58b74973e6b$var$Ab) $bf74d58b74973e6b$var$Hb(), $bf74d58b74973e6b$var$Fb();
    }
}
function $bf74d58b74973e6b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bf74d58b74973e6b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bf74d58b74973e6b$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)));
    return c;
}
var $bf74d58b74973e6b$var$Lb = !1;
if ($bf74d58b74973e6b$var$ia) try {
    var $bf74d58b74973e6b$var$Mb = {};
    Object.defineProperty($bf74d58b74973e6b$var$Mb, "passive", {
        get: function get() {
            $bf74d58b74973e6b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bf74d58b74973e6b$var$Mb, $bf74d58b74973e6b$var$Mb);
    window.removeEventListener("test", $bf74d58b74973e6b$var$Mb, $bf74d58b74973e6b$var$Mb);
} catch (a) {
    $bf74d58b74973e6b$var$Lb = !1;
}
function $bf74d58b74973e6b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bf74d58b74973e6b$var$Ob = !1, $bf74d58b74973e6b$var$Pb = null, $bf74d58b74973e6b$var$Qb = !1, $bf74d58b74973e6b$var$Rb = null, $bf74d58b74973e6b$var$Sb = {
    onError: function onError(a) {
        $bf74d58b74973e6b$var$Ob = !0;
        $bf74d58b74973e6b$var$Pb = a;
    }
};
function $bf74d58b74973e6b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bf74d58b74973e6b$var$Ob = !1;
    $bf74d58b74973e6b$var$Pb = null;
    $bf74d58b74973e6b$var$Nb.apply($bf74d58b74973e6b$var$Sb, arguments);
}
function $bf74d58b74973e6b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bf74d58b74973e6b$var$Tb.apply(this, arguments);
    if ($bf74d58b74973e6b$var$Ob) {
        if ($bf74d58b74973e6b$var$Ob) {
            var l = $bf74d58b74973e6b$var$Pb;
            $bf74d58b74973e6b$var$Ob = !1;
            $bf74d58b74973e6b$var$Pb = null;
        } else throw Error($bf74d58b74973e6b$var$p(198));
        $bf74d58b74973e6b$var$Qb || ($bf74d58b74973e6b$var$Qb = !0, $bf74d58b74973e6b$var$Rb = l);
    }
}
function $bf74d58b74973e6b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bf74d58b74973e6b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bf74d58b74973e6b$var$Xb(a) {
    if ($bf74d58b74973e6b$var$Vb(a) !== a) throw Error($bf74d58b74973e6b$var$p(188));
}
function $bf74d58b74973e6b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bf74d58b74973e6b$var$Vb(a);
        if (null === b) throw Error($bf74d58b74973e6b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bf74d58b74973e6b$var$Xb(e), a;
                if (f === d) return $bf74d58b74973e6b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bf74d58b74973e6b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bf74d58b74973e6b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bf74d58b74973e6b$var$p(190));
    }
    if (3 !== c.tag) throw Error($bf74d58b74973e6b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bf74d58b74973e6b$var$Zb(a) {
    a = $bf74d58b74973e6b$var$Yb(a);
    return null !== a ? $bf74d58b74973e6b$var$$b(a) : null;
}
function $bf74d58b74973e6b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bf74d58b74973e6b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$ac = $ojHeY.unstable_scheduleCallback, $bf74d58b74973e6b$var$bc = $ojHeY.unstable_cancelCallback, $bf74d58b74973e6b$var$cc = $ojHeY.unstable_shouldYield, $bf74d58b74973e6b$var$dc = $ojHeY.unstable_requestPaint, $bf74d58b74973e6b$var$B = $ojHeY.unstable_now, $bf74d58b74973e6b$var$ec = $ojHeY.unstable_getCurrentPriorityLevel, $bf74d58b74973e6b$var$fc = $ojHeY.unstable_ImmediatePriority, $bf74d58b74973e6b$var$gc = $ojHeY.unstable_UserBlockingPriority, $bf74d58b74973e6b$var$hc = $ojHeY.unstable_NormalPriority, $bf74d58b74973e6b$var$ic = $ojHeY.unstable_LowPriority, $bf74d58b74973e6b$var$jc = $ojHeY.unstable_IdlePriority, $bf74d58b74973e6b$var$kc = null, $bf74d58b74973e6b$var$lc = null;
function $bf74d58b74973e6b$var$mc(a) {
    if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onCommitFiberRoot) try {
        $bf74d58b74973e6b$var$lc.onCommitFiberRoot($bf74d58b74973e6b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bf74d58b74973e6b$var$oc = Math.clz32 ? Math.clz32 : $bf74d58b74973e6b$var$nc, $bf74d58b74973e6b$var$pc = Math.log, $bf74d58b74973e6b$var$qc = Math.LN2;
function $bf74d58b74973e6b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bf74d58b74973e6b$var$pc(a) / $bf74d58b74973e6b$var$qc | 0) | 0;
}
var $bf74d58b74973e6b$var$rc = 64, $bf74d58b74973e6b$var$sc = 4194304;
function $bf74d58b74973e6b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bf74d58b74973e6b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bf74d58b74973e6b$var$tc(h) : (f &= g, 0 !== f && (d = $bf74d58b74973e6b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bf74d58b74973e6b$var$tc(g) : 0 !== f && (d = $bf74d58b74973e6b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bf74d58b74973e6b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bf74d58b74973e6b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bf74d58b74973e6b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bf74d58b74973e6b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bf74d58b74973e6b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bf74d58b74973e6b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bf74d58b74973e6b$var$yc() {
    var a = $bf74d58b74973e6b$var$rc;
    $bf74d58b74973e6b$var$rc <<= 1;
    0 === ($bf74d58b74973e6b$var$rc & 4194240) && ($bf74d58b74973e6b$var$rc = 64);
    return a;
}
function $bf74d58b74973e6b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bf74d58b74973e6b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bf74d58b74973e6b$var$oc(b);
    a[b] = c;
}
function $bf74d58b74973e6b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bf74d58b74973e6b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bf74d58b74973e6b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bf74d58b74973e6b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bf74d58b74973e6b$var$C = 0;
function $bf74d58b74973e6b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bf74d58b74973e6b$var$Ec, $bf74d58b74973e6b$var$Fc, $bf74d58b74973e6b$var$Gc, $bf74d58b74973e6b$var$Hc, $bf74d58b74973e6b$var$Ic, $bf74d58b74973e6b$var$Jc = !1, $bf74d58b74973e6b$var$Kc = [], $bf74d58b74973e6b$var$Lc = null, $bf74d58b74973e6b$var$Mc = null, $bf74d58b74973e6b$var$Nc = null, $bf74d58b74973e6b$var$Oc = new Map, $bf74d58b74973e6b$var$Pc = new Map, $bf74d58b74973e6b$var$Qc = [], $bf74d58b74973e6b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bf74d58b74973e6b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bf74d58b74973e6b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bf74d58b74973e6b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bf74d58b74973e6b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bf74d58b74973e6b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bf74d58b74973e6b$var$Pc.delete(b.pointerId);
    }
}
function $bf74d58b74973e6b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bf74d58b74973e6b$var$Cb(b), null !== b && $bf74d58b74973e6b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bf74d58b74973e6b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bf74d58b74973e6b$var$Lc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bf74d58b74973e6b$var$Mc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bf74d58b74973e6b$var$Nc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bf74d58b74973e6b$var$Oc.set(f, $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bf74d58b74973e6b$var$Pc.set(f, $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bf74d58b74973e6b$var$Vc(a) {
    var b = $bf74d58b74973e6b$var$Wc(a.target);
    if (null !== b) {
        var c = $bf74d58b74973e6b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bf74d58b74973e6b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bf74d58b74973e6b$var$Ic(a.priority, function() {
                        $bf74d58b74973e6b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bf74d58b74973e6b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bf74d58b74973e6b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bf74d58b74973e6b$var$wb = d;
            c.target.dispatchEvent(d);
            $bf74d58b74973e6b$var$wb = null;
        } else return b = $bf74d58b74973e6b$var$Cb(c), null !== b && $bf74d58b74973e6b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bf74d58b74973e6b$var$Zc(a, b, c) {
    $bf74d58b74973e6b$var$Xc(a) && c.delete(b);
}
function $bf74d58b74973e6b$var$$c() {
    $bf74d58b74973e6b$var$Jc = !1;
    null !== $bf74d58b74973e6b$var$Lc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Lc) && ($bf74d58b74973e6b$var$Lc = null);
    null !== $bf74d58b74973e6b$var$Mc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Mc) && ($bf74d58b74973e6b$var$Mc = null);
    null !== $bf74d58b74973e6b$var$Nc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Nc) && ($bf74d58b74973e6b$var$Nc = null);
    $bf74d58b74973e6b$var$Oc.forEach($bf74d58b74973e6b$var$Zc);
    $bf74d58b74973e6b$var$Pc.forEach($bf74d58b74973e6b$var$Zc);
}
function $bf74d58b74973e6b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bf74d58b74973e6b$var$Jc || ($bf74d58b74973e6b$var$Jc = !0, $ojHeY.unstable_scheduleCallback($ojHeY.unstable_NormalPriority, $bf74d58b74973e6b$var$$c)));
}
function $bf74d58b74973e6b$var$bd(a) {
    function b(b) {
        return $bf74d58b74973e6b$var$ad(b, a);
    }
    if (0 < $bf74d58b74973e6b$var$Kc.length) {
        $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Kc[0], a);
        for(var c = 1; c < $bf74d58b74973e6b$var$Kc.length; c++){
            var d = $bf74d58b74973e6b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bf74d58b74973e6b$var$Lc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Lc, a);
    null !== $bf74d58b74973e6b$var$Mc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Mc, a);
    null !== $bf74d58b74973e6b$var$Nc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Nc, a);
    $bf74d58b74973e6b$var$Oc.forEach(b);
    $bf74d58b74973e6b$var$Pc.forEach(b);
    for(c = 0; c < $bf74d58b74973e6b$var$Qc.length; c++)d = $bf74d58b74973e6b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bf74d58b74973e6b$var$Qc.length && (c = $bf74d58b74973e6b$var$Qc[0], null === c.blockedOn);)$bf74d58b74973e6b$var$Vc(c), null === c.blockedOn && $bf74d58b74973e6b$var$Qc.shift();
}
var $bf74d58b74973e6b$var$cd = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$dd = !0;
function $bf74d58b74973e6b$var$ed(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$C, f = $bf74d58b74973e6b$var$cd.transition;
    $bf74d58b74973e6b$var$cd.transition = null;
    try {
        $bf74d58b74973e6b$var$C = 1, $bf74d58b74973e6b$var$fd(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$C = e, $bf74d58b74973e6b$var$cd.transition = f;
    }
}
function $bf74d58b74973e6b$var$gd(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$C, f = $bf74d58b74973e6b$var$cd.transition;
    $bf74d58b74973e6b$var$cd.transition = null;
    try {
        $bf74d58b74973e6b$var$C = 4, $bf74d58b74973e6b$var$fd(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$C = e, $bf74d58b74973e6b$var$cd.transition = f;
    }
}
function $bf74d58b74973e6b$var$fd(a, b, c, d) {
    if ($bf74d58b74973e6b$var$dd) {
        var e = $bf74d58b74973e6b$var$Yc(a, b, c, d);
        if (null === e) $bf74d58b74973e6b$var$hd(a, b, d, $bf74d58b74973e6b$var$id, c), $bf74d58b74973e6b$var$Sc(a, d);
        else if ($bf74d58b74973e6b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bf74d58b74973e6b$var$Sc(a, d), b & 4 && -1 < $bf74d58b74973e6b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bf74d58b74973e6b$var$Cb(e);
                null !== f && $bf74d58b74973e6b$var$Ec(f);
                f = $bf74d58b74973e6b$var$Yc(a, b, c, d);
                null === f && $bf74d58b74973e6b$var$hd(a, b, d, $bf74d58b74973e6b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bf74d58b74973e6b$var$hd(a, b, d, null, c);
    }
}
var $bf74d58b74973e6b$var$id = null;
function $bf74d58b74973e6b$var$Yc(a, b, c, d) {
    $bf74d58b74973e6b$var$id = null;
    a = $bf74d58b74973e6b$var$xb(d);
    a = $bf74d58b74973e6b$var$Wc(a);
    if (null !== a) {
        if (b = $bf74d58b74973e6b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bf74d58b74973e6b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bf74d58b74973e6b$var$id = a;
    return null;
}
function $bf74d58b74973e6b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bf74d58b74973e6b$var$ec()){
                case $bf74d58b74973e6b$var$fc:
                    return 1;
                case $bf74d58b74973e6b$var$gc:
                    return 4;
                case $bf74d58b74973e6b$var$hc:
                case $bf74d58b74973e6b$var$ic:
                    return 16;
                case $bf74d58b74973e6b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bf74d58b74973e6b$var$kd = null, $bf74d58b74973e6b$var$ld = null, $bf74d58b74973e6b$var$md = null;
function $bf74d58b74973e6b$var$nd() {
    if ($bf74d58b74973e6b$var$md) return $bf74d58b74973e6b$var$md;
    var a, b = $bf74d58b74973e6b$var$ld, c = b.length, d, e = "value" in $bf74d58b74973e6b$var$kd ? $bf74d58b74973e6b$var$kd.value : $bf74d58b74973e6b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bf74d58b74973e6b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bf74d58b74973e6b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bf74d58b74973e6b$var$pd() {
    return !0;
}
function $bf74d58b74973e6b$var$qd() {
    return !1;
}
function $bf74d58b74973e6b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bf74d58b74973e6b$var$pd : $bf74d58b74973e6b$var$qd;
        this.isPropagationStopped = $bf74d58b74973e6b$var$qd;
        return this;
    }
    $bf74d58b74973e6b$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $5djcY._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $bf74d58b74973e6b$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $5djcY._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $bf74d58b74973e6b$var$pd);
        },
        persist: function persist() {},
        isPersistent: $bf74d58b74973e6b$var$pd
    });
    return b;
}
var $bf74d58b74973e6b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bf74d58b74973e6b$var$td = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$sd), $bf74d58b74973e6b$var$ud = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    view: 0,
    detail: 0
}), $bf74d58b74973e6b$var$vd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$ud), $bf74d58b74973e6b$var$wd, $bf74d58b74973e6b$var$xd, $bf74d58b74973e6b$var$yd, $bf74d58b74973e6b$var$Ad = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bf74d58b74973e6b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bf74d58b74973e6b$var$yd && ($bf74d58b74973e6b$var$yd && "mousemove" === a.type ? ($bf74d58b74973e6b$var$wd = a.screenX - $bf74d58b74973e6b$var$yd.screenX, $bf74d58b74973e6b$var$xd = a.screenY - $bf74d58b74973e6b$var$yd.screenY) : $bf74d58b74973e6b$var$xd = $bf74d58b74973e6b$var$wd = 0, $bf74d58b74973e6b$var$yd = a);
        return $bf74d58b74973e6b$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $bf74d58b74973e6b$var$xd;
    }
}), $bf74d58b74973e6b$var$Bd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ad), $bf74d58b74973e6b$var$Cd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    dataTransfer: 0
}), $bf74d58b74973e6b$var$Dd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Cd), $bf74d58b74973e6b$var$Ed = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    relatedTarget: 0
}), $bf74d58b74973e6b$var$Fd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ed), $bf74d58b74973e6b$var$Gd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bf74d58b74973e6b$var$Hd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Gd), $bf74d58b74973e6b$var$Id = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bf74d58b74973e6b$var$Jd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Id), $bf74d58b74973e6b$var$Kd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    data: 0
}), $bf74d58b74973e6b$var$Ld = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Kd), $bf74d58b74973e6b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bf74d58b74973e6b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bf74d58b74973e6b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bf74d58b74973e6b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bf74d58b74973e6b$var$Od[a]) ? !!b[a] : !1;
}
function $bf74d58b74973e6b$var$zd() {
    return $bf74d58b74973e6b$var$Pd;
}
var $bf74d58b74973e6b$var$Qd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $bf74d58b74973e6b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bf74d58b74973e6b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bf74d58b74973e6b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bf74d58b74973e6b$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $bf74d58b74973e6b$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $bf74d58b74973e6b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bf74d58b74973e6b$var$Rd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Qd), $bf74d58b74973e6b$var$Sd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bf74d58b74973e6b$var$Td = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Sd), $bf74d58b74973e6b$var$Ud = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bf74d58b74973e6b$var$zd
}), $bf74d58b74973e6b$var$Vd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ud), $bf74d58b74973e6b$var$Wd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bf74d58b74973e6b$var$Xd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Wd), $bf74d58b74973e6b$var$Yd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bf74d58b74973e6b$var$Zd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Yd), $bf74d58b74973e6b$var$$d = [
    9,
    13,
    27,
    32
], $bf74d58b74973e6b$var$ae = $bf74d58b74973e6b$var$ia && "CompositionEvent" in window, $bf74d58b74973e6b$var$be = null;
$bf74d58b74973e6b$var$ia && "documentMode" in document && ($bf74d58b74973e6b$var$be = document.documentMode);
var $bf74d58b74973e6b$var$ce = $bf74d58b74973e6b$var$ia && "TextEvent" in window && !$bf74d58b74973e6b$var$be, $bf74d58b74973e6b$var$de = $bf74d58b74973e6b$var$ia && (!$bf74d58b74973e6b$var$ae || $bf74d58b74973e6b$var$be && 8 < $bf74d58b74973e6b$var$be && 11 >= $bf74d58b74973e6b$var$be), $bf74d58b74973e6b$var$ee = String.fromCharCode(32), $bf74d58b74973e6b$var$fe = !1;
function $bf74d58b74973e6b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bf74d58b74973e6b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && "data" in a ? a.data : null;
}
var $bf74d58b74973e6b$var$ie = !1;
function $bf74d58b74973e6b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bf74d58b74973e6b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bf74d58b74973e6b$var$fe = !0;
            return $bf74d58b74973e6b$var$ee;
        case "textInput":
            return a = b.data, a === $bf74d58b74973e6b$var$ee && $bf74d58b74973e6b$var$fe ? null : a;
        default:
            return null;
    }
}
function $bf74d58b74973e6b$var$ke(a, b) {
    if ($bf74d58b74973e6b$var$ie) return "compositionend" === a || !$bf74d58b74973e6b$var$ae && $bf74d58b74973e6b$var$ge(a, b) ? (a = $bf74d58b74973e6b$var$nd(), $bf74d58b74973e6b$var$md = $bf74d58b74973e6b$var$ld = $bf74d58b74973e6b$var$kd = null, $bf74d58b74973e6b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bf74d58b74973e6b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bf74d58b74973e6b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bf74d58b74973e6b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bf74d58b74973e6b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bf74d58b74973e6b$var$ne(a, b, c, d) {
    $bf74d58b74973e6b$var$Eb(d);
    b = $bf74d58b74973e6b$var$oe(b, "onChange");
    0 < b.length && (c = new $bf74d58b74973e6b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bf74d58b74973e6b$var$pe = null, $bf74d58b74973e6b$var$qe = null;
function $bf74d58b74973e6b$var$re(a) {
    $bf74d58b74973e6b$var$se(a, 0);
}
function $bf74d58b74973e6b$var$te(a) {
    var b = $bf74d58b74973e6b$var$ue(a);
    if ($bf74d58b74973e6b$var$Wa(b)) return a;
}
function $bf74d58b74973e6b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bf74d58b74973e6b$var$we = !1;
if ($bf74d58b74973e6b$var$ia) {
    var $bf74d58b74973e6b$var$xe;
    if ($bf74d58b74973e6b$var$ia) {
        var $bf74d58b74973e6b$var$ye = "oninput" in document;
        if (!$bf74d58b74973e6b$var$ye) {
            var $bf74d58b74973e6b$var$ze = document.createElement("div");
            $bf74d58b74973e6b$var$ze.setAttribute("oninput", "return;");
            $bf74d58b74973e6b$var$ye = "function" === typeof $bf74d58b74973e6b$var$ze.oninput;
        }
        $bf74d58b74973e6b$var$xe = $bf74d58b74973e6b$var$ye;
    } else $bf74d58b74973e6b$var$xe = !1;
    $bf74d58b74973e6b$var$we = $bf74d58b74973e6b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bf74d58b74973e6b$var$Ae() {
    $bf74d58b74973e6b$var$pe && ($bf74d58b74973e6b$var$pe.detachEvent("onpropertychange", $bf74d58b74973e6b$var$Be), $bf74d58b74973e6b$var$qe = $bf74d58b74973e6b$var$pe = null);
}
function $bf74d58b74973e6b$var$Be(a) {
    if ("value" === a.propertyName && $bf74d58b74973e6b$var$te($bf74d58b74973e6b$var$qe)) {
        var b = [];
        $bf74d58b74973e6b$var$ne(b, $bf74d58b74973e6b$var$qe, a, $bf74d58b74973e6b$var$xb(a));
        $bf74d58b74973e6b$var$Jb($bf74d58b74973e6b$var$re, b);
    }
}
function $bf74d58b74973e6b$var$Ce(a, b, c) {
    "focusin" === a ? ($bf74d58b74973e6b$var$Ae(), $bf74d58b74973e6b$var$pe = b, $bf74d58b74973e6b$var$qe = c, $bf74d58b74973e6b$var$pe.attachEvent("onpropertychange", $bf74d58b74973e6b$var$Be)) : "focusout" === a && $bf74d58b74973e6b$var$Ae();
}
function $bf74d58b74973e6b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bf74d58b74973e6b$var$te($bf74d58b74973e6b$var$qe);
}
function $bf74d58b74973e6b$var$Ee(a, b) {
    if ("click" === a) return $bf74d58b74973e6b$var$te(b);
}
function $bf74d58b74973e6b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bf74d58b74973e6b$var$te(b);
}
function $bf74d58b74973e6b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bf74d58b74973e6b$var$He = "function" === typeof Object.is ? Object.is : $bf74d58b74973e6b$var$Ge;
function $bf74d58b74973e6b$var$Ie(a, b) {
    if ($bf74d58b74973e6b$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bf74d58b74973e6b$var$ja.call(b, e) || !$bf74d58b74973e6b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bf74d58b74973e6b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bf74d58b74973e6b$var$Ke(a, b) {
    var c = $bf74d58b74973e6b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bf74d58b74973e6b$var$Je(c);
    }
}
function $bf74d58b74973e6b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bf74d58b74973e6b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bf74d58b74973e6b$var$Me() {
    for(var a = window, b = $bf74d58b74973e6b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bf74d58b74973e6b$var$Xa(a.document);
    }
    return b;
}
function $bf74d58b74973e6b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bf74d58b74973e6b$var$Oe(a) {
    var b = $bf74d58b74973e6b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bf74d58b74973e6b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bf74d58b74973e6b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bf74d58b74973e6b$var$Ke(c, f);
                var g = $bf74d58b74973e6b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bf74d58b74973e6b$var$Pe = $bf74d58b74973e6b$var$ia && "documentMode" in document && 11 >= document.documentMode, $bf74d58b74973e6b$var$Qe = null, $bf74d58b74973e6b$var$Re = null, $bf74d58b74973e6b$var$Se = null, $bf74d58b74973e6b$var$Te = !1;
function $bf74d58b74973e6b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bf74d58b74973e6b$var$Te || null == $bf74d58b74973e6b$var$Qe || $bf74d58b74973e6b$var$Qe !== $bf74d58b74973e6b$var$Xa(d) || (d = $bf74d58b74973e6b$var$Qe, "selectionStart" in d && $bf74d58b74973e6b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bf74d58b74973e6b$var$Se && $bf74d58b74973e6b$var$Ie($bf74d58b74973e6b$var$Se, d) || ($bf74d58b74973e6b$var$Se = d, d = $bf74d58b74973e6b$var$oe($bf74d58b74973e6b$var$Re, "onSelect"), 0 < d.length && (b = new $bf74d58b74973e6b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bf74d58b74973e6b$var$Qe)));
}
function $bf74d58b74973e6b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bf74d58b74973e6b$var$We = {
    animationend: $bf74d58b74973e6b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bf74d58b74973e6b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bf74d58b74973e6b$var$Ve("Animation", "AnimationStart"),
    transitionend: $bf74d58b74973e6b$var$Ve("Transition", "TransitionEnd")
}, $bf74d58b74973e6b$var$Xe = {}, $bf74d58b74973e6b$var$Ye = {};
$bf74d58b74973e6b$var$ia && ($bf74d58b74973e6b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bf74d58b74973e6b$var$We.animationend.animation, delete $bf74d58b74973e6b$var$We.animationiteration.animation, delete $bf74d58b74973e6b$var$We.animationstart.animation), "TransitionEvent" in window || delete $bf74d58b74973e6b$var$We.transitionend.transition);
function $bf74d58b74973e6b$var$Ze(a) {
    if ($bf74d58b74973e6b$var$Xe[a]) return $bf74d58b74973e6b$var$Xe[a];
    if (!$bf74d58b74973e6b$var$We[a]) return a;
    var b = $bf74d58b74973e6b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bf74d58b74973e6b$var$Ye) return $bf74d58b74973e6b$var$Xe[a] = b[c];
    return a;
}
var $bf74d58b74973e6b$var$$e = $bf74d58b74973e6b$var$Ze("animationend"), $bf74d58b74973e6b$var$af = $bf74d58b74973e6b$var$Ze("animationiteration"), $bf74d58b74973e6b$var$bf = $bf74d58b74973e6b$var$Ze("animationstart"), $bf74d58b74973e6b$var$cf = $bf74d58b74973e6b$var$Ze("transitionend"), $bf74d58b74973e6b$var$df = new Map, $bf74d58b74973e6b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bf74d58b74973e6b$var$ff(a, b) {
    $bf74d58b74973e6b$var$df.set(a, b);
    $bf74d58b74973e6b$var$fa(b, [
        a
    ]);
}
for(var $bf74d58b74973e6b$var$gf = 0; $bf74d58b74973e6b$var$gf < $bf74d58b74973e6b$var$ef.length; $bf74d58b74973e6b$var$gf++){
    var $bf74d58b74973e6b$var$hf = $bf74d58b74973e6b$var$ef[$bf74d58b74973e6b$var$gf], $bf74d58b74973e6b$var$jf = $bf74d58b74973e6b$var$hf.toLowerCase(), $bf74d58b74973e6b$var$kf = $bf74d58b74973e6b$var$hf[0].toUpperCase() + $bf74d58b74973e6b$var$hf.slice(1);
    $bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$jf, "on" + $bf74d58b74973e6b$var$kf);
}
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$$e, "onAnimationEnd");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$af, "onAnimationIteration");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$bf, "onAnimationStart");
$bf74d58b74973e6b$var$ff("dblclick", "onDoubleClick");
$bf74d58b74973e6b$var$ff("focusin", "onFocus");
$bf74d58b74973e6b$var$ff("focusout", "onBlur");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$cf, "onTransitionEnd");
$bf74d58b74973e6b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bf74d58b74973e6b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bf74d58b74973e6b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bf74d58b74973e6b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bf74d58b74973e6b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bf74d58b74973e6b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bf74d58b74973e6b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bf74d58b74973e6b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bf74d58b74973e6b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bf74d58b74973e6b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bf74d58b74973e6b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bf74d58b74973e6b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bf74d58b74973e6b$var$lf));
function $bf74d58b74973e6b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bf74d58b74973e6b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bf74d58b74973e6b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bf74d58b74973e6b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bf74d58b74973e6b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bf74d58b74973e6b$var$Qb) throw a = $bf74d58b74973e6b$var$Rb, $bf74d58b74973e6b$var$Qb = !1, $bf74d58b74973e6b$var$Rb = null, a;
}
function $bf74d58b74973e6b$var$D(a, b) {
    var c = b[$bf74d58b74973e6b$var$of];
    void 0 === c && (c = b[$bf74d58b74973e6b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bf74d58b74973e6b$var$pf(b, a, 2, !1), c.add(d));
}
function $bf74d58b74973e6b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bf74d58b74973e6b$var$pf(c, a, d, b);
}
var $bf74d58b74973e6b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bf74d58b74973e6b$var$sf(a) {
    if (!a[$bf74d58b74973e6b$var$rf]) {
        a[$bf74d58b74973e6b$var$rf] = !0;
        $bf74d58b74973e6b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bf74d58b74973e6b$var$mf.has(b) || $bf74d58b74973e6b$var$qf(b, !1, a), $bf74d58b74973e6b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bf74d58b74973e6b$var$rf] || (b[$bf74d58b74973e6b$var$rf] = !0, $bf74d58b74973e6b$var$qf("selectionchange", !1, b));
    }
}
function $bf74d58b74973e6b$var$pf(a, b, c, d) {
    switch($bf74d58b74973e6b$var$jd(b)){
        case 1:
            var e = $bf74d58b74973e6b$var$ed;
            break;
        case 4:
            e = $bf74d58b74973e6b$var$gd;
            break;
        default:
            e = $bf74d58b74973e6b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bf74d58b74973e6b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bf74d58b74973e6b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $bf74d58b74973e6b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $bf74d58b74973e6b$var$Jb(function() {
        var _$d = f, _$e = $bf74d58b74973e6b$var$xb(c), g = [];
        a: {
            var h = $bf74d58b74973e6b$var$df.get(a);
            if (void 0 !== h) {
                var k = $bf74d58b74973e6b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bf74d58b74973e6b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bf74d58b74973e6b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bf74d58b74973e6b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bf74d58b74973e6b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bf74d58b74973e6b$var$Vd;
                        break;
                    case $bf74d58b74973e6b$var$$e:
                    case $bf74d58b74973e6b$var$af:
                    case $bf74d58b74973e6b$var$bf:
                        k = $bf74d58b74973e6b$var$Hd;
                        break;
                    case $bf74d58b74973e6b$var$cf:
                        k = $bf74d58b74973e6b$var$Xd;
                        break;
                    case "scroll":
                        k = $bf74d58b74973e6b$var$vd;
                        break;
                    case "wheel":
                        k = $bf74d58b74973e6b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bf74d58b74973e6b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bf74d58b74973e6b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bf74d58b74973e6b$var$Kb(w, x), null != F && t.push($bf74d58b74973e6b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bf74d58b74973e6b$var$wb && (n = c.relatedTarget || c.fromElement) && ($bf74d58b74973e6b$var$Wc(n) || n[$bf74d58b74973e6b$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $bf74d58b74973e6b$var$Wc(n) : null, null !== n && (J = $bf74d58b74973e6b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $bf74d58b74973e6b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bf74d58b74973e6b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bf74d58b74973e6b$var$ue(k);
                        u = null == n ? h : $bf74d58b74973e6b$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bf74d58b74973e6b$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bf74d58b74973e6b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bf74d58b74973e6b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bf74d58b74973e6b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bf74d58b74973e6b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bf74d58b74973e6b$var$vf(t);
                                x = $bf74d58b74973e6b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bf74d58b74973e6b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bf74d58b74973e6b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $bf74d58b74973e6b$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bf74d58b74973e6b$var$ve;
                else if ($bf74d58b74973e6b$var$me(h)) {
                    if ($bf74d58b74973e6b$var$we) na = $bf74d58b74973e6b$var$Fe;
                    else {
                        na = $bf74d58b74973e6b$var$De;
                        var xa = $bf74d58b74973e6b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bf74d58b74973e6b$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $bf74d58b74973e6b$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bf74d58b74973e6b$var$cb(h, "number", h.value);
            }
            xa = _$d ? $bf74d58b74973e6b$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($bf74d58b74973e6b$var$me(xa) || "true" === xa.contentEditable) $bf74d58b74973e6b$var$Qe = xa, $bf74d58b74973e6b$var$Re = _$d, $bf74d58b74973e6b$var$Se = null;
                    break;
                case "focusout":
                    $bf74d58b74973e6b$var$Se = $bf74d58b74973e6b$var$Re = $bf74d58b74973e6b$var$Qe = null;
                    break;
                case "mousedown":
                    $bf74d58b74973e6b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bf74d58b74973e6b$var$Te = !1;
                    $bf74d58b74973e6b$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($bf74d58b74973e6b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bf74d58b74973e6b$var$Ue(g, c, _$e);
            }
            var $a;
            if ($bf74d58b74973e6b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bf74d58b74973e6b$var$ie ? $bf74d58b74973e6b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bf74d58b74973e6b$var$de && "ko" !== c.locale && ($bf74d58b74973e6b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bf74d58b74973e6b$var$ie && ($a = $bf74d58b74973e6b$var$nd()) : ($bf74d58b74973e6b$var$kd = _$e, $bf74d58b74973e6b$var$ld = "value" in $bf74d58b74973e6b$var$kd ? $bf74d58b74973e6b$var$kd.value : $bf74d58b74973e6b$var$kd.textContent, $bf74d58b74973e6b$var$ie = !0)), xa = $bf74d58b74973e6b$var$oe(_$d, ba), 0 < xa.length && (ba = new $bf74d58b74973e6b$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bf74d58b74973e6b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bf74d58b74973e6b$var$ce ? $bf74d58b74973e6b$var$je(a, c) : $bf74d58b74973e6b$var$ke(a, c)) _$d = $bf74d58b74973e6b$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $bf74d58b74973e6b$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $bf74d58b74973e6b$var$se(g, b);
    });
}
function $bf74d58b74973e6b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bf74d58b74973e6b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bf74d58b74973e6b$var$Kb(a, c), null != f && d.unshift($bf74d58b74973e6b$var$tf(a, f, e)), f = $bf74d58b74973e6b$var$Kb(a, b), null != f && d.push($bf74d58b74973e6b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $bf74d58b74973e6b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bf74d58b74973e6b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bf74d58b74973e6b$var$Kb(c, f), null != k && g.unshift($bf74d58b74973e6b$var$tf(c, k, h))) : e || (k = $bf74d58b74973e6b$var$Kb(c, f), null != k && g.push($bf74d58b74973e6b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bf74d58b74973e6b$var$xf = /\r\n?/g, $bf74d58b74973e6b$var$yf = /\u0000|\uFFFD/g;
function $bf74d58b74973e6b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bf74d58b74973e6b$var$xf, "\n").replace($bf74d58b74973e6b$var$yf, "");
}
function $bf74d58b74973e6b$var$Af(a, b, c) {
    b = $bf74d58b74973e6b$var$zf(b);
    if ($bf74d58b74973e6b$var$zf(a) !== b && c) throw Error($bf74d58b74973e6b$var$p(425));
}
function $bf74d58b74973e6b$var$Bf() {}
var $bf74d58b74973e6b$var$Cf = null, $bf74d58b74973e6b$var$Df = null;
function $bf74d58b74973e6b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $5djcY._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bf74d58b74973e6b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bf74d58b74973e6b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bf74d58b74973e6b$var$Hf = "function" === typeof Promise ? Promise : void 0, $bf74d58b74973e6b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bf74d58b74973e6b$var$Hf ? function Jf(a) {
    return $bf74d58b74973e6b$var$Hf.resolve(null).then(a).catch($bf74d58b74973e6b$var$If);
} : $bf74d58b74973e6b$var$Ff;
function $bf74d58b74973e6b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bf74d58b74973e6b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bf74d58b74973e6b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bf74d58b74973e6b$var$bd(b);
}
function $bf74d58b74973e6b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bf74d58b74973e6b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$Nf = Math.random().toString(36).slice(2), $bf74d58b74973e6b$var$Of = "__reactFiber$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Pf = "__reactProps$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$uf = "__reactContainer$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$of = "__reactEvents$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Qf = "__reactListeners$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Rf = "__reactHandles$" + $bf74d58b74973e6b$var$Nf;
function $bf74d58b74973e6b$var$Wc(a) {
    var b = a[$bf74d58b74973e6b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bf74d58b74973e6b$var$uf] || c[$bf74d58b74973e6b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bf74d58b74973e6b$var$Mf(a); null !== a;){
                if (c = a[$bf74d58b74973e6b$var$Of]) return c;
                a = $bf74d58b74973e6b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bf74d58b74973e6b$var$Cb(a) {
    a = a[$bf74d58b74973e6b$var$Of] || a[$bf74d58b74973e6b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bf74d58b74973e6b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bf74d58b74973e6b$var$p(33));
}
function $bf74d58b74973e6b$var$Db(a) {
    return a[$bf74d58b74973e6b$var$Pf] || null;
}
var $bf74d58b74973e6b$var$Sf = [], $bf74d58b74973e6b$var$Tf = -1;
function $bf74d58b74973e6b$var$Uf(a) {
    return {
        current: a
    };
}
function $bf74d58b74973e6b$var$E(a) {
    0 > $bf74d58b74973e6b$var$Tf || (a.current = $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf], $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf] = null, $bf74d58b74973e6b$var$Tf--);
}
function $bf74d58b74973e6b$var$G(a, b) {
    $bf74d58b74973e6b$var$Tf++;
    $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf] = a.current;
    a.current = b;
}
var $bf74d58b74973e6b$var$Vf = {}, $bf74d58b74973e6b$var$H = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$Vf), $bf74d58b74973e6b$var$Wf = $bf74d58b74973e6b$var$Uf(!1), $bf74d58b74973e6b$var$Xf = $bf74d58b74973e6b$var$Vf;
function $bf74d58b74973e6b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bf74d58b74973e6b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bf74d58b74973e6b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bf74d58b74973e6b$var$$f() {
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
}
function $bf74d58b74973e6b$var$ag(a, b, c) {
    if ($bf74d58b74973e6b$var$H.current !== $bf74d58b74973e6b$var$Vf) throw Error($bf74d58b74973e6b$var$p(168));
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, b);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, c);
}
function $bf74d58b74973e6b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bf74d58b74973e6b$var$p(108, $bf74d58b74973e6b$var$Ra(a) || "Unknown", e));
    return $bf74d58b74973e6b$var$A({}, c, d);
}
function $bf74d58b74973e6b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bf74d58b74973e6b$var$Vf;
    $bf74d58b74973e6b$var$Xf = $bf74d58b74973e6b$var$H.current;
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, a);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, $bf74d58b74973e6b$var$Wf.current);
    return !0;
}
function $bf74d58b74973e6b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bf74d58b74973e6b$var$p(169));
    c ? (a = $bf74d58b74973e6b$var$bg(a, b, $bf74d58b74973e6b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H), $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, a)) : $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, c);
}
var $bf74d58b74973e6b$var$eg = null, $bf74d58b74973e6b$var$fg = !1, $bf74d58b74973e6b$var$gg = !1;
function $bf74d58b74973e6b$var$hg(a) {
    null === $bf74d58b74973e6b$var$eg ? $bf74d58b74973e6b$var$eg = [
        a
    ] : $bf74d58b74973e6b$var$eg.push(a);
}
function $bf74d58b74973e6b$var$ig(a) {
    $bf74d58b74973e6b$var$fg = !0;
    $bf74d58b74973e6b$var$hg(a);
}
function $bf74d58b74973e6b$var$jg() {
    if (!$bf74d58b74973e6b$var$gg && null !== $bf74d58b74973e6b$var$eg) {
        $bf74d58b74973e6b$var$gg = !0;
        var a = 0, b = $bf74d58b74973e6b$var$C;
        try {
            var c = $bf74d58b74973e6b$var$eg;
            for($bf74d58b74973e6b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bf74d58b74973e6b$var$eg = null;
            $bf74d58b74973e6b$var$fg = !1;
        } catch (e) {
            throw null !== $bf74d58b74973e6b$var$eg && ($bf74d58b74973e6b$var$eg = $bf74d58b74973e6b$var$eg.slice(a + 1)), $bf74d58b74973e6b$var$ac($bf74d58b74973e6b$var$fc, $bf74d58b74973e6b$var$jg), e;
        } finally{
            $bf74d58b74973e6b$var$C = b, $bf74d58b74973e6b$var$gg = !1;
        }
    }
    return null;
}
var $bf74d58b74973e6b$var$kg = [], $bf74d58b74973e6b$var$lg = 0, $bf74d58b74973e6b$var$mg = null, $bf74d58b74973e6b$var$ng = 0, $bf74d58b74973e6b$var$og = [], $bf74d58b74973e6b$var$pg = 0, $bf74d58b74973e6b$var$qg = null, $bf74d58b74973e6b$var$rg = 1, $bf74d58b74973e6b$var$sg = "";
function $bf74d58b74973e6b$var$tg(a, b) {
    $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg++] = $bf74d58b74973e6b$var$ng;
    $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg++] = $bf74d58b74973e6b$var$mg;
    $bf74d58b74973e6b$var$mg = a;
    $bf74d58b74973e6b$var$ng = b;
}
function $bf74d58b74973e6b$var$ug(a, b, c) {
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$rg;
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$sg;
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$qg;
    $bf74d58b74973e6b$var$qg = a;
    var d = $bf74d58b74973e6b$var$rg;
    a = $bf74d58b74973e6b$var$sg;
    var e = 32 - $bf74d58b74973e6b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bf74d58b74973e6b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bf74d58b74973e6b$var$rg = 1 << 32 - $bf74d58b74973e6b$var$oc(b) + e | c << e | d;
        $bf74d58b74973e6b$var$sg = f + a;
    } else $bf74d58b74973e6b$var$rg = 1 << f | c << e | d, $bf74d58b74973e6b$var$sg = a;
}
function $bf74d58b74973e6b$var$vg(a) {
    null !== a.return && ($bf74d58b74973e6b$var$tg(a, 1), $bf74d58b74973e6b$var$ug(a, 1, 0));
}
function $bf74d58b74973e6b$var$wg(a) {
    for(; a === $bf74d58b74973e6b$var$mg;)$bf74d58b74973e6b$var$mg = $bf74d58b74973e6b$var$kg[--$bf74d58b74973e6b$var$lg], $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg] = null, $bf74d58b74973e6b$var$ng = $bf74d58b74973e6b$var$kg[--$bf74d58b74973e6b$var$lg], $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg] = null;
    for(; a === $bf74d58b74973e6b$var$qg;)$bf74d58b74973e6b$var$qg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null, $bf74d58b74973e6b$var$sg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null, $bf74d58b74973e6b$var$rg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null;
}
var $bf74d58b74973e6b$var$xg = null, $bf74d58b74973e6b$var$yg = null, $bf74d58b74973e6b$var$I = !1, $bf74d58b74973e6b$var$zg = null;
function $bf74d58b74973e6b$var$Ag(a, b) {
    var c = $bf74d58b74973e6b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bf74d58b74973e6b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bf74d58b74973e6b$var$qg ? {
                id: $bf74d58b74973e6b$var$rg,
                overflow: $bf74d58b74973e6b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bf74d58b74973e6b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bf74d58b74973e6b$var$Eg(a) {
    if ($bf74d58b74973e6b$var$I) {
        var b = $bf74d58b74973e6b$var$yg;
        if (b) {
            var c = b;
            if (!$bf74d58b74973e6b$var$Cg(a, b)) {
                if ($bf74d58b74973e6b$var$Dg(a)) throw Error($bf74d58b74973e6b$var$p(418));
                b = $bf74d58b74973e6b$var$Lf(c.nextSibling);
                var d = $bf74d58b74973e6b$var$xg;
                b && $bf74d58b74973e6b$var$Cg(a, b) ? $bf74d58b74973e6b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bf74d58b74973e6b$var$I = !1, $bf74d58b74973e6b$var$xg = a);
            }
        } else {
            if ($bf74d58b74973e6b$var$Dg(a)) throw Error($bf74d58b74973e6b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bf74d58b74973e6b$var$I = !1;
            $bf74d58b74973e6b$var$xg = a;
        }
    }
}
function $bf74d58b74973e6b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bf74d58b74973e6b$var$xg = a;
}
function $bf74d58b74973e6b$var$Gg(a) {
    if (a !== $bf74d58b74973e6b$var$xg) return !1;
    if (!$bf74d58b74973e6b$var$I) return $bf74d58b74973e6b$var$Fg(a), $bf74d58b74973e6b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bf74d58b74973e6b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bf74d58b74973e6b$var$yg)) {
        if ($bf74d58b74973e6b$var$Dg(a)) throw $bf74d58b74973e6b$var$Hg(), Error($bf74d58b74973e6b$var$p(418));
        for(; b;)$bf74d58b74973e6b$var$Ag(a, b), b = $bf74d58b74973e6b$var$Lf(b.nextSibling);
    }
    $bf74d58b74973e6b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bf74d58b74973e6b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bf74d58b74973e6b$var$yg = null;
        }
    } else $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$xg ? $bf74d58b74973e6b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bf74d58b74973e6b$var$Hg() {
    for(var a = $bf74d58b74973e6b$var$yg; a;)a = $bf74d58b74973e6b$var$Lf(a.nextSibling);
}
function $bf74d58b74973e6b$var$Ig() {
    $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$xg = null;
    $bf74d58b74973e6b$var$I = !1;
}
function $bf74d58b74973e6b$var$Jg(a) {
    null === $bf74d58b74973e6b$var$zg ? $bf74d58b74973e6b$var$zg = [
        a
    ] : $bf74d58b74973e6b$var$zg.push(a);
}
var $bf74d58b74973e6b$var$Kg = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig;
function $bf74d58b74973e6b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bf74d58b74973e6b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bf74d58b74973e6b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bf74d58b74973e6b$var$p(284));
        if (!c._owner) throw Error($bf74d58b74973e6b$var$p(290, a));
    }
    return a;
}
function $bf74d58b74973e6b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bf74d58b74973e6b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bf74d58b74973e6b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $bf74d58b74973e6b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bf74d58b74973e6b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bf74d58b74973e6b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bf74d58b74973e6b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f && f.$$typeof === $bf74d58b74973e6b$var$Ha && $bf74d58b74973e6b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $bf74d58b74973e6b$var$Lg(a, b, c), d.return = a, d;
        d = $bf74d58b74973e6b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bf74d58b74973e6b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bf74d58b74973e6b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bf74d58b74973e6b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bf74d58b74973e6b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return c = $bf74d58b74973e6b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $bf74d58b74973e6b$var$Lg(a, null, b), c.return = a, c;
                case $bf74d58b74973e6b$var$wa:
                    return b = $bf74d58b74973e6b$var$Sg(b, a.mode, c), b.return = a, b;
                case $bf74d58b74973e6b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bf74d58b74973e6b$var$eb(b) || $bf74d58b74973e6b$var$Ka(b)) return b = $bf74d58b74973e6b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $bf74d58b74973e6b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bf74d58b74973e6b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bf74d58b74973e6b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bf74d58b74973e6b$var$eb(c) || $bf74d58b74973e6b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bf74d58b74973e6b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $5djcY._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bf74d58b74973e6b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bf74d58b74973e6b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bf74d58b74973e6b$var$eb(d) || $bf74d58b74973e6b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bf74d58b74973e6b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bf74d58b74973e6b$var$Ka(h);
        if ("function" !== typeof l) throw Error($bf74d58b74973e6b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bf74d58b74973e6b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f && f.type === $bf74d58b74973e6b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bf74d58b74973e6b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && null !== k && k.$$typeof === $bf74d58b74973e6b$var$Ha && $bf74d58b74973e6b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bf74d58b74973e6b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bf74d58b74973e6b$var$ya ? (d = $bf74d58b74973e6b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bf74d58b74973e6b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $bf74d58b74973e6b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $bf74d58b74973e6b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bf74d58b74973e6b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $bf74d58b74973e6b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bf74d58b74973e6b$var$eb(f)) return n(a, d, f, h);
            if ($bf74d58b74973e6b$var$Ka(f)) return t(a, d, f, h);
            $bf74d58b74973e6b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $bf74d58b74973e6b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bf74d58b74973e6b$var$Ug = $bf74d58b74973e6b$var$Og(!0), $bf74d58b74973e6b$var$Vg = $bf74d58b74973e6b$var$Og(!1), $bf74d58b74973e6b$var$Wg = $bf74d58b74973e6b$var$Uf(null), $bf74d58b74973e6b$var$Xg = null, $bf74d58b74973e6b$var$Yg = null, $bf74d58b74973e6b$var$Zg = null;
function $bf74d58b74973e6b$var$$g() {
    $bf74d58b74973e6b$var$Zg = $bf74d58b74973e6b$var$Yg = $bf74d58b74973e6b$var$Xg = null;
}
function $bf74d58b74973e6b$var$ah(a) {
    var b = $bf74d58b74973e6b$var$Wg.current;
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wg);
    a._currentValue = b;
}
function $bf74d58b74973e6b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $bf74d58b74973e6b$var$ch(a, b) {
    $bf74d58b74973e6b$var$Xg = a;
    $bf74d58b74973e6b$var$Zg = $bf74d58b74973e6b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bf74d58b74973e6b$var$dh = !0), a.firstContext = null);
}
function $bf74d58b74973e6b$var$eh(a) {
    var b = a._currentValue;
    if ($bf74d58b74973e6b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bf74d58b74973e6b$var$Yg) {
            if (null === $bf74d58b74973e6b$var$Xg) throw Error($bf74d58b74973e6b$var$p(308));
            $bf74d58b74973e6b$var$Yg = a;
            $bf74d58b74973e6b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bf74d58b74973e6b$var$Yg = $bf74d58b74973e6b$var$Yg.next = a;
    }
    return b;
}
var $bf74d58b74973e6b$var$fh = null;
function $bf74d58b74973e6b$var$gh(a) {
    null === $bf74d58b74973e6b$var$fh ? $bf74d58b74973e6b$var$fh = [
        a
    ] : $bf74d58b74973e6b$var$fh.push(a);
}
function $bf74d58b74973e6b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bf74d58b74973e6b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bf74d58b74973e6b$var$ih(a, d);
}
function $bf74d58b74973e6b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $bf74d58b74973e6b$var$jh = !1;
function $bf74d58b74973e6b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bf74d58b74973e6b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bf74d58b74973e6b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bf74d58b74973e6b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bf74d58b74973e6b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bf74d58b74973e6b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bf74d58b74973e6b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bf74d58b74973e6b$var$ih(a, c);
}
function $bf74d58b74973e6b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bf74d58b74973e6b$var$Cc(a, c);
    }
}
function $bf74d58b74973e6b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bf74d58b74973e6b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $bf74d58b74973e6b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bf74d58b74973e6b$var$A({}, q, r);
                            break a;
                        case 2:
                            $bf74d58b74973e6b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bf74d58b74973e6b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bf74d58b74973e6b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bf74d58b74973e6b$var$p(191, e));
            e.call(d);
        }
    }
}
var $bf74d58b74973e6b$var$th = {}, $bf74d58b74973e6b$var$uh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th), $bf74d58b74973e6b$var$vh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th), $bf74d58b74973e6b$var$wh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th);
function $bf74d58b74973e6b$var$xh(a) {
    if (a === $bf74d58b74973e6b$var$th) throw Error($bf74d58b74973e6b$var$p(174));
    return a;
}
function $bf74d58b74973e6b$var$yh(a, b) {
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$wh, b);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$vh, a);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, $bf74d58b74973e6b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bf74d58b74973e6b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bf74d58b74973e6b$var$lb(b, a);
    }
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, b);
}
function $bf74d58b74973e6b$var$zh() {
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$vh);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$wh);
}
function $bf74d58b74973e6b$var$Ah(a) {
    $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
    var b = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
    var c = $bf74d58b74973e6b$var$lb(b, a.type);
    b !== c && ($bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$vh, a), $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, c));
}
function $bf74d58b74973e6b$var$Bh(a) {
    $bf74d58b74973e6b$var$vh.current === a && ($bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$vh));
}
var $bf74d58b74973e6b$var$L = $bf74d58b74973e6b$var$Uf(0);
function $bf74d58b74973e6b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$Dh = [];
function $bf74d58b74973e6b$var$Eh() {
    for(var a = 0; a < $bf74d58b74973e6b$var$Dh.length; a++)$bf74d58b74973e6b$var$Dh[a]._workInProgressVersionPrimary = null;
    $bf74d58b74973e6b$var$Dh.length = 0;
}
var $bf74d58b74973e6b$var$Fh = $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher, $bf74d58b74973e6b$var$Gh = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$Hh = 0, $bf74d58b74973e6b$var$M = null, $bf74d58b74973e6b$var$N = null, $bf74d58b74973e6b$var$O = null, $bf74d58b74973e6b$var$Ih = !1, $bf74d58b74973e6b$var$Jh = !1, $bf74d58b74973e6b$var$Kh = 0, $bf74d58b74973e6b$var$Lh = 0;
function $bf74d58b74973e6b$var$P() {
    throw Error($bf74d58b74973e6b$var$p(321));
}
function $bf74d58b74973e6b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bf74d58b74973e6b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bf74d58b74973e6b$var$Nh(a, b, c, d, e, f) {
    $bf74d58b74973e6b$var$Hh = f;
    $bf74d58b74973e6b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bf74d58b74973e6b$var$Fh.current = null === a || null === a.memoizedState ? $bf74d58b74973e6b$var$Oh : $bf74d58b74973e6b$var$Ph;
    a = c(d, e);
    if ($bf74d58b74973e6b$var$Jh) {
        f = 0;
        do {
            $bf74d58b74973e6b$var$Jh = !1;
            $bf74d58b74973e6b$var$Kh = 0;
            if (25 <= f) throw Error($bf74d58b74973e6b$var$p(301));
            f += 1;
            $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = null;
            b.updateQueue = null;
            $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Qh;
            a = c(d, e);
        }while ($bf74d58b74973e6b$var$Jh);
    }
    $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Rh;
    b = null !== $bf74d58b74973e6b$var$N && null !== $bf74d58b74973e6b$var$N.next;
    $bf74d58b74973e6b$var$Hh = 0;
    $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = $bf74d58b74973e6b$var$M = null;
    $bf74d58b74973e6b$var$Ih = !1;
    if (b) throw Error($bf74d58b74973e6b$var$p(300));
    return a;
}
function $bf74d58b74973e6b$var$Sh() {
    var a = 0 !== $bf74d58b74973e6b$var$Kh;
    $bf74d58b74973e6b$var$Kh = 0;
    return a;
}
function $bf74d58b74973e6b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState = $bf74d58b74973e6b$var$O = a : $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$O.next = a;
    return $bf74d58b74973e6b$var$O;
}
function $bf74d58b74973e6b$var$Uh() {
    if (null === $bf74d58b74973e6b$var$N) {
        var a = $bf74d58b74973e6b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bf74d58b74973e6b$var$N.next;
    var b = null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState : $bf74d58b74973e6b$var$O.next;
    if (null !== b) $bf74d58b74973e6b$var$O = b, $bf74d58b74973e6b$var$N = a;
    else {
        if (null === a) throw Error($bf74d58b74973e6b$var$p(310));
        $bf74d58b74973e6b$var$N = a;
        a = {
            memoizedState: $bf74d58b74973e6b$var$N.memoizedState,
            baseState: $bf74d58b74973e6b$var$N.baseState,
            baseQueue: $bf74d58b74973e6b$var$N.baseQueue,
            queue: $bf74d58b74973e6b$var$N.queue,
            next: null
        };
        null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState = $bf74d58b74973e6b$var$O = a : $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$O.next = a;
    }
    return $bf74d58b74973e6b$var$O;
}
function $bf74d58b74973e6b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bf74d58b74973e6b$var$Wh(a) {
    var b = $bf74d58b74973e6b$var$Uh(), c = b.queue;
    if (null === c) throw Error($bf74d58b74973e6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bf74d58b74973e6b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bf74d58b74973e6b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bf74d58b74973e6b$var$M.lanes |= m;
                $bf74d58b74973e6b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bf74d58b74973e6b$var$He(d, b.memoizedState) || ($bf74d58b74973e6b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bf74d58b74973e6b$var$M.lanes |= f, $bf74d58b74973e6b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bf74d58b74973e6b$var$Xh(a) {
    var b = $bf74d58b74973e6b$var$Uh(), c = b.queue;
    if (null === c) throw Error($bf74d58b74973e6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bf74d58b74973e6b$var$He(f, b.memoizedState) || ($bf74d58b74973e6b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bf74d58b74973e6b$var$Yh() {}
function $bf74d58b74973e6b$var$Zh(a, b) {
    var c = $bf74d58b74973e6b$var$M, d = $bf74d58b74973e6b$var$Uh(), e = b(), f = !$bf74d58b74973e6b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bf74d58b74973e6b$var$dh = !0);
    d = d.queue;
    $bf74d58b74973e6b$var$$h($bf74d58b74973e6b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bf74d58b74973e6b$var$O && $bf74d58b74973e6b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bf74d58b74973e6b$var$bi(9, $bf74d58b74973e6b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $bf74d58b74973e6b$var$Q) throw Error($bf74d58b74973e6b$var$p(349));
        0 !== ($bf74d58b74973e6b$var$Hh & 30) || $bf74d58b74973e6b$var$di(c, b, e);
    }
    return e;
}
function $bf74d58b74973e6b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bf74d58b74973e6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bf74d58b74973e6b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bf74d58b74973e6b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bf74d58b74973e6b$var$ei(b) && $bf74d58b74973e6b$var$fi(a);
}
function $bf74d58b74973e6b$var$ai(a, b, c) {
    return c(function() {
        $bf74d58b74973e6b$var$ei(b) && $bf74d58b74973e6b$var$fi(a);
    });
}
function $bf74d58b74973e6b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bf74d58b74973e6b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bf74d58b74973e6b$var$fi(a) {
    var b = $bf74d58b74973e6b$var$ih(a, 1);
    null !== b && $bf74d58b74973e6b$var$gi(b, a, 1, -1);
}
function $bf74d58b74973e6b$var$hi(a) {
    var b = $bf74d58b74973e6b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bf74d58b74973e6b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bf74d58b74973e6b$var$ii.bind(null, $bf74d58b74973e6b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bf74d58b74973e6b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bf74d58b74973e6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bf74d58b74973e6b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bf74d58b74973e6b$var$ji() {
    return $bf74d58b74973e6b$var$Uh().memoizedState;
}
function $bf74d58b74973e6b$var$ki(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$Th();
    $bf74d58b74973e6b$var$M.flags |= a;
    e.memoizedState = $bf74d58b74973e6b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bf74d58b74973e6b$var$li(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bf74d58b74973e6b$var$N) {
        var g = $bf74d58b74973e6b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $bf74d58b74973e6b$var$Mh(d, g.deps)) {
            e.memoizedState = $bf74d58b74973e6b$var$bi(b, c, f, d);
            return;
        }
    }
    $bf74d58b74973e6b$var$M.flags |= a;
    e.memoizedState = $bf74d58b74973e6b$var$bi(1 | b, c, f, d);
}
function $bf74d58b74973e6b$var$mi(a, b) {
    return $bf74d58b74973e6b$var$ki(8390656, 8, a, b);
}
function $bf74d58b74973e6b$var$$h(a, b) {
    return $bf74d58b74973e6b$var$li(2048, 8, a, b);
}
function $bf74d58b74973e6b$var$ni(a, b) {
    return $bf74d58b74973e6b$var$li(4, 2, a, b);
}
function $bf74d58b74973e6b$var$oi(a, b) {
    return $bf74d58b74973e6b$var$li(4, 4, a, b);
}
function $bf74d58b74973e6b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bf74d58b74973e6b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bf74d58b74973e6b$var$li(4, 4, $bf74d58b74973e6b$var$pi.bind(null, b, a), c);
}
function $bf74d58b74973e6b$var$ri() {}
function $bf74d58b74973e6b$var$si(a, b) {
    var c = $bf74d58b74973e6b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bf74d58b74973e6b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bf74d58b74973e6b$var$ti(a, b) {
    var c = $bf74d58b74973e6b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bf74d58b74973e6b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bf74d58b74973e6b$var$ui(a, b, c) {
    if (0 === ($bf74d58b74973e6b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $bf74d58b74973e6b$var$dh = !0), a.memoizedState = c;
    $bf74d58b74973e6b$var$He(c, b) || (c = $bf74d58b74973e6b$var$yc(), $bf74d58b74973e6b$var$M.lanes |= c, $bf74d58b74973e6b$var$rh |= c, a.baseState = !0);
    return b;
}
function $bf74d58b74973e6b$var$vi(a, b) {
    var c = $bf74d58b74973e6b$var$C;
    $bf74d58b74973e6b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bf74d58b74973e6b$var$Gh.transition;
    $bf74d58b74973e6b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bf74d58b74973e6b$var$C = c, $bf74d58b74973e6b$var$Gh.transition = d;
    }
}
function $bf74d58b74973e6b$var$wi() {
    return $bf74d58b74973e6b$var$Uh().memoizedState;
}
function $bf74d58b74973e6b$var$xi(a, b, c) {
    var d = $bf74d58b74973e6b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bf74d58b74973e6b$var$zi(a)) $bf74d58b74973e6b$var$Ai(b, c);
    else if (c = $bf74d58b74973e6b$var$hh(a, b, c, d), null !== c) {
        var e = $bf74d58b74973e6b$var$R();
        $bf74d58b74973e6b$var$gi(c, a, d, e);
        $bf74d58b74973e6b$var$Bi(c, b, d);
    }
}
function $bf74d58b74973e6b$var$ii(a, b, c) {
    var d = $bf74d58b74973e6b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bf74d58b74973e6b$var$zi(a)) $bf74d58b74973e6b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bf74d58b74973e6b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bf74d58b74973e6b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bf74d58b74973e6b$var$hh(a, b, e, d);
        null !== c && (e = $bf74d58b74973e6b$var$R(), $bf74d58b74973e6b$var$gi(c, a, d, e), $bf74d58b74973e6b$var$Bi(c, b, d));
    }
}
function $bf74d58b74973e6b$var$zi(a) {
    var b = a.alternate;
    return a === $bf74d58b74973e6b$var$M || null !== b && b === $bf74d58b74973e6b$var$M;
}
function $bf74d58b74973e6b$var$Ai(a, b) {
    $bf74d58b74973e6b$var$Jh = $bf74d58b74973e6b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bf74d58b74973e6b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bf74d58b74973e6b$var$Cc(a, c);
    }
}
var $bf74d58b74973e6b$var$Rh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$P,
    useContext: $bf74d58b74973e6b$var$P,
    useEffect: $bf74d58b74973e6b$var$P,
    useImperativeHandle: $bf74d58b74973e6b$var$P,
    useInsertionEffect: $bf74d58b74973e6b$var$P,
    useLayoutEffect: $bf74d58b74973e6b$var$P,
    useMemo: $bf74d58b74973e6b$var$P,
    useReducer: $bf74d58b74973e6b$var$P,
    useRef: $bf74d58b74973e6b$var$P,
    useState: $bf74d58b74973e6b$var$P,
    useDebugValue: $bf74d58b74973e6b$var$P,
    useDeferredValue: $bf74d58b74973e6b$var$P,
    useTransition: $bf74d58b74973e6b$var$P,
    useMutableSource: $bf74d58b74973e6b$var$P,
    useSyncExternalStore: $bf74d58b74973e6b$var$P,
    useId: $bf74d58b74973e6b$var$P,
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Oh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: function useCallback(a, b) {
        $bf74d58b74973e6b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bf74d58b74973e6b$var$ki(4194308, 4, $bf74d58b74973e6b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $bf74d58b74973e6b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $bf74d58b74973e6b$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $bf74d58b74973e6b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $bf74d58b74973e6b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bf74d58b74973e6b$var$xi.bind(null, $bf74d58b74973e6b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $bf74d58b74973e6b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bf74d58b74973e6b$var$hi,
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $bf74d58b74973e6b$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$hi(!1), b = a[0];
        a = $bf74d58b74973e6b$var$vi.bind(null, a[1]);
        $bf74d58b74973e6b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $bf74d58b74973e6b$var$M, e = $bf74d58b74973e6b$var$Th();
        if ($bf74d58b74973e6b$var$I) {
            if (void 0 === c) throw Error($bf74d58b74973e6b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bf74d58b74973e6b$var$Q) throw Error($bf74d58b74973e6b$var$p(349));
            0 !== ($bf74d58b74973e6b$var$Hh & 30) || $bf74d58b74973e6b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bf74d58b74973e6b$var$mi($bf74d58b74973e6b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bf74d58b74973e6b$var$bi(9, $bf74d58b74973e6b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $bf74d58b74973e6b$var$Th(), b = $bf74d58b74973e6b$var$Q.identifierPrefix;
        if ($bf74d58b74973e6b$var$I) {
            var c = $bf74d58b74973e6b$var$sg;
            var d = $bf74d58b74973e6b$var$rg;
            c = (d & ~(1 << 32 - $bf74d58b74973e6b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bf74d58b74973e6b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bf74d58b74973e6b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Ph = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$si,
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$$h,
    useImperativeHandle: $bf74d58b74973e6b$var$qi,
    useInsertionEffect: $bf74d58b74973e6b$var$ni,
    useLayoutEffect: $bf74d58b74973e6b$var$oi,
    useMemo: $bf74d58b74973e6b$var$ti,
    useReducer: $bf74d58b74973e6b$var$Wh,
    useRef: $bf74d58b74973e6b$var$ji,
    useState: function useState() {
        return $bf74d58b74973e6b$var$Wh($bf74d58b74973e6b$var$Vh);
    },
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bf74d58b74973e6b$var$Uh();
        return $bf74d58b74973e6b$var$ui(b, $bf74d58b74973e6b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$Wh($bf74d58b74973e6b$var$Vh)[0], b = $bf74d58b74973e6b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bf74d58b74973e6b$var$Yh,
    useSyncExternalStore: $bf74d58b74973e6b$var$Zh,
    useId: $bf74d58b74973e6b$var$wi,
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Qh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$si,
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$$h,
    useImperativeHandle: $bf74d58b74973e6b$var$qi,
    useInsertionEffect: $bf74d58b74973e6b$var$ni,
    useLayoutEffect: $bf74d58b74973e6b$var$oi,
    useMemo: $bf74d58b74973e6b$var$ti,
    useReducer: $bf74d58b74973e6b$var$Xh,
    useRef: $bf74d58b74973e6b$var$ji,
    useState: function useState() {
        return $bf74d58b74973e6b$var$Xh($bf74d58b74973e6b$var$Vh);
    },
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bf74d58b74973e6b$var$Uh();
        return null === $bf74d58b74973e6b$var$N ? b.memoizedState = a : $bf74d58b74973e6b$var$ui(b, $bf74d58b74973e6b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$Xh($bf74d58b74973e6b$var$Vh)[0], b = $bf74d58b74973e6b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bf74d58b74973e6b$var$Yh,
    useSyncExternalStore: $bf74d58b74973e6b$var$Zh,
    useId: $bf74d58b74973e6b$var$wi,
    unstable_isNewReconciler: !1
};
function $bf74d58b74973e6b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $bf74d58b74973e6b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $bf74d58b74973e6b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bf74d58b74973e6b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bf74d58b74973e6b$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $bf74d58b74973e6b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $bf74d58b74973e6b$var$R(), e = $bf74d58b74973e6b$var$yi(a), f = $bf74d58b74973e6b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bf74d58b74973e6b$var$nh(a, f, e);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, e, d), $bf74d58b74973e6b$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $bf74d58b74973e6b$var$R(), e = $bf74d58b74973e6b$var$yi(a), f = $bf74d58b74973e6b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bf74d58b74973e6b$var$nh(a, f, e);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, e, d), $bf74d58b74973e6b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $bf74d58b74973e6b$var$R(), d = $bf74d58b74973e6b$var$yi(a), e = $bf74d58b74973e6b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bf74d58b74973e6b$var$nh(a, e, d);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, d, c), $bf74d58b74973e6b$var$oh(b, a, d));
    }
};
function $bf74d58b74973e6b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bf74d58b74973e6b$var$Ie(c, d) || !$bf74d58b74973e6b$var$Ie(e, f) : !0;
}
function $bf74d58b74973e6b$var$Gi(a, b, c) {
    var d = !1, e = $bf74d58b74973e6b$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f ? f = $bf74d58b74973e6b$var$eh(f) : (e = $bf74d58b74973e6b$var$Zf(b) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bf74d58b74973e6b$var$Yf(a, e) : $bf74d58b74973e6b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bf74d58b74973e6b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bf74d58b74973e6b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bf74d58b74973e6b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $bf74d58b74973e6b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $bf74d58b74973e6b$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f ? e.context = $bf74d58b74973e6b$var$eh(f) : (f = $bf74d58b74973e6b$var$Zf(b) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, e.context = $bf74d58b74973e6b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bf74d58b74973e6b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bf74d58b74973e6b$var$Ei.enqueueReplaceState(e, e.state, null), $bf74d58b74973e6b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bf74d58b74973e6b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $bf74d58b74973e6b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bf74d58b74973e6b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bf74d58b74973e6b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bf74d58b74973e6b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $bf74d58b74973e6b$var$Ni(a, b, c) {
    c = $bf74d58b74973e6b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bf74d58b74973e6b$var$Oi || ($bf74d58b74973e6b$var$Oi = !0, $bf74d58b74973e6b$var$Pi = d);
        $bf74d58b74973e6b$var$Li(a, b);
    };
    return c;
}
function $bf74d58b74973e6b$var$Qi(a, b, c) {
    c = $bf74d58b74973e6b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bf74d58b74973e6b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bf74d58b74973e6b$var$Li(a, b);
        "function" !== typeof d && (null === $bf74d58b74973e6b$var$Ri ? $bf74d58b74973e6b$var$Ri = new Set([
            this
        ]) : $bf74d58b74973e6b$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $bf74d58b74973e6b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bf74d58b74973e6b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bf74d58b74973e6b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $bf74d58b74973e6b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $bf74d58b74973e6b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bf74d58b74973e6b$var$mh(-1, 1), b.tag = 2, $bf74d58b74973e6b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bf74d58b74973e6b$var$Wi = $bf74d58b74973e6b$var$ua.ReactCurrentOwner, $bf74d58b74973e6b$var$dh = !1;
function $bf74d58b74973e6b$var$Xi(a, b, c, d) {
    b.child = null === a ? $bf74d58b74973e6b$var$Vg(b, null, c, d) : $bf74d58b74973e6b$var$Ug(b, a.child, c, d);
}
function $bf74d58b74973e6b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bf74d58b74973e6b$var$ch(b, e);
    d = $bf74d58b74973e6b$var$Nh(a, b, c, d, f, e);
    c = $bf74d58b74973e6b$var$Sh();
    if (null !== a && !$bf74d58b74973e6b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bf74d58b74973e6b$var$Zi(a, b, e);
    $bf74d58b74973e6b$var$I && c && $bf74d58b74973e6b$var$vg(b);
    b.flags |= 1;
    $bf74d58b74973e6b$var$Xi(a, b, d, e);
    return b.child;
}
function $bf74d58b74973e6b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bf74d58b74973e6b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bf74d58b74973e6b$var$bj(a, b, f, d, e);
        a = $bf74d58b74973e6b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bf74d58b74973e6b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bf74d58b74973e6b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $bf74d58b74973e6b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bf74d58b74973e6b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bf74d58b74973e6b$var$Ie(f, d) && a.ref === b.ref) {
            if ($bf74d58b74973e6b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bf74d58b74973e6b$var$dh = !0);
            else return b.lanes = a.lanes, $bf74d58b74973e6b$var$Zi(a, b, e);
        }
    }
    return $bf74d58b74973e6b$var$cj(a, b, c, d, e);
}
function $bf74d58b74973e6b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj);
            $bf74d58b74973e6b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= d;
    $bf74d58b74973e6b$var$Xi(a, b, e, c);
    return b.child;
}
function $bf74d58b74973e6b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bf74d58b74973e6b$var$cj(a, b, c, d, e) {
    var f = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current;
    f = $bf74d58b74973e6b$var$Yf(b, f);
    $bf74d58b74973e6b$var$ch(b, e);
    c = $bf74d58b74973e6b$var$Nh(a, b, c, d, f, e);
    d = $bf74d58b74973e6b$var$Sh();
    if (null !== a && !$bf74d58b74973e6b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bf74d58b74973e6b$var$Zi(a, b, e);
    $bf74d58b74973e6b$var$I && d && $bf74d58b74973e6b$var$vg(b);
    b.flags |= 1;
    $bf74d58b74973e6b$var$Xi(a, b, c, e);
    return b.child;
}
function $bf74d58b74973e6b$var$hj(a, b, c, d, e) {
    if ($bf74d58b74973e6b$var$Zf(c)) {
        var f = !0;
        $bf74d58b74973e6b$var$cg(b);
    } else f = !1;
    $bf74d58b74973e6b$var$ch(b, e);
    if (null === b.stateNode) $bf74d58b74973e6b$var$ij(a, b), $bf74d58b74973e6b$var$Gi(b, c, d), $bf74d58b74973e6b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $5djcY._)(l)) && null !== l ? l = $bf74d58b74973e6b$var$eh(l) : (l = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, l = $bf74d58b74973e6b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bf74d58b74973e6b$var$Hi(b, g, d, l);
        $bf74d58b74973e6b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $bf74d58b74973e6b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bf74d58b74973e6b$var$Wf.current || $bf74d58b74973e6b$var$jh ? ("function" === typeof m && ($bf74d58b74973e6b$var$Di(b, c, m, d), k = b.memoizedState), (h = $bf74d58b74973e6b$var$jh || $bf74d58b74973e6b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bf74d58b74973e6b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bf74d58b74973e6b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && null !== k ? k = $bf74d58b74973e6b$var$eh(k) : (k = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, k = $bf74d58b74973e6b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bf74d58b74973e6b$var$Hi(b, g, d, k);
        $bf74d58b74973e6b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $bf74d58b74973e6b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bf74d58b74973e6b$var$Wf.current || $bf74d58b74973e6b$var$jh ? ("function" === typeof y && ($bf74d58b74973e6b$var$Di(b, c, y, d), n = b.memoizedState), (l = $bf74d58b74973e6b$var$jh || $bf74d58b74973e6b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bf74d58b74973e6b$var$jj(a, b, c, d, f, e);
}
function $bf74d58b74973e6b$var$jj(a, b, c, d, e, f) {
    $bf74d58b74973e6b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bf74d58b74973e6b$var$dg(b, c, !1), $bf74d58b74973e6b$var$Zi(a, b, f);
    d = b.stateNode;
    $bf74d58b74973e6b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bf74d58b74973e6b$var$Ug(b, a.child, null, f), b.child = $bf74d58b74973e6b$var$Ug(b, null, h, f)) : $bf74d58b74973e6b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bf74d58b74973e6b$var$dg(b, c, !0);
    return b.child;
}
function $bf74d58b74973e6b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bf74d58b74973e6b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bf74d58b74973e6b$var$ag(a, b.context, !1);
    $bf74d58b74973e6b$var$yh(a, b.containerInfo);
}
function $bf74d58b74973e6b$var$lj(a, b, c, d, e) {
    $bf74d58b74973e6b$var$Ig();
    $bf74d58b74973e6b$var$Jg(e);
    b.flags |= 256;
    $bf74d58b74973e6b$var$Xi(a, b, c, d);
    return b.child;
}
var $bf74d58b74973e6b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bf74d58b74973e6b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bf74d58b74973e6b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $bf74d58b74973e6b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, e & 1);
    if (null === a) {
        $bf74d58b74973e6b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bf74d58b74973e6b$var$pj(g, d, 0, null), a = $bf74d58b74973e6b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $bf74d58b74973e6b$var$nj(c), b.memoizedState = $bf74d58b74973e6b$var$mj, a) : $bf74d58b74973e6b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bf74d58b74973e6b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bf74d58b74973e6b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bf74d58b74973e6b$var$Pg(h, f) : (f = $bf74d58b74973e6b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bf74d58b74973e6b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bf74d58b74973e6b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bf74d58b74973e6b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bf74d58b74973e6b$var$qj(a, b) {
    b = $bf74d58b74973e6b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $bf74d58b74973e6b$var$sj(a, b, c, d) {
    null !== d && $bf74d58b74973e6b$var$Jg(d);
    $bf74d58b74973e6b$var$Ug(b, a.child, null, c);
    a = $bf74d58b74973e6b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bf74d58b74973e6b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bf74d58b74973e6b$var$Ki(Error($bf74d58b74973e6b$var$p(422))), $bf74d58b74973e6b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bf74d58b74973e6b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bf74d58b74973e6b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bf74d58b74973e6b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $bf74d58b74973e6b$var$nj(g);
        b.memoizedState = $bf74d58b74973e6b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bf74d58b74973e6b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bf74d58b74973e6b$var$p(419));
        d = $bf74d58b74973e6b$var$Ki(f, d, void 0);
        return $bf74d58b74973e6b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bf74d58b74973e6b$var$dh || h) {
        d = $bf74d58b74973e6b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bf74d58b74973e6b$var$ih(a, e), $bf74d58b74973e6b$var$gi(d, a, e, -1));
        }
        $bf74d58b74973e6b$var$tj();
        d = $bf74d58b74973e6b$var$Ki(Error($bf74d58b74973e6b$var$p(421)));
        return $bf74d58b74973e6b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bf74d58b74973e6b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(e.nextSibling);
    $bf74d58b74973e6b$var$xg = b;
    $bf74d58b74973e6b$var$I = !0;
    $bf74d58b74973e6b$var$zg = null;
    null !== a && ($bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$rg, $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$sg, $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$qg, $bf74d58b74973e6b$var$rg = a.id, $bf74d58b74973e6b$var$sg = a.overflow, $bf74d58b74973e6b$var$qg = b);
    b = $bf74d58b74973e6b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bf74d58b74973e6b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bf74d58b74973e6b$var$bh(a.return, b, c);
}
function $bf74d58b74973e6b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bf74d58b74973e6b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bf74d58b74973e6b$var$Xi(a, b, d.children, c);
    d = $bf74d58b74973e6b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bf74d58b74973e6b$var$vj(a, c, b);
            else if (19 === a.tag) $bf74d58b74973e6b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bf74d58b74973e6b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bf74d58b74973e6b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bf74d58b74973e6b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bf74d58b74973e6b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $bf74d58b74973e6b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bf74d58b74973e6b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bf74d58b74973e6b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bf74d58b74973e6b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bf74d58b74973e6b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bf74d58b74973e6b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bf74d58b74973e6b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bf74d58b74973e6b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $bf74d58b74973e6b$var$kj(b);
            $bf74d58b74973e6b$var$Ig();
            break;
        case 5:
            $bf74d58b74973e6b$var$Ah(b);
            break;
        case 1:
            $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$cg(b);
            break;
        case 4:
            $bf74d58b74973e6b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bf74d58b74973e6b$var$oj(a, b, c);
                $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1);
                a = $bf74d58b74973e6b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bf74d58b74973e6b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bf74d58b74973e6b$var$dj(a, b, c);
    }
    return $bf74d58b74973e6b$var$Zi(a, b, c);
}
var $bf74d58b74973e6b$var$zj, $bf74d58b74973e6b$var$Aj, $bf74d58b74973e6b$var$Bj, $bf74d58b74973e6b$var$Cj;
$bf74d58b74973e6b$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bf74d58b74973e6b$var$Aj = function Aj() {};
$bf74d58b74973e6b$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bf74d58b74973e6b$var$Ya(a, e);
                d = $bf74d58b74973e6b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bf74d58b74973e6b$var$A({}, e, {
                    value: void 0
                });
                d = $bf74d58b74973e6b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bf74d58b74973e6b$var$gb(a, e);
                d = $bf74d58b74973e6b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bf74d58b74973e6b$var$Bf);
        }
        $bf74d58b74973e6b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bf74d58b74973e6b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bf74d58b74973e6b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bf74d58b74973e6b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bf74d58b74973e6b$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bf74d58b74973e6b$var$Dj(a, b) {
    if (!$bf74d58b74973e6b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bf74d58b74973e6b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bf74d58b74973e6b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $bf74d58b74973e6b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bf74d58b74973e6b$var$S(b), null;
        case 1:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), $bf74d58b74973e6b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bf74d58b74973e6b$var$zh();
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
            $bf74d58b74973e6b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bf74d58b74973e6b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bf74d58b74973e6b$var$zg && ($bf74d58b74973e6b$var$Fj($bf74d58b74973e6b$var$zg), $bf74d58b74973e6b$var$zg = null));
            $bf74d58b74973e6b$var$Aj(a, b);
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 5:
            $bf74d58b74973e6b$var$Bh(b);
            var e = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bf74d58b74973e6b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bf74d58b74973e6b$var$p(166));
                    $bf74d58b74973e6b$var$S(b);
                    return null;
                }
                a = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
                if ($bf74d58b74973e6b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bf74d58b74973e6b$var$Of] = b;
                    d[$bf74d58b74973e6b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bf74d58b74973e6b$var$D("cancel", d);
                            $bf74d58b74973e6b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bf74d58b74973e6b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bf74d58b74973e6b$var$lf.length; e++)$bf74d58b74973e6b$var$D($bf74d58b74973e6b$var$lf[e], d);
                            break;
                        case "source":
                            $bf74d58b74973e6b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bf74d58b74973e6b$var$D("error", d);
                            $bf74d58b74973e6b$var$D("load", d);
                            break;
                        case "details":
                            $bf74d58b74973e6b$var$D("toggle", d);
                            break;
                        case "input":
                            $bf74d58b74973e6b$var$Za(d, f);
                            $bf74d58b74973e6b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bf74d58b74973e6b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$hb(d, f), $bf74d58b74973e6b$var$D("invalid", d);
                    }
                    $bf74d58b74973e6b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bf74d58b74973e6b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bf74d58b74973e6b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bf74d58b74973e6b$var$Va(d);
                            $bf74d58b74973e6b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$Va(d);
                            $bf74d58b74973e6b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bf74d58b74973e6b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bf74d58b74973e6b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bf74d58b74973e6b$var$Of] = b;
                    a[$bf74d58b74973e6b$var$Pf] = d;
                    $bf74d58b74973e6b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bf74d58b74973e6b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bf74d58b74973e6b$var$D("cancel", a);
                                $bf74d58b74973e6b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bf74d58b74973e6b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bf74d58b74973e6b$var$lf.length; e++)$bf74d58b74973e6b$var$D($bf74d58b74973e6b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bf74d58b74973e6b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bf74d58b74973e6b$var$D("error", a);
                                $bf74d58b74973e6b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bf74d58b74973e6b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bf74d58b74973e6b$var$Za(a, d);
                                e = $bf74d58b74973e6b$var$Ya(a, d);
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bf74d58b74973e6b$var$A({}, d, {
                                    value: void 0
                                });
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bf74d58b74973e6b$var$hb(a, d);
                                e = $bf74d58b74973e6b$var$gb(a, d);
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bf74d58b74973e6b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bf74d58b74973e6b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bf74d58b74973e6b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bf74d58b74973e6b$var$ob(a, k) : "number" === typeof k && $bf74d58b74973e6b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bf74d58b74973e6b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bf74d58b74973e6b$var$D("scroll", a) : null != k && $bf74d58b74973e6b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bf74d58b74973e6b$var$Va(a);
                                $bf74d58b74973e6b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bf74d58b74973e6b$var$Va(a);
                                $bf74d58b74973e6b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bf74d58b74973e6b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bf74d58b74973e6b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bf74d58b74973e6b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bf74d58b74973e6b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bf74d58b74973e6b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bf74d58b74973e6b$var$p(166));
                c = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
                $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
                if ($bf74d58b74973e6b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bf74d58b74973e6b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bf74d58b74973e6b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bf74d58b74973e6b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bf74d58b74973e6b$var$Of] = b, b.stateNode = d;
            }
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 13:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bf74d58b74973e6b$var$I && null !== $bf74d58b74973e6b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bf74d58b74973e6b$var$Hg(), $bf74d58b74973e6b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bf74d58b74973e6b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bf74d58b74973e6b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bf74d58b74973e6b$var$p(317));
                        f[$bf74d58b74973e6b$var$Of] = b;
                    } else $bf74d58b74973e6b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bf74d58b74973e6b$var$S(b);
                    f = !1;
                } else null !== $bf74d58b74973e6b$var$zg && ($bf74d58b74973e6b$var$Fj($bf74d58b74973e6b$var$zg), $bf74d58b74973e6b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bf74d58b74973e6b$var$L.current & 1) ? 0 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 3) : $bf74d58b74973e6b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 4:
            return $bf74d58b74973e6b$var$zh(), $bf74d58b74973e6b$var$Aj(a, b), null === a && $bf74d58b74973e6b$var$sf(b.stateNode.containerInfo), $bf74d58b74973e6b$var$S(b), null;
        case 10:
            return $bf74d58b74973e6b$var$ah(b.type._context), $bf74d58b74973e6b$var$S(b), null;
        case 17:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), $bf74d58b74973e6b$var$S(b), null;
        case 19:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            f = b.memoizedState;
            if (null === f) return $bf74d58b74973e6b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bf74d58b74973e6b$var$Dj(f, !1);
                else {
                    if (0 !== $bf74d58b74973e6b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bf74d58b74973e6b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bf74d58b74973e6b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bf74d58b74973e6b$var$B() > $bf74d58b74973e6b$var$Gj && (b.flags |= 128, d = !0, $bf74d58b74973e6b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bf74d58b74973e6b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bf74d58b74973e6b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bf74d58b74973e6b$var$I) return $bf74d58b74973e6b$var$S(b), null;
                    } else 2 * $bf74d58b74973e6b$var$B() - f.renderingStartTime > $bf74d58b74973e6b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $bf74d58b74973e6b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bf74d58b74973e6b$var$B(), b.sibling = null, c = $bf74d58b74973e6b$var$L.current, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, d ? c & 1 | 2 : c & 1), b;
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 22:
        case 23:
            return $bf74d58b74973e6b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bf74d58b74973e6b$var$fj & 1073741824) && ($bf74d58b74973e6b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bf74d58b74973e6b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bf74d58b74973e6b$var$p(156, b.tag));
}
function $bf74d58b74973e6b$var$Ij(a, b) {
    $bf74d58b74973e6b$var$wg(b);
    switch(b.tag){
        case 1:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bf74d58b74973e6b$var$zh(), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H), $bf74d58b74973e6b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bf74d58b74973e6b$var$Bh(b), null;
        case 13:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bf74d58b74973e6b$var$p(340));
                $bf74d58b74973e6b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L), null;
        case 4:
            return $bf74d58b74973e6b$var$zh(), null;
        case 10:
            return $bf74d58b74973e6b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $bf74d58b74973e6b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bf74d58b74973e6b$var$Jj = !1, $bf74d58b74973e6b$var$U = !1, $bf74d58b74973e6b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $bf74d58b74973e6b$var$V = null;
function $bf74d58b74973e6b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bf74d58b74973e6b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bf74d58b74973e6b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bf74d58b74973e6b$var$W(a, b, d);
    }
}
var $bf74d58b74973e6b$var$Nj = !1;
function $bf74d58b74973e6b$var$Oj(a, b) {
    $bf74d58b74973e6b$var$Cf = $bf74d58b74973e6b$var$dd;
    a = $bf74d58b74973e6b$var$Me();
    if ($bf74d58b74973e6b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bf74d58b74973e6b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bf74d58b74973e6b$var$dd = !1;
    for($bf74d58b74973e6b$var$V = b; null !== $bf74d58b74973e6b$var$V;)if (b = $bf74d58b74973e6b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $bf74d58b74973e6b$var$V = a;
    else for(; null !== $bf74d58b74973e6b$var$V;){
        b = $bf74d58b74973e6b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bf74d58b74973e6b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(163));
            }
        } catch (F) {
            $bf74d58b74973e6b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $bf74d58b74973e6b$var$V = a;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
    n = $bf74d58b74973e6b$var$Nj;
    $bf74d58b74973e6b$var$Nj = !1;
    return n;
}
function $bf74d58b74973e6b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bf74d58b74973e6b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bf74d58b74973e6b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bf74d58b74973e6b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bf74d58b74973e6b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bf74d58b74973e6b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bf74d58b74973e6b$var$Of], delete b[$bf74d58b74973e6b$var$Pf], delete b[$bf74d58b74973e6b$var$of], delete b[$bf74d58b74973e6b$var$Qf], delete b[$bf74d58b74973e6b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bf74d58b74973e6b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bf74d58b74973e6b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $bf74d58b74973e6b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bf74d58b74973e6b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bf74d58b74973e6b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bf74d58b74973e6b$var$Vj(a, b, c), a = a.sibling; null !== a;)$bf74d58b74973e6b$var$Vj(a, b, c), a = a.sibling;
}
function $bf74d58b74973e6b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bf74d58b74973e6b$var$Wj(a, b, c), a = a.sibling; null !== a;)$bf74d58b74973e6b$var$Wj(a, b, c), a = a.sibling;
}
var $bf74d58b74973e6b$var$X = null, $bf74d58b74973e6b$var$Xj = !1;
function $bf74d58b74973e6b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$bf74d58b74973e6b$var$Zj(a, b, c), c = c.sibling;
}
function $bf74d58b74973e6b$var$Zj(a, b, c) {
    if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onCommitFiberUnmount) try {
        $bf74d58b74973e6b$var$lc.onCommitFiberUnmount($bf74d58b74973e6b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bf74d58b74973e6b$var$U || $bf74d58b74973e6b$var$Lj(c, b);
        case 6:
            var d = $bf74d58b74973e6b$var$X, e = $bf74d58b74973e6b$var$Xj;
            $bf74d58b74973e6b$var$X = null;
            $bf74d58b74973e6b$var$Yj(a, b, c);
            $bf74d58b74973e6b$var$X = d;
            $bf74d58b74973e6b$var$Xj = e;
            null !== $bf74d58b74973e6b$var$X && ($bf74d58b74973e6b$var$Xj ? (a = $bf74d58b74973e6b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bf74d58b74973e6b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bf74d58b74973e6b$var$X && ($bf74d58b74973e6b$var$Xj ? (a = $bf74d58b74973e6b$var$X, c = c.stateNode, 8 === a.nodeType ? $bf74d58b74973e6b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bf74d58b74973e6b$var$Kf(a, c), $bf74d58b74973e6b$var$bd(a)) : $bf74d58b74973e6b$var$Kf($bf74d58b74973e6b$var$X, c.stateNode));
            break;
        case 4:
            d = $bf74d58b74973e6b$var$X;
            e = $bf74d58b74973e6b$var$Xj;
            $bf74d58b74973e6b$var$X = c.stateNode.containerInfo;
            $bf74d58b74973e6b$var$Xj = !0;
            $bf74d58b74973e6b$var$Yj(a, b, c);
            $bf74d58b74973e6b$var$X = d;
            $bf74d58b74973e6b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bf74d58b74973e6b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bf74d58b74973e6b$var$Mj(c, b, g) : 0 !== (f & 4) && $bf74d58b74973e6b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$bf74d58b74973e6b$var$U && ($bf74d58b74973e6b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bf74d58b74973e6b$var$W(c, b, h);
            }
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 21:
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bf74d58b74973e6b$var$U = (d = $bf74d58b74973e6b$var$U) || null !== c.memoizedState, $bf74d58b74973e6b$var$Yj(a, b, c), $bf74d58b74973e6b$var$U = d) : $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        default:
            $bf74d58b74973e6b$var$Yj(a, b, c);
    }
}
function $bf74d58b74973e6b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bf74d58b74973e6b$var$Kj);
        b.forEach(function(b) {
            var d = $bf74d58b74973e6b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bf74d58b74973e6b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bf74d58b74973e6b$var$X = h.stateNode;
                        $bf74d58b74973e6b$var$Xj = !1;
                        break a;
                    case 3:
                        $bf74d58b74973e6b$var$X = h.stateNode.containerInfo;
                        $bf74d58b74973e6b$var$Xj = !0;
                        break a;
                    case 4:
                        $bf74d58b74973e6b$var$X = h.stateNode.containerInfo;
                        $bf74d58b74973e6b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $bf74d58b74973e6b$var$X) throw Error($bf74d58b74973e6b$var$p(160));
            $bf74d58b74973e6b$var$Zj(f, g, e);
            $bf74d58b74973e6b$var$X = null;
            $bf74d58b74973e6b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $bf74d58b74973e6b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bf74d58b74973e6b$var$dk(b, a), b = b.sibling;
}
function $bf74d58b74973e6b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4) {
                try {
                    $bf74d58b74973e6b$var$Pj(3, a, a.return), $bf74d58b74973e6b$var$Qj(3, a);
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
                try {
                    $bf74d58b74973e6b$var$Pj(5, a, a.return);
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 512 && null !== c && $bf74d58b74973e6b$var$Lj(c, c.return);
            break;
        case 5:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 512 && null !== c && $bf74d58b74973e6b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bf74d58b74973e6b$var$ob(e, "");
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bf74d58b74973e6b$var$ab(e, f);
                    $bf74d58b74973e6b$var$vb(h, g);
                    var l = $bf74d58b74973e6b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bf74d58b74973e6b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bf74d58b74973e6b$var$nb(e, q) : "children" === m ? $bf74d58b74973e6b$var$ob(e, q) : $bf74d58b74973e6b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bf74d58b74973e6b$var$bb(e, f);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bf74d58b74973e6b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bf74d58b74973e6b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bf74d58b74973e6b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bf74d58b74973e6b$var$Pf] = f;
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bf74d58b74973e6b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bf74d58b74973e6b$var$bd(b.containerInfo);
            } catch (t) {
                $bf74d58b74973e6b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            break;
        case 13:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bf74d58b74973e6b$var$fk = $bf74d58b74973e6b$var$B()));
            d & 4 && $bf74d58b74973e6b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bf74d58b74973e6b$var$U = (l = $bf74d58b74973e6b$var$U) || m, $bf74d58b74973e6b$var$ck(b, a), $bf74d58b74973e6b$var$U = l) : $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bf74d58b74973e6b$var$V = a, m = a.child; null !== m;){
                    for(q = $bf74d58b74973e6b$var$V = m; null !== $bf74d58b74973e6b$var$V;){
                        r = $bf74d58b74973e6b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bf74d58b74973e6b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $bf74d58b74973e6b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bf74d58b74973e6b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bf74d58b74973e6b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bf74d58b74973e6b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $bf74d58b74973e6b$var$V = y) : $bf74d58b74973e6b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bf74d58b74973e6b$var$rb("display", g));
                            } catch (t) {
                                $bf74d58b74973e6b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bf74d58b74973e6b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 4 && $bf74d58b74973e6b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $bf74d58b74973e6b$var$ck(b, a), $bf74d58b74973e6b$var$ek(a);
    }
}
function $bf74d58b74973e6b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($bf74d58b74973e6b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($bf74d58b74973e6b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bf74d58b74973e6b$var$ob(e, ""), d.flags &= -33);
                    var f = $bf74d58b74973e6b$var$Uj(a);
                    $bf74d58b74973e6b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bf74d58b74973e6b$var$Uj(a);
                    $bf74d58b74973e6b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(161));
            }
        } catch (k) {
            $bf74d58b74973e6b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bf74d58b74973e6b$var$hk(a, b, c) {
    $bf74d58b74973e6b$var$V = a;
    $bf74d58b74973e6b$var$ik(a, b, c);
}
function $bf74d58b74973e6b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bf74d58b74973e6b$var$V;){
        var e = $bf74d58b74973e6b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bf74d58b74973e6b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bf74d58b74973e6b$var$U;
                h = $bf74d58b74973e6b$var$Jj;
                var l = $bf74d58b74973e6b$var$U;
                $bf74d58b74973e6b$var$Jj = g;
                if (($bf74d58b74973e6b$var$U = k) && !l) for($bf74d58b74973e6b$var$V = e; null !== $bf74d58b74973e6b$var$V;)g = $bf74d58b74973e6b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bf74d58b74973e6b$var$jk(e) : null !== k ? (k.return = g, $bf74d58b74973e6b$var$V = k) : $bf74d58b74973e6b$var$jk(e);
                for(; null !== f;)$bf74d58b74973e6b$var$V = f, $bf74d58b74973e6b$var$ik(f, b, c), f = f.sibling;
                $bf74d58b74973e6b$var$V = e;
                $bf74d58b74973e6b$var$Jj = h;
                $bf74d58b74973e6b$var$U = l;
            }
            $bf74d58b74973e6b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $bf74d58b74973e6b$var$V = f) : $bf74d58b74973e6b$var$kk(a, b, c);
    }
}
function $bf74d58b74973e6b$var$kk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bf74d58b74973e6b$var$U || $bf74d58b74973e6b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bf74d58b74973e6b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bf74d58b74973e6b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bf74d58b74973e6b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bf74d58b74973e6b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bf74d58b74973e6b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bf74d58b74973e6b$var$p(163));
                }
                $bf74d58b74973e6b$var$U || b.flags & 512 && $bf74d58b74973e6b$var$Rj(b);
            } catch (r) {
                $bf74d58b74973e6b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bf74d58b74973e6b$var$V = c;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
function $bf74d58b74973e6b$var$gk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bf74d58b74973e6b$var$V = c;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
function $bf74d58b74973e6b$var$jk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $bf74d58b74973e6b$var$Qj(4, b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bf74d58b74973e6b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $bf74d58b74973e6b$var$Rj(b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $bf74d58b74973e6b$var$Rj(b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bf74d58b74973e6b$var$W(b, b.return, k);
        }
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $bf74d58b74973e6b$var$V = h;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
var $bf74d58b74973e6b$var$lk = Math.ceil, $bf74d58b74973e6b$var$mk = $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher, $bf74d58b74973e6b$var$nk = $bf74d58b74973e6b$var$ua.ReactCurrentOwner, $bf74d58b74973e6b$var$ok = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$K = 0, $bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Y = null, $bf74d58b74973e6b$var$Z = 0, $bf74d58b74973e6b$var$fj = 0, $bf74d58b74973e6b$var$ej = $bf74d58b74973e6b$var$Uf(0), $bf74d58b74973e6b$var$T = 0, $bf74d58b74973e6b$var$pk = null, $bf74d58b74973e6b$var$rh = 0, $bf74d58b74973e6b$var$qk = 0, $bf74d58b74973e6b$var$rk = 0, $bf74d58b74973e6b$var$sk = null, $bf74d58b74973e6b$var$tk = null, $bf74d58b74973e6b$var$fk = 0, $bf74d58b74973e6b$var$Gj = Infinity, $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Oi = !1, $bf74d58b74973e6b$var$Pi = null, $bf74d58b74973e6b$var$Ri = null, $bf74d58b74973e6b$var$vk = !1, $bf74d58b74973e6b$var$wk = null, $bf74d58b74973e6b$var$xk = 0, $bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = null, $bf74d58b74973e6b$var$Ak = -1, $bf74d58b74973e6b$var$Bk = 0;
function $bf74d58b74973e6b$var$R() {
    return 0 !== ($bf74d58b74973e6b$var$K & 6) ? $bf74d58b74973e6b$var$B() : -1 !== $bf74d58b74973e6b$var$Ak ? $bf74d58b74973e6b$var$Ak : $bf74d58b74973e6b$var$Ak = $bf74d58b74973e6b$var$B();
}
function $bf74d58b74973e6b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bf74d58b74973e6b$var$K & 2) && 0 !== $bf74d58b74973e6b$var$Z) return $bf74d58b74973e6b$var$Z & -$bf74d58b74973e6b$var$Z;
    if (null !== $bf74d58b74973e6b$var$Kg.transition) return 0 === $bf74d58b74973e6b$var$Bk && ($bf74d58b74973e6b$var$Bk = $bf74d58b74973e6b$var$yc()), $bf74d58b74973e6b$var$Bk;
    a = $bf74d58b74973e6b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bf74d58b74973e6b$var$jd(a.type);
    return a;
}
function $bf74d58b74973e6b$var$gi(a, b, c, d) {
    if (50 < $bf74d58b74973e6b$var$yk) throw $bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = null, Error($bf74d58b74973e6b$var$p(185));
    $bf74d58b74973e6b$var$Ac(a, c, d);
    if (0 === ($bf74d58b74973e6b$var$K & 2) || a !== $bf74d58b74973e6b$var$Q) a === $bf74d58b74973e6b$var$Q && (0 === ($bf74d58b74973e6b$var$K & 2) && ($bf74d58b74973e6b$var$qk |= c), 4 === $bf74d58b74973e6b$var$T && $bf74d58b74973e6b$var$Ck(a, $bf74d58b74973e6b$var$Z)), $bf74d58b74973e6b$var$Dk(a, d), 1 === c && 0 === $bf74d58b74973e6b$var$K && 0 === (b.mode & 1) && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$fg && $bf74d58b74973e6b$var$jg());
}
function $bf74d58b74973e6b$var$Dk(a, b) {
    var c = a.callbackNode;
    $bf74d58b74973e6b$var$wc(a, b);
    var d = $bf74d58b74973e6b$var$uc(a, a === $bf74d58b74973e6b$var$Q ? $bf74d58b74973e6b$var$Z : 0);
    if (0 === d) null !== c && $bf74d58b74973e6b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bf74d58b74973e6b$var$bc(c);
        if (1 === b) 0 === a.tag ? $bf74d58b74973e6b$var$ig($bf74d58b74973e6b$var$Ek.bind(null, a)) : $bf74d58b74973e6b$var$hg($bf74d58b74973e6b$var$Ek.bind(null, a)), $bf74d58b74973e6b$var$Jf(function() {
            0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$jg();
        }), c = null;
        else {
            switch($bf74d58b74973e6b$var$Dc(d)){
                case 1:
                    c = $bf74d58b74973e6b$var$fc;
                    break;
                case 4:
                    c = $bf74d58b74973e6b$var$gc;
                    break;
                case 16:
                    c = $bf74d58b74973e6b$var$hc;
                    break;
                case 536870912:
                    c = $bf74d58b74973e6b$var$jc;
                    break;
                default:
                    c = $bf74d58b74973e6b$var$hc;
            }
            c = $bf74d58b74973e6b$var$Fk(c, $bf74d58b74973e6b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bf74d58b74973e6b$var$Gk(a, b) {
    $bf74d58b74973e6b$var$Ak = -1;
    $bf74d58b74973e6b$var$Bk = 0;
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    var c = a.callbackNode;
    if ($bf74d58b74973e6b$var$Hk() && a.callbackNode !== c) return null;
    var d = $bf74d58b74973e6b$var$uc(a, a === $bf74d58b74973e6b$var$Q ? $bf74d58b74973e6b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bf74d58b74973e6b$var$Ik(a, d);
    else {
        b = d;
        var e = $bf74d58b74973e6b$var$K;
        $bf74d58b74973e6b$var$K |= 2;
        var f = $bf74d58b74973e6b$var$Jk();
        if ($bf74d58b74973e6b$var$Q !== a || $bf74d58b74973e6b$var$Z !== b) $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$Kk(a, b);
        for(;;)try {
            $bf74d58b74973e6b$var$Lk();
            break;
        } catch (h) {
            $bf74d58b74973e6b$var$Mk(a, h);
        }
        $bf74d58b74973e6b$var$$g();
        $bf74d58b74973e6b$var$mk.current = f;
        $bf74d58b74973e6b$var$K = e;
        null !== $bf74d58b74973e6b$var$Y ? b = 0 : ($bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Z = 0, b = $bf74d58b74973e6b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bf74d58b74973e6b$var$xc(a), 0 !== e && (d = e, b = $bf74d58b74973e6b$var$Nk(a, e)));
        if (1 === b) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, d), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
        if (6 === b) $bf74d58b74973e6b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bf74d58b74973e6b$var$Ok(e) && (b = $bf74d58b74973e6b$var$Ik(a, d), 2 === b && (f = $bf74d58b74973e6b$var$xc(a), 0 !== f && (d = f, b = $bf74d58b74973e6b$var$Nk(a, f))), 1 === b)) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, d), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bf74d58b74973e6b$var$p(345));
                case 2:
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 3:
                    $bf74d58b74973e6b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $bf74d58b74973e6b$var$fk + 500 - $bf74d58b74973e6b$var$B(), 10 < b)) {
                        if (0 !== $bf74d58b74973e6b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bf74d58b74973e6b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bf74d58b74973e6b$var$Ff($bf74d58b74973e6b$var$Pk.bind(null, a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk), b);
                        break;
                    }
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 4:
                    $bf74d58b74973e6b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bf74d58b74973e6b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bf74d58b74973e6b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bf74d58b74973e6b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bf74d58b74973e6b$var$Ff($bf74d58b74973e6b$var$Pk.bind(null, a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk), d);
                        break;
                    }
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 5:
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(329));
            }
        }
    }
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    return a.callbackNode === c ? $bf74d58b74973e6b$var$Gk.bind(null, a) : null;
}
function $bf74d58b74973e6b$var$Nk(a, b) {
    var c = $bf74d58b74973e6b$var$sk;
    a.current.memoizedState.isDehydrated && ($bf74d58b74973e6b$var$Kk(a, b).flags |= 256);
    a = $bf74d58b74973e6b$var$Ik(a, b);
    2 !== a && (b = $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$tk = c, null !== b && $bf74d58b74973e6b$var$Fj(b));
    return a;
}
function $bf74d58b74973e6b$var$Fj(a) {
    null === $bf74d58b74973e6b$var$tk ? $bf74d58b74973e6b$var$tk = a : $bf74d58b74973e6b$var$tk.push.apply($bf74d58b74973e6b$var$tk, a);
}
function $bf74d58b74973e6b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bf74d58b74973e6b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $bf74d58b74973e6b$var$Ck(a, b) {
    b &= ~$bf74d58b74973e6b$var$rk;
    b &= ~$bf74d58b74973e6b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bf74d58b74973e6b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bf74d58b74973e6b$var$Ek(a) {
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    $bf74d58b74973e6b$var$Hk();
    var b = $bf74d58b74973e6b$var$uc(a, 0);
    if (0 === (b & 1)) return $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), null;
    var c = $bf74d58b74973e6b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bf74d58b74973e6b$var$xc(a);
        0 !== d && (b = d, c = $bf74d58b74973e6b$var$Nk(a, d));
    }
    if (1 === c) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, b), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
    if (6 === c) throw Error($bf74d58b74973e6b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    return null;
}
function $bf74d58b74973e6b$var$Qk(a, b) {
    var c = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bf74d58b74973e6b$var$K = c, 0 === $bf74d58b74973e6b$var$K && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$fg && $bf74d58b74973e6b$var$jg());
    }
}
function $bf74d58b74973e6b$var$Rk(a) {
    null !== $bf74d58b74973e6b$var$wk && 0 === $bf74d58b74973e6b$var$wk.tag && 0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$Hk();
    var b = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 1;
    var c = $bf74d58b74973e6b$var$ok.transition, d = $bf74d58b74973e6b$var$C;
    try {
        if ($bf74d58b74973e6b$var$ok.transition = null, $bf74d58b74973e6b$var$C = 1, a) return a();
    } finally{
        $bf74d58b74973e6b$var$C = d, $bf74d58b74973e6b$var$ok.transition = c, $bf74d58b74973e6b$var$K = b, 0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$jg();
    }
}
function $bf74d58b74973e6b$var$Hj() {
    $bf74d58b74973e6b$var$fj = $bf74d58b74973e6b$var$ej.current;
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$ej);
}
function $bf74d58b74973e6b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bf74d58b74973e6b$var$Gf(c));
    if (null !== $bf74d58b74973e6b$var$Y) for(c = $bf74d58b74973e6b$var$Y.return; null !== c;){
        var d = c;
        $bf74d58b74973e6b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bf74d58b74973e6b$var$$f();
                break;
            case 3:
                $bf74d58b74973e6b$var$zh();
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
                $bf74d58b74973e6b$var$Eh();
                break;
            case 5:
                $bf74d58b74973e6b$var$Bh(d);
                break;
            case 4:
                $bf74d58b74973e6b$var$zh();
                break;
            case 13:
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
                break;
            case 19:
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
                break;
            case 10:
                $bf74d58b74973e6b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $bf74d58b74973e6b$var$Hj();
        }
        c = c.return;
    }
    $bf74d58b74973e6b$var$Q = a;
    $bf74d58b74973e6b$var$Y = a = $bf74d58b74973e6b$var$Pg(a.current, null);
    $bf74d58b74973e6b$var$Z = $bf74d58b74973e6b$var$fj = b;
    $bf74d58b74973e6b$var$T = 0;
    $bf74d58b74973e6b$var$pk = null;
    $bf74d58b74973e6b$var$rk = $bf74d58b74973e6b$var$qk = $bf74d58b74973e6b$var$rh = 0;
    $bf74d58b74973e6b$var$tk = $bf74d58b74973e6b$var$sk = null;
    if (null !== $bf74d58b74973e6b$var$fh) {
        for(b = 0; b < $bf74d58b74973e6b$var$fh.length; b++)if (c = $bf74d58b74973e6b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bf74d58b74973e6b$var$fh = null;
    }
    return a;
}
function $bf74d58b74973e6b$var$Mk(a, b) {
    do {
        var c = $bf74d58b74973e6b$var$Y;
        try {
            $bf74d58b74973e6b$var$$g();
            $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Rh;
            if ($bf74d58b74973e6b$var$Ih) {
                for(var d = $bf74d58b74973e6b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bf74d58b74973e6b$var$Ih = !1;
            }
            $bf74d58b74973e6b$var$Hh = 0;
            $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = $bf74d58b74973e6b$var$M = null;
            $bf74d58b74973e6b$var$Jh = !1;
            $bf74d58b74973e6b$var$Kh = 0;
            $bf74d58b74973e6b$var$nk.current = null;
            if (null === c || null === c.return) {
                $bf74d58b74973e6b$var$T = 1;
                $bf74d58b74973e6b$var$pk = b;
                $bf74d58b74973e6b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $bf74d58b74973e6b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bf74d58b74973e6b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bf74d58b74973e6b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $bf74d58b74973e6b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bf74d58b74973e6b$var$Si(f, l, b);
                            $bf74d58b74973e6b$var$tj();
                            break a;
                        }
                        k = Error($bf74d58b74973e6b$var$p(426));
                    }
                } else if ($bf74d58b74973e6b$var$I && h.mode & 1) {
                    var J = $bf74d58b74973e6b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bf74d58b74973e6b$var$Vi(J, g, h, f, b);
                        $bf74d58b74973e6b$var$Jg($bf74d58b74973e6b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $bf74d58b74973e6b$var$Ji(k, h);
                4 !== $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 2);
                null === $bf74d58b74973e6b$var$sk ? $bf74d58b74973e6b$var$sk = [
                    f
                ] : $bf74d58b74973e6b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bf74d58b74973e6b$var$Ni(f, k, b);
                            $bf74d58b74973e6b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bf74d58b74973e6b$var$Ri || !$bf74d58b74973e6b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bf74d58b74973e6b$var$Qi(f, h, b);
                                $bf74d58b74973e6b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $bf74d58b74973e6b$var$Sk(c);
        } catch (na) {
            b = na;
            $bf74d58b74973e6b$var$Y === c && null !== c && ($bf74d58b74973e6b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $bf74d58b74973e6b$var$Jk() {
    var a = $bf74d58b74973e6b$var$mk.current;
    $bf74d58b74973e6b$var$mk.current = $bf74d58b74973e6b$var$Rh;
    return null === a ? $bf74d58b74973e6b$var$Rh : a;
}
function $bf74d58b74973e6b$var$tj() {
    if (0 === $bf74d58b74973e6b$var$T || 3 === $bf74d58b74973e6b$var$T || 2 === $bf74d58b74973e6b$var$T) $bf74d58b74973e6b$var$T = 4;
    null === $bf74d58b74973e6b$var$Q || 0 === ($bf74d58b74973e6b$var$rh & 268435455) && 0 === ($bf74d58b74973e6b$var$qk & 268435455) || $bf74d58b74973e6b$var$Ck($bf74d58b74973e6b$var$Q, $bf74d58b74973e6b$var$Z);
}
function $bf74d58b74973e6b$var$Ik(a, b) {
    var c = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 2;
    var d = $bf74d58b74973e6b$var$Jk();
    if ($bf74d58b74973e6b$var$Q !== a || $bf74d58b74973e6b$var$Z !== b) $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Kk(a, b);
    for(;;)try {
        $bf74d58b74973e6b$var$Tk();
        break;
    } catch (e) {
        $bf74d58b74973e6b$var$Mk(a, e);
    }
    $bf74d58b74973e6b$var$$g();
    $bf74d58b74973e6b$var$K = c;
    $bf74d58b74973e6b$var$mk.current = d;
    if (null !== $bf74d58b74973e6b$var$Y) throw Error($bf74d58b74973e6b$var$p(261));
    $bf74d58b74973e6b$var$Q = null;
    $bf74d58b74973e6b$var$Z = 0;
    return $bf74d58b74973e6b$var$T;
}
function $bf74d58b74973e6b$var$Tk() {
    for(; null !== $bf74d58b74973e6b$var$Y;)$bf74d58b74973e6b$var$Uk($bf74d58b74973e6b$var$Y);
}
function $bf74d58b74973e6b$var$Lk() {
    for(; null !== $bf74d58b74973e6b$var$Y && !$bf74d58b74973e6b$var$cc();)$bf74d58b74973e6b$var$Uk($bf74d58b74973e6b$var$Y);
}
function $bf74d58b74973e6b$var$Uk(a) {
    var b = $bf74d58b74973e6b$var$Vk(a.alternate, a, $bf74d58b74973e6b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bf74d58b74973e6b$var$Sk(a) : $bf74d58b74973e6b$var$Y = b;
    $bf74d58b74973e6b$var$nk.current = null;
}
function $bf74d58b74973e6b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $bf74d58b74973e6b$var$Ej(c, b, $bf74d58b74973e6b$var$fj), null !== c) {
                $bf74d58b74973e6b$var$Y = c;
                return;
            }
        } else {
            c = $bf74d58b74973e6b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bf74d58b74973e6b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bf74d58b74973e6b$var$T = 6;
                $bf74d58b74973e6b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bf74d58b74973e6b$var$Y = b;
            return;
        }
        $bf74d58b74973e6b$var$Y = b = a;
    }while (null !== b);
    0 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 5);
}
function $bf74d58b74973e6b$var$Pk(a, b, c) {
    var d = $bf74d58b74973e6b$var$C, e = $bf74d58b74973e6b$var$ok.transition;
    try {
        $bf74d58b74973e6b$var$ok.transition = null, $bf74d58b74973e6b$var$C = 1, $bf74d58b74973e6b$var$Wk(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$ok.transition = e, $bf74d58b74973e6b$var$C = d;
    }
    return null;
}
function $bf74d58b74973e6b$var$Wk(a, b, c, d) {
    do $bf74d58b74973e6b$var$Hk();
    while (null !== $bf74d58b74973e6b$var$wk);
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bf74d58b74973e6b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bf74d58b74973e6b$var$Bc(a, f);
    a === $bf74d58b74973e6b$var$Q && ($bf74d58b74973e6b$var$Y = $bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bf74d58b74973e6b$var$vk || ($bf74d58b74973e6b$var$vk = !0, $bf74d58b74973e6b$var$Fk($bf74d58b74973e6b$var$hc, function() {
        $bf74d58b74973e6b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bf74d58b74973e6b$var$ok.transition;
        $bf74d58b74973e6b$var$ok.transition = null;
        var g = $bf74d58b74973e6b$var$C;
        $bf74d58b74973e6b$var$C = 1;
        var h = $bf74d58b74973e6b$var$K;
        $bf74d58b74973e6b$var$K |= 4;
        $bf74d58b74973e6b$var$nk.current = null;
        $bf74d58b74973e6b$var$Oj(a, c);
        $bf74d58b74973e6b$var$dk(c, a);
        $bf74d58b74973e6b$var$Oe($bf74d58b74973e6b$var$Df);
        $bf74d58b74973e6b$var$dd = !!$bf74d58b74973e6b$var$Cf;
        $bf74d58b74973e6b$var$Df = $bf74d58b74973e6b$var$Cf = null;
        a.current = c;
        $bf74d58b74973e6b$var$hk(c, a, e);
        $bf74d58b74973e6b$var$dc();
        $bf74d58b74973e6b$var$K = h;
        $bf74d58b74973e6b$var$C = g;
        $bf74d58b74973e6b$var$ok.transition = f;
    } else a.current = c;
    $bf74d58b74973e6b$var$vk && ($bf74d58b74973e6b$var$vk = !1, $bf74d58b74973e6b$var$wk = a, $bf74d58b74973e6b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($bf74d58b74973e6b$var$Ri = null);
    $bf74d58b74973e6b$var$mc(c.stateNode, d);
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bf74d58b74973e6b$var$Oi) throw $bf74d58b74973e6b$var$Oi = !1, a = $bf74d58b74973e6b$var$Pi, $bf74d58b74973e6b$var$Pi = null, a;
    0 !== ($bf74d58b74973e6b$var$xk & 1) && 0 !== a.tag && $bf74d58b74973e6b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bf74d58b74973e6b$var$zk ? $bf74d58b74973e6b$var$yk++ : ($bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = a) : $bf74d58b74973e6b$var$yk = 0;
    $bf74d58b74973e6b$var$jg();
    return null;
}
function $bf74d58b74973e6b$var$Hk() {
    if (null !== $bf74d58b74973e6b$var$wk) {
        var a = $bf74d58b74973e6b$var$Dc($bf74d58b74973e6b$var$xk), b = $bf74d58b74973e6b$var$ok.transition, c = $bf74d58b74973e6b$var$C;
        try {
            $bf74d58b74973e6b$var$ok.transition = null;
            $bf74d58b74973e6b$var$C = 16 > a ? 16 : a;
            if (null === $bf74d58b74973e6b$var$wk) var d = !1;
            else {
                a = $bf74d58b74973e6b$var$wk;
                $bf74d58b74973e6b$var$wk = null;
                $bf74d58b74973e6b$var$xk = 0;
                if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(331));
                var e = $bf74d58b74973e6b$var$K;
                $bf74d58b74973e6b$var$K |= 4;
                for($bf74d58b74973e6b$var$V = a.current; null !== $bf74d58b74973e6b$var$V;){
                    var f = $bf74d58b74973e6b$var$V, g = f.child;
                    if (0 !== ($bf74d58b74973e6b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bf74d58b74973e6b$var$V = l; null !== $bf74d58b74973e6b$var$V;){
                                    var m = $bf74d58b74973e6b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bf74d58b74973e6b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $bf74d58b74973e6b$var$V = q;
                                    else for(; null !== $bf74d58b74973e6b$var$V;){
                                        m = $bf74d58b74973e6b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $bf74d58b74973e6b$var$Sj(m);
                                        if (m === l) {
                                            $bf74d58b74973e6b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $bf74d58b74973e6b$var$V = r;
                                            break;
                                        }
                                        $bf74d58b74973e6b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bf74d58b74973e6b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $bf74d58b74973e6b$var$V = g;
                    else b: for(; null !== $bf74d58b74973e6b$var$V;){
                        f = $bf74d58b74973e6b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bf74d58b74973e6b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $bf74d58b74973e6b$var$V = x;
                            break b;
                        }
                        $bf74d58b74973e6b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($bf74d58b74973e6b$var$V = w; null !== $bf74d58b74973e6b$var$V;){
                    g = $bf74d58b74973e6b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $bf74d58b74973e6b$var$V = u;
                    else b: for(g = w; null !== $bf74d58b74973e6b$var$V;){
                        h = $bf74d58b74973e6b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bf74d58b74973e6b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $bf74d58b74973e6b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $bf74d58b74973e6b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $bf74d58b74973e6b$var$V = F;
                            break b;
                        }
                        $bf74d58b74973e6b$var$V = h.return;
                    }
                }
                $bf74d58b74973e6b$var$K = e;
                $bf74d58b74973e6b$var$jg();
                if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onPostCommitFiberRoot) try {
                    $bf74d58b74973e6b$var$lc.onPostCommitFiberRoot($bf74d58b74973e6b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bf74d58b74973e6b$var$C = c, $bf74d58b74973e6b$var$ok.transition = b;
        }
    }
    return !1;
}
function $bf74d58b74973e6b$var$Xk(a, b, c) {
    b = $bf74d58b74973e6b$var$Ji(c, b);
    b = $bf74d58b74973e6b$var$Ni(a, b, 1);
    a = $bf74d58b74973e6b$var$nh(a, b, 1);
    b = $bf74d58b74973e6b$var$R();
    null !== a && ($bf74d58b74973e6b$var$Ac(a, 1, b), $bf74d58b74973e6b$var$Dk(a, b));
}
function $bf74d58b74973e6b$var$W(a, b, c) {
    if (3 === a.tag) $bf74d58b74973e6b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bf74d58b74973e6b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bf74d58b74973e6b$var$Ri || !$bf74d58b74973e6b$var$Ri.has(d))) {
                a = $bf74d58b74973e6b$var$Ji(c, a);
                a = $bf74d58b74973e6b$var$Qi(b, a, 1);
                b = $bf74d58b74973e6b$var$nh(b, a, 1);
                a = $bf74d58b74973e6b$var$R();
                null !== b && ($bf74d58b74973e6b$var$Ac(b, 1, a), $bf74d58b74973e6b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $bf74d58b74973e6b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $bf74d58b74973e6b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $bf74d58b74973e6b$var$Q === a && ($bf74d58b74973e6b$var$Z & c) === c && (4 === $bf74d58b74973e6b$var$T || 3 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$Z & 130023424) === $bf74d58b74973e6b$var$Z && 500 > $bf74d58b74973e6b$var$B() - $bf74d58b74973e6b$var$fk ? $bf74d58b74973e6b$var$Kk(a, 0) : $bf74d58b74973e6b$var$rk |= c);
    $bf74d58b74973e6b$var$Dk(a, b);
}
function $bf74d58b74973e6b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bf74d58b74973e6b$var$sc, $bf74d58b74973e6b$var$sc <<= 1, 0 === ($bf74d58b74973e6b$var$sc & 130023424) && ($bf74d58b74973e6b$var$sc = 4194304)));
    var c = $bf74d58b74973e6b$var$R();
    a = $bf74d58b74973e6b$var$ih(a, b);
    null !== a && ($bf74d58b74973e6b$var$Ac(a, b, c), $bf74d58b74973e6b$var$Dk(a, c));
}
function $bf74d58b74973e6b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bf74d58b74973e6b$var$Yk(a, c);
}
function $bf74d58b74973e6b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bf74d58b74973e6b$var$p(314));
    }
    null !== d && d.delete(b);
    $bf74d58b74973e6b$var$Yk(a, c);
}
var $bf74d58b74973e6b$var$Vk;
$bf74d58b74973e6b$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bf74d58b74973e6b$var$Wf.current) $bf74d58b74973e6b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bf74d58b74973e6b$var$dh = !1, $bf74d58b74973e6b$var$yj(a, b, c);
            $bf74d58b74973e6b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bf74d58b74973e6b$var$dh = !1, $bf74d58b74973e6b$var$I && 0 !== (b.flags & 1048576) && $bf74d58b74973e6b$var$ug(b, $bf74d58b74973e6b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bf74d58b74973e6b$var$ij(a, b);
            a = b.pendingProps;
            var e = $bf74d58b74973e6b$var$Yf(b, $bf74d58b74973e6b$var$H.current);
            $bf74d58b74973e6b$var$ch(b, c);
            e = $bf74d58b74973e6b$var$Nh(null, b, d, a, e, c);
            var f = $bf74d58b74973e6b$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bf74d58b74973e6b$var$Zf(d) ? (f = !0, $bf74d58b74973e6b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bf74d58b74973e6b$var$kh(b), e.updater = $bf74d58b74973e6b$var$Ei, b.stateNode = e, e._reactInternals = b, $bf74d58b74973e6b$var$Ii(b, d, a, c), b = $bf74d58b74973e6b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $bf74d58b74973e6b$var$I && f && $bf74d58b74973e6b$var$vg(b), $bf74d58b74973e6b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bf74d58b74973e6b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bf74d58b74973e6b$var$Zk(d);
                a = $bf74d58b74973e6b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $bf74d58b74973e6b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bf74d58b74973e6b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bf74d58b74973e6b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bf74d58b74973e6b$var$$i(null, b, d, $bf74d58b74973e6b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($bf74d58b74973e6b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $bf74d58b74973e6b$var$kj(b);
                if (null === a) throw Error($bf74d58b74973e6b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bf74d58b74973e6b$var$lh(a, b);
                $bf74d58b74973e6b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bf74d58b74973e6b$var$Ji(Error($bf74d58b74973e6b$var$p(423)), b);
                        b = $bf74d58b74973e6b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bf74d58b74973e6b$var$Ji(Error($bf74d58b74973e6b$var$p(424)), b);
                        b = $bf74d58b74973e6b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(b.stateNode.containerInfo.firstChild), $bf74d58b74973e6b$var$xg = b, $bf74d58b74973e6b$var$I = !0, $bf74d58b74973e6b$var$zg = null, c = $bf74d58b74973e6b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bf74d58b74973e6b$var$Ig();
                    if (d === e) {
                        b = $bf74d58b74973e6b$var$Zi(a, b, c);
                        break a;
                    }
                    $bf74d58b74973e6b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bf74d58b74973e6b$var$Ah(b), null === a && $bf74d58b74973e6b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bf74d58b74973e6b$var$Ef(d, e) ? g = null : null !== f && $bf74d58b74973e6b$var$Ef(d, f) && (b.flags |= 32), $bf74d58b74973e6b$var$gj(a, b), $bf74d58b74973e6b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $bf74d58b74973e6b$var$Eg(b), null;
        case 13:
            return $bf74d58b74973e6b$var$oj(a, b, c);
        case 4:
            return $bf74d58b74973e6b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bf74d58b74973e6b$var$Ug(b, null, d, c) : $bf74d58b74973e6b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$Yi(a, b, d, e, c);
        case 7:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bf74d58b74973e6b$var$He(f.value, g)) {
                        if (f.children === e.children && !$bf74d58b74973e6b$var$Wf.current) {
                            b = $bf74d58b74973e6b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bf74d58b74973e6b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bf74d58b74973e6b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($bf74d58b74973e6b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bf74d58b74973e6b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $bf74d58b74973e6b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bf74d58b74973e6b$var$ch(b, c), e = $bf74d58b74973e6b$var$eh(e), d = d(e), b.flags |= 1, $bf74d58b74973e6b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bf74d58b74973e6b$var$Ci(d, b.pendingProps), e = $bf74d58b74973e6b$var$Ci(d.type, e), $bf74d58b74973e6b$var$$i(a, b, d, e, c);
        case 15:
            return $bf74d58b74973e6b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$ij(a, b), b.tag = 1, $bf74d58b74973e6b$var$Zf(d) ? (a = !0, $bf74d58b74973e6b$var$cg(b)) : a = !1, $bf74d58b74973e6b$var$ch(b, c), $bf74d58b74973e6b$var$Gi(b, d, e), $bf74d58b74973e6b$var$Ii(b, d, e, c), $bf74d58b74973e6b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $bf74d58b74973e6b$var$xj(a, b, c);
        case 22:
            return $bf74d58b74973e6b$var$dj(a, b, c);
    }
    throw Error($bf74d58b74973e6b$var$p(156, b.tag));
};
function $bf74d58b74973e6b$var$Fk(a, b) {
    return $bf74d58b74973e6b$var$ac(a, b);
}
function $bf74d58b74973e6b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bf74d58b74973e6b$var$Bg(a, b, c, d) {
    return new $bf74d58b74973e6b$var$$k(a, b, c, d);
}
function $bf74d58b74973e6b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bf74d58b74973e6b$var$Zk(a) {
    if ("function" === typeof a) return $bf74d58b74973e6b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bf74d58b74973e6b$var$Da) return 11;
        if (a === $bf74d58b74973e6b$var$Ga) return 14;
    }
    return 2;
}
function $bf74d58b74973e6b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $bf74d58b74973e6b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bf74d58b74973e6b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bf74d58b74973e6b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bf74d58b74973e6b$var$ya:
            return $bf74d58b74973e6b$var$Tg(c.children, e, f, b);
        case $bf74d58b74973e6b$var$za:
            g = 8;
            e |= 8;
            break;
        case $bf74d58b74973e6b$var$Aa:
            return a = $bf74d58b74973e6b$var$Bg(12, c, b, e | 2), a.elementType = $bf74d58b74973e6b$var$Aa, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Ea:
            return a = $bf74d58b74973e6b$var$Bg(13, c, b, e), a.elementType = $bf74d58b74973e6b$var$Ea, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Fa:
            return a = $bf74d58b74973e6b$var$Bg(19, c, b, e), a.elementType = $bf74d58b74973e6b$var$Fa, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Ia:
            return $bf74d58b74973e6b$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a) switch(a.$$typeof){
                case $bf74d58b74973e6b$var$Ba:
                    g = 10;
                    break a;
                case $bf74d58b74973e6b$var$Ca:
                    g = 9;
                    break a;
                case $bf74d58b74973e6b$var$Da:
                    g = 11;
                    break a;
                case $bf74d58b74973e6b$var$Ga:
                    g = 14;
                    break a;
                case $bf74d58b74973e6b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bf74d58b74973e6b$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a), ""));
    }
    b = $bf74d58b74973e6b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bf74d58b74973e6b$var$Tg(a, b, c, d) {
    a = $bf74d58b74973e6b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bf74d58b74973e6b$var$pj(a, b, c, d) {
    a = $bf74d58b74973e6b$var$Bg(22, a, d, b);
    a.elementType = $bf74d58b74973e6b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bf74d58b74973e6b$var$Qg(a, b, c) {
    a = $bf74d58b74973e6b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bf74d58b74973e6b$var$Sg(a, b, c) {
    b = $bf74d58b74973e6b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bf74d58b74973e6b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bf74d58b74973e6b$var$zc(0);
    this.expirationTimes = $bf74d58b74973e6b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bf74d58b74973e6b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bf74d58b74973e6b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $bf74d58b74973e6b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bf74d58b74973e6b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bf74d58b74973e6b$var$kh(f);
    return a;
}
function $bf74d58b74973e6b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bf74d58b74973e6b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bf74d58b74973e6b$var$dl(a) {
    if (!a) return $bf74d58b74973e6b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bf74d58b74973e6b$var$Vb(a) !== a || 1 !== a.tag) throw Error($bf74d58b74973e6b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bf74d58b74973e6b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($bf74d58b74973e6b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bf74d58b74973e6b$var$Zf(c)) return $bf74d58b74973e6b$var$bg(a, c, b);
    }
    return b;
}
function $bf74d58b74973e6b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $bf74d58b74973e6b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $bf74d58b74973e6b$var$dl(null);
    c = a.current;
    d = $bf74d58b74973e6b$var$R();
    e = $bf74d58b74973e6b$var$yi(c);
    f = $bf74d58b74973e6b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bf74d58b74973e6b$var$nh(c, f, e);
    a.current.lanes = e;
    $bf74d58b74973e6b$var$Ac(a, e, d);
    $bf74d58b74973e6b$var$Dk(a, d);
    return a;
}
function $bf74d58b74973e6b$var$fl(a, b, c, d) {
    var e = b.current, f = $bf74d58b74973e6b$var$R(), g = $bf74d58b74973e6b$var$yi(e);
    c = $bf74d58b74973e6b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bf74d58b74973e6b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bf74d58b74973e6b$var$nh(e, b, g);
    null !== a && ($bf74d58b74973e6b$var$gi(a, e, g, f), $bf74d58b74973e6b$var$oh(a, e, g));
    return g;
}
function $bf74d58b74973e6b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bf74d58b74973e6b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bf74d58b74973e6b$var$il(a, b) {
    $bf74d58b74973e6b$var$hl(a, b);
    (a = a.alternate) && $bf74d58b74973e6b$var$hl(a, b);
}
function $bf74d58b74973e6b$var$jl() {
    return null;
}
var $bf74d58b74973e6b$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $bf74d58b74973e6b$var$ll(a) {
    this._internalRoot = a;
}
$bf74d58b74973e6b$var$ml.prototype.render = $bf74d58b74973e6b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bf74d58b74973e6b$var$p(409));
    $bf74d58b74973e6b$var$fl(a, b, null, null);
};
$bf74d58b74973e6b$var$ml.prototype.unmount = $bf74d58b74973e6b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bf74d58b74973e6b$var$Rk(function() {
            $bf74d58b74973e6b$var$fl(null, a, null, null);
        });
        b[$bf74d58b74973e6b$var$uf] = null;
    }
};
function $bf74d58b74973e6b$var$ml(a) {
    this._internalRoot = a;
}
$bf74d58b74973e6b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bf74d58b74973e6b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bf74d58b74973e6b$var$Qc.length && 0 !== b && b < $bf74d58b74973e6b$var$Qc[c].priority; c++);
        $bf74d58b74973e6b$var$Qc.splice(c, 0, a);
        0 === c && $bf74d58b74973e6b$var$Vc(a);
    }
};
function $bf74d58b74973e6b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bf74d58b74973e6b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bf74d58b74973e6b$var$pl() {}
function $bf74d58b74973e6b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $bf74d58b74973e6b$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $bf74d58b74973e6b$var$el(b, d, a, 0, null, !1, !1, "", $bf74d58b74973e6b$var$pl);
        a._reactRootContainer = g;
        a[$bf74d58b74973e6b$var$uf] = g.current;
        $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bf74d58b74973e6b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $bf74d58b74973e6b$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $bf74d58b74973e6b$var$bl(a, 0, !1, null, null, !1, !1, "", $bf74d58b74973e6b$var$pl);
    a._reactRootContainer = k;
    a[$bf74d58b74973e6b$var$uf] = k.current;
    $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bf74d58b74973e6b$var$Rk(function() {
        $bf74d58b74973e6b$var$fl(b, k, c, d);
    });
    return k;
}
function $bf74d58b74973e6b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $bf74d58b74973e6b$var$gl(g);
                h.call(_$a);
            };
        }
        $bf74d58b74973e6b$var$fl(b, g, a, e);
    } else g = $bf74d58b74973e6b$var$ql(c, b, a, e, d);
    return $bf74d58b74973e6b$var$gl(g);
}
$bf74d58b74973e6b$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bf74d58b74973e6b$var$tc(b.pendingLanes);
                0 !== c && ($bf74d58b74973e6b$var$Cc(b, c | 1), $bf74d58b74973e6b$var$Dk(b, $bf74d58b74973e6b$var$B()), 0 === ($bf74d58b74973e6b$var$K & 6) && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$jg()));
            }
            break;
        case 13:
            $bf74d58b74973e6b$var$Rk(function() {
                var b = $bf74d58b74973e6b$var$ih(a, 1);
                if (null !== b) {
                    var c = $bf74d58b74973e6b$var$R();
                    $bf74d58b74973e6b$var$gi(b, a, 1, c);
                }
            }), $bf74d58b74973e6b$var$il(a, 1);
    }
};
$bf74d58b74973e6b$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $bf74d58b74973e6b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $bf74d58b74973e6b$var$R();
            $bf74d58b74973e6b$var$gi(b, a, 134217728, c);
        }
        $bf74d58b74973e6b$var$il(a, 134217728);
    }
};
$bf74d58b74973e6b$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $bf74d58b74973e6b$var$yi(a), c = $bf74d58b74973e6b$var$ih(a, b);
        if (null !== c) {
            var d = $bf74d58b74973e6b$var$R();
            $bf74d58b74973e6b$var$gi(c, a, b, d);
        }
        $bf74d58b74973e6b$var$il(a, b);
    }
};
$bf74d58b74973e6b$var$Hc = function Hc() {
    return $bf74d58b74973e6b$var$C;
};
$bf74d58b74973e6b$var$Ic = function Ic(a, b) {
    var c = $bf74d58b74973e6b$var$C;
    try {
        return $bf74d58b74973e6b$var$C = a, b();
    } finally{
        $bf74d58b74973e6b$var$C = c;
    }
};
$bf74d58b74973e6b$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $bf74d58b74973e6b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bf74d58b74973e6b$var$Db(d);
                        if (!e) throw Error($bf74d58b74973e6b$var$p(90));
                        $bf74d58b74973e6b$var$Wa(d);
                        $bf74d58b74973e6b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bf74d58b74973e6b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bf74d58b74973e6b$var$fb(a, !!c.multiple, b, !1);
    }
};
$bf74d58b74973e6b$var$Gb = $bf74d58b74973e6b$var$Qk;
$bf74d58b74973e6b$var$Hb = $bf74d58b74973e6b$var$Rk;
var $bf74d58b74973e6b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $bf74d58b74973e6b$var$Cb,
        $bf74d58b74973e6b$var$ue,
        $bf74d58b74973e6b$var$Db,
        $bf74d58b74973e6b$var$Eb,
        $bf74d58b74973e6b$var$Fb,
        $bf74d58b74973e6b$var$Qk
    ]
}, $bf74d58b74973e6b$var$tl = {
    findFiberByHostInstance: $bf74d58b74973e6b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $bf74d58b74973e6b$var$ul = {
    bundleType: $bf74d58b74973e6b$var$tl.bundleType,
    version: $bf74d58b74973e6b$var$tl.version,
    rendererPackageName: $bf74d58b74973e6b$var$tl.rendererPackageName,
    rendererConfig: $bf74d58b74973e6b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $bf74d58b74973e6b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bf74d58b74973e6b$var$tl.findFiberByHostInstance || $bf74d58b74973e6b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bf74d58b74973e6b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bf74d58b74973e6b$var$vl.isDisabled && $bf74d58b74973e6b$var$vl.supportsFiber) try {
        $bf74d58b74973e6b$var$kc = $bf74d58b74973e6b$var$vl.inject($bf74d58b74973e6b$var$ul), $bf74d58b74973e6b$var$lc = $bf74d58b74973e6b$var$vl;
    } catch (a) {}
}
$bf74d58b74973e6b$export$ae55be85d98224ed = $bf74d58b74973e6b$var$sl;
$bf74d58b74973e6b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bf74d58b74973e6b$var$nl(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$cl(a, b, null, c);
};
$bf74d58b74973e6b$export$882461b6382ed46c = function(a, b) {
    if (!$bf74d58b74973e6b$var$nl(a)) throw Error($bf74d58b74973e6b$var$p(299));
    var c = !1, d = "", e = $bf74d58b74973e6b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bf74d58b74973e6b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$bf74d58b74973e6b$var$uf] = b.current;
    $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bf74d58b74973e6b$var$ll(b);
};
$bf74d58b74973e6b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bf74d58b74973e6b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bf74d58b74973e6b$var$p(268, a));
    }
    a = $bf74d58b74973e6b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bf74d58b74973e6b$export$cd75ccfd720a3cd4 = function(a) {
    return $bf74d58b74973e6b$var$Rk(a);
};
$bf74d58b74973e6b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$ol(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$rl(null, a, b, !0, c);
};
$bf74d58b74973e6b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$nl(a)) throw Error($bf74d58b74973e6b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bf74d58b74973e6b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bf74d58b74973e6b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bf74d58b74973e6b$var$uf] = b.current;
    $bf74d58b74973e6b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bf74d58b74973e6b$var$ml(b);
};
$bf74d58b74973e6b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$ol(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$rl(null, a, b, !1, c);
};
$bf74d58b74973e6b$export$502457920280e6be = function(a) {
    if (!$bf74d58b74973e6b$var$ol(a)) throw Error($bf74d58b74973e6b$var$p(40));
    return a._reactRootContainer ? ($bf74d58b74973e6b$var$Rk(function() {
        $bf74d58b74973e6b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bf74d58b74973e6b$var$uf] = null;
        });
    }), !0) : !1;
};
$bf74d58b74973e6b$export$c78a37762a8d58e1 = $bf74d58b74973e6b$var$Qk;
$bf74d58b74973e6b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bf74d58b74973e6b$var$ol(c)) throw Error($bf74d58b74973e6b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bf74d58b74973e6b$var$p(38));
    return $bf74d58b74973e6b$var$rl(a, b, c, !1, d);
};
$bf74d58b74973e6b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("ojHeY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5wZqJ"));

});
parcelRegister("5wZqJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $406f97a93edc2f95$export$c4744153514ff05d; }, function (v) { return $406f97a93edc2f95$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $406f97a93edc2f95$export$3e506c1ccc9cc1a7; }, function (v) { return $406f97a93edc2f95$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $406f97a93edc2f95$export$e26fe2ed2fa76875; }, function (v) { return $406f97a93edc2f95$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $406f97a93edc2f95$export$502329bbf4b505b1; }, function (v) { return $406f97a93edc2f95$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $406f97a93edc2f95$export$6e3807111c4874c4; }, function (v) { return $406f97a93edc2f95$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $406f97a93edc2f95$export$c27134553091fb3a; }, function (v) { return $406f97a93edc2f95$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $406f97a93edc2f95$export$33ee1acdc04fd2a2; }, function (v) { return $406f97a93edc2f95$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $406f97a93edc2f95$export$b00a404bbd5edef2; }, function (v) { return $406f97a93edc2f95$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $406f97a93edc2f95$export$8352ce38b91d0c62; }, function (v) { return $406f97a93edc2f95$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $406f97a93edc2f95$export$d66a1c1c77bd778b; }, function (v) { return $406f97a93edc2f95$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $406f97a93edc2f95$export$d3dfb8e4810cb555; }, function (v) { return $406f97a93edc2f95$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $406f97a93edc2f95$export$839f9183b0465a69; }, function (v) { return $406f97a93edc2f95$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $406f97a93edc2f95$export$72fdf0e06517287b; }, function (v) { return $406f97a93edc2f95$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $406f97a93edc2f95$export$4b844e58a3e414b4; }, function (v) { return $406f97a93edc2f95$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $406f97a93edc2f95$export$816d2913ae6b83b1; }, function (v) { return $406f97a93edc2f95$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $406f97a93edc2f95$export$61bcfe829111a1d0; }, function (v) { return $406f97a93edc2f95$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $406f97a93edc2f95$export$7ee8c9beb337bc3f; }, function (v) { return $406f97a93edc2f95$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $406f97a93edc2f95$export$b5836b71941fa3ed; }, function (v) { return $406f97a93edc2f95$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $406f97a93edc2f95$export$cf845f2c119da08a; }, function (v) { return $406f97a93edc2f95$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $406f97a93edc2f95$export$c4744153514ff05d;
var $406f97a93edc2f95$export$3e506c1ccc9cc1a7;
var $406f97a93edc2f95$export$e26fe2ed2fa76875;
var $406f97a93edc2f95$export$502329bbf4b505b1;
var $406f97a93edc2f95$export$6e3807111c4874c4;
var $406f97a93edc2f95$export$c27134553091fb3a;
var $406f97a93edc2f95$export$33ee1acdc04fd2a2;
var $406f97a93edc2f95$export$b00a404bbd5edef2;
var $406f97a93edc2f95$export$8352ce38b91d0c62;
var $406f97a93edc2f95$export$d66a1c1c77bd778b;
var $406f97a93edc2f95$export$d3dfb8e4810cb555;
var $406f97a93edc2f95$export$839f9183b0465a69;
var $406f97a93edc2f95$export$72fdf0e06517287b;
var $406f97a93edc2f95$export$4b844e58a3e414b4;
var $406f97a93edc2f95$export$816d2913ae6b83b1;
var $406f97a93edc2f95$export$61bcfe829111a1d0;
var $406f97a93edc2f95$export$7ee8c9beb337bc3f;
var $406f97a93edc2f95$export$b5836b71941fa3ed;
var $406f97a93edc2f95$export$cf845f2c119da08a;
'use strict';
function $406f97a93edc2f95$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $406f97a93edc2f95$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $406f97a93edc2f95$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $406f97a93edc2f95$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $406f97a93edc2f95$var$g(C, c)) n < e && 0 > $406f97a93edc2f95$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $406f97a93edc2f95$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $406f97a93edc2f95$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $5djcY._)(performance)) && "function" === typeof performance.now) {
    var $406f97a93edc2f95$var$l = performance;
    $406f97a93edc2f95$export$c4744153514ff05d = function() {
        return $406f97a93edc2f95$var$l.now();
    };
} else {
    var $406f97a93edc2f95$var$p = Date, $406f97a93edc2f95$var$q = $406f97a93edc2f95$var$p.now();
    $406f97a93edc2f95$export$c4744153514ff05d = function() {
        return $406f97a93edc2f95$var$p.now() - $406f97a93edc2f95$var$q;
    };
}
var $406f97a93edc2f95$var$r = [], $406f97a93edc2f95$var$t = [], $406f97a93edc2f95$var$u = 1, $406f97a93edc2f95$var$v = null, $406f97a93edc2f95$var$y = 3, $406f97a93edc2f95$var$z = !1, $406f97a93edc2f95$var$A = !1, $406f97a93edc2f95$var$B = !1, $406f97a93edc2f95$var$D = "function" === typeof setTimeout ? setTimeout : null, $406f97a93edc2f95$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $406f97a93edc2f95$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $406f97a93edc2f95$var$G(a) {
    for(var b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t); null !== b;){
        if (null === b.callback) $406f97a93edc2f95$var$k($406f97a93edc2f95$var$t);
        else if (b.startTime <= a) $406f97a93edc2f95$var$k($406f97a93edc2f95$var$t), b.sortIndex = b.expirationTime, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$r, b);
        else break;
        b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
    }
}
function $406f97a93edc2f95$var$H(a) {
    $406f97a93edc2f95$var$B = !1;
    $406f97a93edc2f95$var$G(a);
    if (!$406f97a93edc2f95$var$A) {
        if (null !== $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r)) $406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J);
        else {
            var b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
            null !== b && $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, b.startTime - a);
        }
    }
}
function $406f97a93edc2f95$var$J(a, b) {
    $406f97a93edc2f95$var$A = !1;
    $406f97a93edc2f95$var$B && ($406f97a93edc2f95$var$B = !1, $406f97a93edc2f95$var$E($406f97a93edc2f95$var$L), $406f97a93edc2f95$var$L = -1);
    $406f97a93edc2f95$var$z = !0;
    var c = $406f97a93edc2f95$var$y;
    try {
        $406f97a93edc2f95$var$G(b);
        for($406f97a93edc2f95$var$v = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r); null !== $406f97a93edc2f95$var$v && (!($406f97a93edc2f95$var$v.expirationTime > b) || a && !$406f97a93edc2f95$var$M());){
            var d = $406f97a93edc2f95$var$v.callback;
            if ("function" === typeof d) {
                $406f97a93edc2f95$var$v.callback = null;
                $406f97a93edc2f95$var$y = $406f97a93edc2f95$var$v.priorityLevel;
                var e = d($406f97a93edc2f95$var$v.expirationTime <= b);
                b = $406f97a93edc2f95$export$c4744153514ff05d();
                "function" === typeof e ? $406f97a93edc2f95$var$v.callback = e : $406f97a93edc2f95$var$v === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r) && $406f97a93edc2f95$var$k($406f97a93edc2f95$var$r);
                $406f97a93edc2f95$var$G(b);
            } else $406f97a93edc2f95$var$k($406f97a93edc2f95$var$r);
            $406f97a93edc2f95$var$v = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r);
        }
        if (null !== $406f97a93edc2f95$var$v) var w = !0;
        else {
            var m = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
            null !== m && $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $406f97a93edc2f95$var$v = null, $406f97a93edc2f95$var$y = c, $406f97a93edc2f95$var$z = !1;
    }
}
var $406f97a93edc2f95$var$N = !1, $406f97a93edc2f95$var$O = null, $406f97a93edc2f95$var$L = -1, $406f97a93edc2f95$var$P = 5, $406f97a93edc2f95$var$Q = -1;
function $406f97a93edc2f95$var$M() {
    return $406f97a93edc2f95$export$c4744153514ff05d() - $406f97a93edc2f95$var$Q < $406f97a93edc2f95$var$P ? !1 : !0;
}
function $406f97a93edc2f95$var$R() {
    if (null !== $406f97a93edc2f95$var$O) {
        var a = $406f97a93edc2f95$export$c4744153514ff05d();
        $406f97a93edc2f95$var$Q = a;
        var b = !0;
        try {
            b = $406f97a93edc2f95$var$O(!0, a);
        } finally{
            b ? $406f97a93edc2f95$var$S() : ($406f97a93edc2f95$var$N = !1, $406f97a93edc2f95$var$O = null);
        }
    } else $406f97a93edc2f95$var$N = !1;
}
var $406f97a93edc2f95$var$S;
if ("function" === typeof $406f97a93edc2f95$var$F) $406f97a93edc2f95$var$S = function S() {
    $406f97a93edc2f95$var$F($406f97a93edc2f95$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $406f97a93edc2f95$var$T = new MessageChannel, $406f97a93edc2f95$var$U = $406f97a93edc2f95$var$T.port2;
    $406f97a93edc2f95$var$T.port1.onmessage = $406f97a93edc2f95$var$R;
    $406f97a93edc2f95$var$S = function S() {
        $406f97a93edc2f95$var$U.postMessage(null);
    };
} else $406f97a93edc2f95$var$S = function S() {
    $406f97a93edc2f95$var$D($406f97a93edc2f95$var$R, 0);
};
function $406f97a93edc2f95$var$I(a) {
    $406f97a93edc2f95$var$O = a;
    $406f97a93edc2f95$var$N || ($406f97a93edc2f95$var$N = !0, $406f97a93edc2f95$var$S());
}
function $406f97a93edc2f95$var$K(a, b) {
    $406f97a93edc2f95$var$L = $406f97a93edc2f95$var$D(function() {
        a($406f97a93edc2f95$export$c4744153514ff05d());
    }, b);
}
$406f97a93edc2f95$export$3e506c1ccc9cc1a7 = 5;
$406f97a93edc2f95$export$e26fe2ed2fa76875 = 1;
$406f97a93edc2f95$export$502329bbf4b505b1 = 4;
$406f97a93edc2f95$export$6e3807111c4874c4 = 3;
$406f97a93edc2f95$export$c27134553091fb3a = null;
$406f97a93edc2f95$export$33ee1acdc04fd2a2 = 2;
$406f97a93edc2f95$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$406f97a93edc2f95$export$8352ce38b91d0c62 = function() {
    $406f97a93edc2f95$var$A || $406f97a93edc2f95$var$z || ($406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J));
};
$406f97a93edc2f95$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $406f97a93edc2f95$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$406f97a93edc2f95$export$d3dfb8e4810cb555 = function() {
    return $406f97a93edc2f95$var$y;
};
$406f97a93edc2f95$export$839f9183b0465a69 = function() {
    return $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r);
};
$406f97a93edc2f95$export$72fdf0e06517287b = function(a) {
    switch($406f97a93edc2f95$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $406f97a93edc2f95$var$y;
    }
    var c = $406f97a93edc2f95$var$y;
    $406f97a93edc2f95$var$y = b;
    try {
        return a();
    } finally{
        $406f97a93edc2f95$var$y = c;
    }
};
$406f97a93edc2f95$export$4b844e58a3e414b4 = function() {};
$406f97a93edc2f95$export$816d2913ae6b83b1 = function() {};
$406f97a93edc2f95$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $406f97a93edc2f95$var$y;
    $406f97a93edc2f95$var$y = a;
    try {
        return b();
    } finally{
        $406f97a93edc2f95$var$y = c;
    }
};
$406f97a93edc2f95$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $406f97a93edc2f95$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $406f97a93edc2f95$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$t, a), null === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r) && a === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t) && ($406f97a93edc2f95$var$B ? ($406f97a93edc2f95$var$E($406f97a93edc2f95$var$L), $406f97a93edc2f95$var$L = -1) : $406f97a93edc2f95$var$B = !0, $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, c - d))) : (a.sortIndex = e, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$r, a), $406f97a93edc2f95$var$A || $406f97a93edc2f95$var$z || ($406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J)));
    return a;
};
$406f97a93edc2f95$export$b5836b71941fa3ed = $406f97a93edc2f95$var$M;
$406f97a93edc2f95$export$cf845f2c119da08a = function(a) {
    var b = $406f97a93edc2f95$var$y;
    return function() {
        var c = $406f97a93edc2f95$var$y;
        $406f97a93edc2f95$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $406f97a93edc2f95$var$y = c;
        }
    };
};

});





parcelRegister("ehF45", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a66281e0cb61a131$export$71511d61b312f219; });

var $9atk1 = parcelRequire("9atk1");

var $guZS9 = parcelRequire("guZS9");

var $hvep1 = parcelRequire("hvep1");
function $a66281e0cb61a131$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $9atk1._)(derived);
    return (0, $hvep1._)(_this, (0, $guZS9._)() ? Reflect.construct(derived, args || [], (0, $9atk1._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("9atk1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6acbcaee24263e7e$export$71511d61b312f219; });
function $6acbcaee24263e7e$export$71511d61b312f219(o) {
    $6acbcaee24263e7e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6acbcaee24263e7e$export$71511d61b312f219(o);
}

});

parcelRegister("guZS9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c02f7145f7333f96$export$71511d61b312f219; });
function $c02f7145f7333f96$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($c02f7145f7333f96$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("hvep1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbe080f489d283a9$export$71511d61b312f219; });

var $kE8SG = parcelRequire("kE8SG");

var $5djcY = parcelRequire("5djcY");
function $cbe080f489d283a9$export$71511d61b312f219(self, call) {
    if (call && ((0, $5djcY._)(call) === "object" || typeof call === "function")) return call;
    return (0, $kE8SG._)(self);
}

});
parcelRegister("kE8SG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f07e6eacebc6356c$export$71511d61b312f219; });
function $f07e6eacebc6356c$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("4QweW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $387506f4e8043722$export$71511d61b312f219; });
function $387506f4e8043722$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6hK4i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $493810cfcf480a5a$export$71511d61b312f219; });
function $493810cfcf480a5a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $493810cfcf480a5a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $493810cfcf480a5a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $493810cfcf480a5a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("6tY97", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b841b45c75a3225$export$71511d61b312f219; });
function $4b841b45c75a3225$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("c2MhV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c4b20f88f3acc70$export$71511d61b312f219; });

var $lwwt5 = parcelRequire("lwwt5");
function $8c4b20f88f3acc70$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $lwwt5._)(subClass, superClass);
}

});
parcelRegister("lwwt5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fab5c5a3fca5294c$export$71511d61b312f219; });
function $fab5c5a3fca5294c$export$71511d61b312f219(o, p) {
    $fab5c5a3fca5294c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fab5c5a3fca5294c$export$71511d61b312f219(o, p);
}

});


parcelRegister("kWfK0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e56f3eac89eefa$export$71511d61b312f219; });

var $6tY97 = parcelRequire("6tY97");
function $f3e56f3eac89eefa$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6tY97._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("hApvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccd99553ef7f1c61$export$71511d61b312f219; });
function $ccd99553ef7f1c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccd99553ef7f1c61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ccd99553ef7f1c61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("34ZKH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $23e1a58c0ce47d26$var$ReactIs, $23e1a58c0ce47d26$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jcgNi"))();

});
parcelRegister("jcgNi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lz8re = parcelRequire("lz8re");
function $df9c2a438da7b9e6$var$emptyFunction() {}
function $df9c2a438da7b9e6$var$emptyFunctionWithReset() {}
$df9c2a438da7b9e6$var$emptyFunctionWithReset.resetWarningCache = $df9c2a438da7b9e6$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lz8re) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $df9c2a438da7b9e6$var$emptyFunctionWithReset,
        resetWarningCache: $df9c2a438da7b9e6$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lz8re", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fb33698669fbe5d4$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fb33698669fbe5d4$var$ReactPropTypesSecret;

});



parcelRegister("7c6n8", function(module, exports) {

$parcel$export(module.exports, "goToExactSlide", function () { return goToExactSlide; });
$parcel$export(module.exports, "goToPrevSlide", function () { return goToPrevSlide; });
$parcel$export(module.exports, "goToNextSlide", function () { return goToNextSlide; });
$parcel$export(module.exports, "onSlideChange", function () { return onSlideChange; });
$parcel$export(module.exports, "getDimensionDots", function () { return getDimensionDots; });
$parcel$export(module.exports, "restartSurvey", function () { return restartSurvey; });
$parcel$export(module.exports, "showLeftNavButton", function () { return showLeftNavButton; });
$parcel$export(module.exports, "showRightNavButton", function () { return showRightNavButton; });
$parcel$export(module.exports, "isNextBtnDisabled", function () { return isNextBtnDisabled; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $9HB6H = parcelRequire("9HB6H");

var $jqwqw = parcelRequire("jqwqw");
var goToExactSlide = function goToExactSlide(slideIndex) {
    var _this = this;
    // check first if user is allowed to go to slide (slideIndex)
    // is only allowed to go to slide if all questions up to that slide (slideIndex) are answered
    // 1. Get all question IDs up to position 'slideIndex' that need to be answered
    var slides = this.state.slides;
    var questions = [];
    Object.keys(slides).map(function(key) {
        if (slides[key].type === 'question' && key <= slideIndex) questions.push(slides[key].ID);
    });
    // 2. Get IDs of already answered questions
    var answeredQuestions = [];
    Object.keys(this.state.userData.dimensions).map(function(key) {
        if ('results' in _this.state.userData.dimensions[key]) Object.keys(_this.state.userData.dimensions[key].results).map(function(ID) {
            answeredQuestions.push(parseInt(ID));
        });
    });
    // 3. Check if all questions up to target slide are answered (exist in the answeredQuestions array)
    var goToSlide = true;
    for(var i = 0; i < questions.length; i++)if (!questions.includes(answeredQuestions[i])) {
        goToSlide = false;
        break;
    }
    if (goToSlide) this.setState({
        position: slideIndex
    });
    else console.error("You're not allowed to go to the slide with the index ".concat(slideIndex, " because you didn't answer all necessary questions yet."));
};
var goToPrevSlide = function goToPrevSlide() {
    var _this = this;
    var position = this.state.position;
    if (position > 0) position--;
    this.setState({
        position: position
    }, function() {
        _this.onSlideChange();
    });
};
var goToNextSlide = function goToNextSlide() {
    var _this = this;
    var position = this.state.position;
    if (position < Object.keys(this.state.slides).length - 1) position++;
    var targetState = {
        position: position
    };
    if (position > this.state.userData.progress) targetState.userData = (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData), {
        progress: position
    });
    this.setState(targetState, function() {
        _this.onSlideChange(true);
    });
};
var onSlideChange = function onSlideChange() {
    var nextSlide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // Push data to database (nextSlide determines if user has gone forwards / backwards)
    this.dbPushData(nextSlide);
    // Adjust scroll position
    var container = document.querySelector("#ms-form-".concat(this.state.id));
    if (container) {
        var offset = 100; // Default offset of 100px
        // Take care of WP admin bar
        if (document.querySelector('#wpadminbar')) offset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
        var y = container.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }
};
var getDimensionDots = function getDimensionDots() {
    var _this_props = this.props, dimensions = _this_props.dimensions, progress = _this_props.progress, callback = _this_props.callback;
    return Object.keys(dimensions).map(function(key, index) {
        var range = 100 / Object.keys(dimensions).length;
        var dotClasses = [
            'dot'
        ];
        if (progress.handle >= index * range) dotClasses.push(progress.handle >= (index + 1) * range ? 'done' : 'current');
        return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: dotClasses.join(' '),
            onClick: function() {
                return callback(dimensions[key].slide_start);
            }
        }, key);
    });
};
var restartSurvey = function restartSurvey() {
    // Re-Init state
    this.setState(this.getInitialState());
    // Renew user ID
    this.generateUID(true);
    // Adjust scroll position
    this.onSlideChange();
};
var showLeftNavButton = function showLeftNavButton() {
    var _this_props = this.props, position = _this_props.position, resultsSlide = _this_props.resultsSlide, labels = _this_props.labels, restartBtnCallback = _this_props.restartBtnCallback, prevBtnCallback = _this_props.prevBtnCallback;
    if (position === resultsSlide) return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $jqwqw.default), {
        type: "secondary",
        callback: restartBtnCallback,
        title: labels.btn_restart,
        blank: false
    });
    else if (position > 0) return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $jqwqw.default), {
        type: "secondary",
        callback: prevBtnCallback,
        title: labels.btn_prev,
        blank: false
    });
};
var showRightNavButton = function showRightNavButton() {
    var _this_props = this.props, position = _this_props.position, slideCount = _this_props.slideCount, resultsSlide = _this_props.resultsSlide, labels = _this_props.labels, nextBtnCallback = _this_props.nextBtnCallback;
    if (position < slideCount - 1) {
        var btnTitle = position === resultsSlide ? labels.btn_next_steps : labels.btn_next;
        return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $jqwqw.default), {
            type: "primary",
            disabled: this.isNextBtnDisabled(),
            callback: nextBtnCallback,
            title: btnTitle,
            blank: false
        });
    }
};
var isNextBtnDisabled = function isNextBtnDisabled() {
    var _this_props = this.props, slide = _this_props.slide, userData = _this_props.userData;
    var show = true;
    if (slide.type === 'question') show = slide.dimension in userData.dimensions && 'results' in userData.dimensions[slide.dimension] && slide.ID in userData.dimensions[slide.dimension].results;
    return !show;
};

});
parcelRegister("jqwqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e249995172eff126$export$2e2bcd8739ae039; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");
var $e249995172eff126$var$Button = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Button, _React_Component);
    function Button(props) {
        (0, $4QweW._)(this, Button);
        return (0, $ehF45._)(this, Button, [
            props
        ]);
    }
    (0, $6hK4i._)(Button, [
        {
            key: "render",
            value: function render() {
                var classes = [
                    'btn',
                    "btn--".concat(this.props.type)
                ];
                if (this.props.disabled) classes.push('disabled');
                return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                    className: "btn-ctr",
                    children: /*#__PURE__*/ (0, $9HB6H.jsx)("button", {
                        onClick: this.props.callback,
                        className: classes.join(' '),
                        title: this.props.title,
                        rel: this.props.blank ? 'noopener noreferrer' : '',
                        target: this.props.blank ? '_blank' : '_self',
                        children: this.props.title
                    })
                });
            }
        }
    ]);
    return Button;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $e249995172eff126$export$2e2bcd8739ae039 = $e249995172eff126$var$Button;
$e249995172eff126$var$Button.propTypes = {
    blank: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};

});


parcelRegister("5cT1S", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return generateUID; });
$parcel$export(module.exports, "trackUser", function () { return trackUser; });
$parcel$export(module.exports, "getStorageFormKey", function () { return getStorageFormKey; });
$parcel$export(module.exports, "getSessionData", function () { return getSessionData; });
$parcel$export(module.exports, "getUID", function () { return getUID; });
$parcel$export(module.exports, "updateSessionData", function () { return updateSessionData; });
var generateUID = function generateUID() {
    var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // Handle Session Storage
    var storageKey = 'itdms_uid';
    /**
	 * this.props.track can be
	 * => 0                       => Do not track
	 * => 1                       => Track with any user ID
	 * => a string of any length  => Track with given user ID, f.e. 'sf-lka'
	 */ /**
	 * Generate new user ID if
	 * => the user should be tracked
	 * AND
	 * => there is no user ID yet |OR| there should be a custom user ID |OR| the generation is enforced
	 */ if (this.trackUser() && (!sessionStorage.getItem(storageKey) || this.props.track !== '1' || force)) {
        var UID;
        // Generate random user ID if there is no custom ID transferred
        if (this.props.track === '1') UID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        else UID = this.props.track;
        sessionStorage.setItem(storageKey, UID);
    } else if (!this.trackUser()) sessionStorage.removeItem(storageKey);
};
var trackUser = function trackUser() {
    return this.props.track !== '0';
};
var getStorageFormKey = function getStorageFormKey() {
    var htmlTag = document.querySelector('html');
    var language = 'lang' in htmlTag ? htmlTag.lang + '_' : '';
    return "itdms_v".concat(this.props.version, "_form_").concat(language).concat(this.state.id);
};
var getSessionData = function getSessionData() {
    var key = this.getStorageFormKey();
    return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : {};
};
var getUID = function getUID() {
    return sessionStorage.getItem('itdms_uid');
};
var updateSessionData = function updateSessionData() {
    var data = {
        position: this.state.position,
        userData: this.state.userData
    };
    sessionStorage.setItem(this.getStorageFormKey(), JSON.stringify(data));
};

});

parcelRegister("1DiK7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1307f8e9916ec00c$export$71511d61b312f219; });

var $fD3AT = parcelRequire("fD3AT");
function $1307f8e9916ec00c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $fD3AT._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("fD3AT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b60d49377240381a$export$71511d61b312f219; });
function $b60d49377240381a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("162UT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cc89d262cc1e43e$export$2e2bcd8739ae039; });
function $0cc89d262cc1e43e$export$2e2bcd8739ae039(t, e) {
    return $0cc89d262cc1e43e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $0cc89d262cc1e43e$export$2e2bcd8739ae039(t, e);
}

});

parcelRegister("ktpIU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee7a782d6ae8bdf8$export$2e2bcd8739ae039; });
function $ee7a782d6ae8bdf8$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("lS58v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fec2a01480a15580$export$2e2bcd8739ae039; });
function $fec2a01480a15580$export$2e2bcd8739ae039() {
    return $fec2a01480a15580$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fec2a01480a15580$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("86yTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e69f360531b4271$export$2e2bcd8739ae039; });
function $5e69f360531b4271$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("l23zI", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $f4fc8ed3a72751b9$export$a7c73072b1a182ae; }, function (v) { return $f4fc8ed3a72751b9$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f4fc8ed3a72751b9$export$9f27bc3417b4524d; }, function (v) { return $f4fc8ed3a72751b9$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f4fc8ed3a72751b9$export$db77ccec0bb4ccac; }, function (v) { return $f4fc8ed3a72751b9$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f4fc8ed3a72751b9$export$8392c0c9d3dcbd35; }, function (v) { return $f4fc8ed3a72751b9$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f4fc8ed3a72751b9$export$ffb0004e005737fa; }, function (v) { return $f4fc8ed3a72751b9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f4fc8ed3a72751b9$export$b624eff549462981; }, function (v) { return $f4fc8ed3a72751b9$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f4fc8ed3a72751b9$export$7897aa7841a5380c; }, function (v) { return $f4fc8ed3a72751b9$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f4fc8ed3a72751b9$export$602eac185826482c; }, function (v) { return $f4fc8ed3a72751b9$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f4fc8ed3a72751b9$export$e2c29f18771995cb; }, function (v) { return $f4fc8ed3a72751b9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f4fc8ed3a72751b9$export$5f8d39834fd61797; }, function (v) { return $f4fc8ed3a72751b9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f4fc8ed3a72751b9$export$74bf444e3cd11ea5; }, function (v) { return $f4fc8ed3a72751b9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $f4fc8ed3a72751b9$export$998bcd577473dd93; }, function (v) { return $f4fc8ed3a72751b9$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f4fc8ed3a72751b9$export$92387174baf9b227; }, function (v) { return $f4fc8ed3a72751b9$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f4fc8ed3a72751b9$export$ec112efeb987d9c6; }, function (v) { return $f4fc8ed3a72751b9$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f4fc8ed3a72751b9$export$b706b080d889d2c9; }, function (v) { return $f4fc8ed3a72751b9$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f4fc8ed3a72751b9$export$5be5a87408f70ddc; }, function (v) { return $f4fc8ed3a72751b9$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f4fc8ed3a72751b9$export$45a5e7f76e0caa8d; }, function (v) { return $f4fc8ed3a72751b9$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f4fc8ed3a72751b9$export$455c2e768291efa6; }, function (v) { return $f4fc8ed3a72751b9$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f4fc8ed3a72751b9$export$9522e17588c12572; }, function (v) { return $f4fc8ed3a72751b9$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f4fc8ed3a72751b9$export$2110ac352bb060b9; }, function (v) { return $f4fc8ed3a72751b9$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f4fc8ed3a72751b9$export$56885ab8b9c456ab; }, function (v) { return $f4fc8ed3a72751b9$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f4fc8ed3a72751b9$export$d927fcb6adf8f9de; }, function (v) { return $f4fc8ed3a72751b9$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f4fc8ed3a72751b9$export$b82d16f27459e05a; }, function (v) { return $f4fc8ed3a72751b9$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f4fc8ed3a72751b9$export$522c17b4f5e123e8; }, function (v) { return $f4fc8ed3a72751b9$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f4fc8ed3a72751b9$export$1aabd8a0274ecfd6; }, function (v) { return $f4fc8ed3a72751b9$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $f4fc8ed3a72751b9$export$3d6c20d97e46b957; }, function (v) { return $f4fc8ed3a72751b9$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f4fc8ed3a72751b9$export$9b621391a187a31a; }, function (v) { return $f4fc8ed3a72751b9$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f4fc8ed3a72751b9$export$f5bbd400c2f4426f; }, function (v) { return $f4fc8ed3a72751b9$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $f4fc8ed3a72751b9$export$a7c73072b1a182ae;
var $f4fc8ed3a72751b9$export$9f27bc3417b4524d;
var $f4fc8ed3a72751b9$export$db77ccec0bb4ccac;
var $f4fc8ed3a72751b9$export$8392c0c9d3dcbd35;
var $f4fc8ed3a72751b9$export$ffb0004e005737fa;
var $f4fc8ed3a72751b9$export$b624eff549462981;
var $f4fc8ed3a72751b9$export$7897aa7841a5380c;
var $f4fc8ed3a72751b9$export$602eac185826482c;
var $f4fc8ed3a72751b9$export$e2c29f18771995cb;
var $f4fc8ed3a72751b9$export$5f8d39834fd61797;
var $f4fc8ed3a72751b9$export$74bf444e3cd11ea5;
var $f4fc8ed3a72751b9$export$998bcd577473dd93;
var $f4fc8ed3a72751b9$export$92387174baf9b227;
var $f4fc8ed3a72751b9$export$ec112efeb987d9c6;
var $f4fc8ed3a72751b9$export$b706b080d889d2c9;
var $f4fc8ed3a72751b9$export$5be5a87408f70ddc;
var $f4fc8ed3a72751b9$export$45a5e7f76e0caa8d;
var $f4fc8ed3a72751b9$export$455c2e768291efa6;
var $f4fc8ed3a72751b9$export$9522e17588c12572;
var $f4fc8ed3a72751b9$export$2110ac352bb060b9;
var $f4fc8ed3a72751b9$export$56885ab8b9c456ab;
var $f4fc8ed3a72751b9$export$d927fcb6adf8f9de;
var $f4fc8ed3a72751b9$export$b82d16f27459e05a;
var $f4fc8ed3a72751b9$export$522c17b4f5e123e8;
var $f4fc8ed3a72751b9$export$1aabd8a0274ecfd6;
var $f4fc8ed3a72751b9$export$3d6c20d97e46b957;
var $f4fc8ed3a72751b9$export$9b621391a187a31a;
var $f4fc8ed3a72751b9$export$f5bbd400c2f4426f;
'use strict';
var $f4fc8ed3a72751b9$var$b = Symbol.for("react.element"), $f4fc8ed3a72751b9$var$c = Symbol.for("react.portal"), $f4fc8ed3a72751b9$var$d = Symbol.for("react.fragment"), $f4fc8ed3a72751b9$var$e = Symbol.for("react.strict_mode"), $f4fc8ed3a72751b9$var$f = Symbol.for("react.profiler"), $f4fc8ed3a72751b9$var$g = Symbol.for("react.provider"), $f4fc8ed3a72751b9$var$h = Symbol.for("react.context"), $f4fc8ed3a72751b9$var$k = Symbol.for("react.server_context"), $f4fc8ed3a72751b9$var$l = Symbol.for("react.forward_ref"), $f4fc8ed3a72751b9$var$m = Symbol.for("react.suspense"), $f4fc8ed3a72751b9$var$n = Symbol.for("react.suspense_list"), $f4fc8ed3a72751b9$var$p = Symbol.for("react.memo"), $f4fc8ed3a72751b9$var$q = Symbol.for("react.lazy"), $f4fc8ed3a72751b9$var$t = Symbol.for("react.offscreen"), $f4fc8ed3a72751b9$var$u;
$f4fc8ed3a72751b9$var$u = Symbol.for("react.module.reference");
function $f4fc8ed3a72751b9$var$v(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $f4fc8ed3a72751b9$var$b:
                switch(a = a.type, a){
                    case $f4fc8ed3a72751b9$var$d:
                    case $f4fc8ed3a72751b9$var$f:
                    case $f4fc8ed3a72751b9$var$e:
                    case $f4fc8ed3a72751b9$var$m:
                    case $f4fc8ed3a72751b9$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f4fc8ed3a72751b9$var$k:
                            case $f4fc8ed3a72751b9$var$h:
                            case $f4fc8ed3a72751b9$var$l:
                            case $f4fc8ed3a72751b9$var$q:
                            case $f4fc8ed3a72751b9$var$p:
                            case $f4fc8ed3a72751b9$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $f4fc8ed3a72751b9$var$c:
                return r;
        }
    }
}
$f4fc8ed3a72751b9$export$a7c73072b1a182ae = $f4fc8ed3a72751b9$var$h;
$f4fc8ed3a72751b9$export$9f27bc3417b4524d = $f4fc8ed3a72751b9$var$g;
$f4fc8ed3a72751b9$export$db77ccec0bb4ccac = $f4fc8ed3a72751b9$var$b;
$f4fc8ed3a72751b9$export$8392c0c9d3dcbd35 = $f4fc8ed3a72751b9$var$l;
$f4fc8ed3a72751b9$export$ffb0004e005737fa = $f4fc8ed3a72751b9$var$d;
$f4fc8ed3a72751b9$export$b624eff549462981 = $f4fc8ed3a72751b9$var$q;
$f4fc8ed3a72751b9$export$7897aa7841a5380c = $f4fc8ed3a72751b9$var$p;
$f4fc8ed3a72751b9$export$602eac185826482c = $f4fc8ed3a72751b9$var$c;
$f4fc8ed3a72751b9$export$e2c29f18771995cb = $f4fc8ed3a72751b9$var$f;
$f4fc8ed3a72751b9$export$5f8d39834fd61797 = $f4fc8ed3a72751b9$var$e;
$f4fc8ed3a72751b9$export$74bf444e3cd11ea5 = $f4fc8ed3a72751b9$var$m;
$f4fc8ed3a72751b9$export$998bcd577473dd93 = $f4fc8ed3a72751b9$var$n;
$f4fc8ed3a72751b9$export$92387174baf9b227 = function() {
    return !1;
};
$f4fc8ed3a72751b9$export$ec112efeb987d9c6 = function() {
    return !1;
};
$f4fc8ed3a72751b9$export$b706b080d889d2c9 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$h;
};
$f4fc8ed3a72751b9$export$5be5a87408f70ddc = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$g;
};
$f4fc8ed3a72751b9$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && a.$$typeof === $f4fc8ed3a72751b9$var$b;
};
$f4fc8ed3a72751b9$export$455c2e768291efa6 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$l;
};
$f4fc8ed3a72751b9$export$9522e17588c12572 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$d;
};
$f4fc8ed3a72751b9$export$2110ac352bb060b9 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$q;
};
$f4fc8ed3a72751b9$export$56885ab8b9c456ab = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$p;
};
$f4fc8ed3a72751b9$export$d927fcb6adf8f9de = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$c;
};
$f4fc8ed3a72751b9$export$b82d16f27459e05a = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$f;
};
$f4fc8ed3a72751b9$export$522c17b4f5e123e8 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$e;
};
$f4fc8ed3a72751b9$export$1aabd8a0274ecfd6 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$m;
};
$f4fc8ed3a72751b9$export$3d6c20d97e46b957 = function(a) {
    return $f4fc8ed3a72751b9$var$v(a) === $f4fc8ed3a72751b9$var$n;
};
$f4fc8ed3a72751b9$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f4fc8ed3a72751b9$var$d || a === $f4fc8ed3a72751b9$var$f || a === $f4fc8ed3a72751b9$var$e || a === $f4fc8ed3a72751b9$var$m || a === $f4fc8ed3a72751b9$var$n || a === $f4fc8ed3a72751b9$var$t || "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && (a.$$typeof === $f4fc8ed3a72751b9$var$q || a.$$typeof === $f4fc8ed3a72751b9$var$p || a.$$typeof === $f4fc8ed3a72751b9$var$g || a.$$typeof === $f4fc8ed3a72751b9$var$h || a.$$typeof === $f4fc8ed3a72751b9$var$l || a.$$typeof === $f4fc8ed3a72751b9$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$f4fc8ed3a72751b9$export$f5bbd400c2f4426f = $f4fc8ed3a72751b9$var$v;

});

parcelRegister("hiya6", function(module, exports) {

$parcel$export(module.exports, "handleChange", function () { return handleChange; });
$parcel$export(module.exports, "handleSliderChange", function () { return handleSliderChange; });
$parcel$export(module.exports, "afterChangeHandled", function () { return afterChangeHandled; });

var $kWfK0 = parcelRequire("kWfK0");
var handleChange = function handleChange(event) {
    var t = event.target;
    var q = this.state.slides[this.state.position];
    var userData = (0, $kWfK0._)({}, this.state.userData);
    var includeInScore = this.state.dimensions[q.dimension].include_in_score;
    if (!(q.dimension in userData.dimensions)) userData.dimensions[q.dimension] = {
        results: {}
    };
    var results = (0, $kWfK0._)({}, userData.dimensions[q.dimension].results);
    var answers;
    if (t.type === 'radio') answers = parseInt(t.id);
    else if (t.type === 'checkbox') {
        var answerIndex = parseInt(t.id);
        answers = q.ID in results ? results[q.ID].answers : [];
        // Get exclusive answers
        var exclusiveAnswers = [];
        q.answers.forEach(function(answer, i) {
            if (answer.exclusive) exclusiveAnswers.push(i);
        });
        if (t.checked) {
            // Checkbox is checked
            if (exclusiveAnswers.includes(answerIndex)) // is an exclusive answer
            answers = [
                answerIndex
            ];
            else {
                // is not an exclusive answer
                // uncheck all exclusive answers
                exclusiveAnswers.forEach(function(i) {
                    if (answers.includes(i)) answers.splice(answers.indexOf(i), 1);
                });
                // push answer to answers array
                answers.push(answerIndex);
            }
        } else if (answers.indexOf(answerIndex) !== -1) {
            // Checkbox is not checked and unchecked box still exists in the answers array
            answers.splice(answers.indexOf(answerIndex), 1);
            // If no answer is selected set answers to false to remove it from the results list
            if (!answers.length) answers = false;
        }
    } else if (t.type === 'text') answers = t.value.length ? parseInt(t.value) : false;
    if (answers !== false) {
        results[q.ID] = {
            answers: answers
        };
        if (includeInScore) results[q.ID].score = this.getQuestionScore(answers);
    } else delete results[q.ID];
    userData.dimensions[q.dimension].results = results;
    this.afterChangeHandled(userData);
};
var handleSliderChange = function handleSliderChange(value) {
    var q = this.state.slides[this.state.position];
    var userData = (0, $kWfK0._)({}, this.state.userData);
    var includeInScore = this.state.dimensions[q.dimension].include_in_score;
    if (!(q.dimension in userData.dimensions)) userData.dimensions[q.dimension] = {
        results: {}
    };
    var results = (0, $kWfK0._)({}, userData.dimensions[q.dimension].results);
    if (q.scale_options.type === 'percentage') {
        var i = 0;
        for(var key in q.answers){
            var answer = q.answers[key];
            if (value >= answer.min && value <= answer.max) {
                results[q.ID] = {
                    answers: value,
                    answerIndex: i
                };
                if (includeInScore) results[q.ID].score = answer.value;
                break;
            }
            i++;
        }
    } else if (q.scale_options.type === 'fixed') {
        var steps = 100 / (Object.keys(q.answers).length - 1);
        for(var i1 = 0; i1 < steps; i1++)if (value === steps * i1) {
            results[q.ID] = {
                answers: i1
            };
            if (includeInScore) results[q.ID].score = q.answers[i1].value;
            break;
        }
    }
    userData.dimensions[q.dimension].results = results;
    this.afterChangeHandled(userData);
};
var afterChangeHandled = function afterChangeHandled(userData) {
    this.setState({
        userData: userData
    }, this.calcUserScore);
};

});

parcelRegister("6jIiv", function(module, exports) {

$parcel$export(module.exports, "getQuestionScore", function () { return getQuestionScore; });
$parcel$export(module.exports, "calcUserScore", function () { return calcUserScore; });
$parcel$export(module.exports, "calcDimensionScore", function () { return calcDimensionScore; });
$parcel$export(module.exports, "calcTotalScore", function () { return calcTotalScore; });

var $6tY97 = parcelRequire("6tY97");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");
var getQuestionScore = function getQuestionScore(chosenAnswers) {
    var slide = this.state.slides[this.state.position];
    var score = 0;
    if (Array.isArray(chosenAnswers)) chosenAnswers.forEach(function(answerKey) {
        score += slide.answers[answerKey].value;
    });
    else score = slide.answers[chosenAnswers].value;
    return score;
};
var calcUserScore = function calcUserScore() {
    var state = this.state;
    // Only recalculate score if question is inside a dimension that is included in the total score
    if (state.dimensions[state.slides[state.position].dimension].include_in_score) this.calcDimensionScore(this.calcTotalScore);
};
var calcDimensionScore = function calcDimensionScore(callback) {
    var d = this.state.slides[this.state.position].dimension;
    var dimensionResults = (0, $kWfK0._)({}, this.state.userData.dimensions[d].results);
    // Only calculate score of dimension if all its questions are answered
    if (Object.keys(dimensionResults).length === this.state.dimensions[d].question_count) {
        var pointsInDimension = 0;
        for(var i in dimensionResults)pointsInDimension += dimensionResults[i].score;
        // Calculate final score as ratio
        var dimensionScore = Math.round(pointsInDimension / this.state.dimensions[d].max_score * 100);
        this.setState({
            userData: (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData), {
                dimensions: (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData.dimensions), (0, $6tY97._)({}, d, (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData.dimensions[d]), {
                    score: dimensionScore
                })))
            })
        }, callback);
    // Remove dimension score and total score if not all questions in the dimension are answered
    } else this.setState({
        userData: (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData), {
            dimensions: (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData.dimensions), (0, $6tY97._)({}, d, (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData.dimensions[d]), {
                score: false
            }))),
            score: false
        })
    });
};
var calcTotalScore = function calcTotalScore() {
    var dimensions = this.state.dimensions;
    var dimensionScores = [];
    var score = false;
    for(var d in dimensions)// Check if dimension should be included for total score calculation
    if (dimensions[d].include_in_score) {
        // Check if dimension exists in user data and has a valid score, otherwise reset score to false
        if (d in this.state.userData.dimensions && this.state.userData.dimensions[d].score !== false) dimensionScores.push(this.state.userData.dimensions[d].score);
        else {
            dimensionScores = [];
            break;
        }
    }
    if (dimensionScores.length) score = Math.round(dimensionScores.reduce(function(previousValue, currentValue) {
        return previousValue + currentValue;
    }) / dimensionScores.length);
    this.setState({
        userData: (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData), {
            score: score
        })
    });
};

});


var $9HB6H = parcelRequire("9HB6H");

var $kwI20 = parcelRequire("kwI20");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $7c6n8 = parcelRequire("7c6n8");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $7c6n8 = parcelRequire("7c6n8");
var $8c2278b994218bcc$var$ProgressBar = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(ProgressBar, _React_Component);
    function ProgressBar(props) {
        (0, $4QweW._)(this, ProgressBar);
        var _this;
        _this = (0, $ehF45._)(this, ProgressBar, [
            props
        ]);
        _this.getDimensionDots = (0, $7c6n8.getDimensionDots).bind(_this);
        return _this;
    }
    (0, $6hK4i._)(ProgressBar, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, progress = _this_props.progress, callback = _this_props.callback, resultsSlide = _this_props.resultsSlide;
                return progress && /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "ms-form__progress",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                            className: "progress__label",
                            children: 'label' in progress && progress.label
                        }),
                        !isNaN(progress.handle) && /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                            className: "progress__bar",
                            style: {
                                '--progress': "".concat(progress.handle, "%")
                            },
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                                    className: "progress__bar-dots",
                                    children: [
                                        this.getDimensionDots().map(function(dot) {
                                            return dot;
                                        }),
                                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                            className: "dot".concat(progress.handle == 100 ? ' done' : ''),
                                            onClick: function() {
                                                return callback(resultsSlide);
                                            }
                                        }, "success")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                    className: "progress__bar-handle"
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ProgressBar;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $8c2278b994218bcc$export$2e2bcd8739ae039 = $8c2278b994218bcc$var$ProgressBar;
$8c2278b994218bcc$var$ProgressBar.propTypes = {
    resultsSlide: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object
    ]),
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func
};


var $242be4aa1e7f6b6f$var$Navigation = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Navigation, _React_Component);
    function Navigation(props) {
        (0, $4QweW._)(this, Navigation);
        var _this;
        _this = (0, $ehF45._)(this, Navigation, [
            props
        ]);
        _this.showLeftNavButton = (0, $7c6n8.showLeftNavButton).bind(_this);
        _this.showRightNavButton = (0, $7c6n8.showRightNavButton).bind(_this);
        _this.isNextBtnDisabled = (0, $7c6n8.isNextBtnDisabled).bind(_this);
        return _this;
    }
    (0, $6hK4i._)(Navigation, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, resultsSlide = _this_props.resultsSlide, dimensions = _this_props.dimensions, progress = _this_props.progress, goToSlideCallback = _this_props.goToSlideCallback;
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "ms-form__nav",
                    "data-color-scheme": "highlight",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "left",
                            children: this.showLeftNavButton()
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "center",
                            children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $8c2278b994218bcc$export$2e2bcd8739ae039), {
                                resultsSlide: resultsSlide,
                                dimensions: dimensions,
                                progress: progress,
                                callback: goToSlideCallback
                            })
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "right",
                            children: this.showRightNavButton()
                        })
                    ]
                });
            }
        }
    ]);
    return Navigation;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $242be4aa1e7f6b6f$export$2e2bcd8739ae039 = $242be4aa1e7f6b6f$var$Navigation;
$242be4aa1e7f6b6f$var$Navigation.propTypes = {
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    goToSlideCallback: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object
    ]),
    resultsSlide: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $kWfK0 = parcelRequire("kWfK0");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");
function $73011f57c5b199c6$export$2e2bcd8739ae039(param) {
    var tile_content = param.tile_content;
    var _$_object_spread = (0, $kWfK0._)({}, tile_content), name = _$_object_spread.name, image = _$_object_spread.image, desc = _$_object_spread.desc, link = _$_object_spread.link, link_type = _$_object_spread.link_type, link_text = _$_object_spread.link_text;
    return /*#__PURE__*/ (0, $9HB6H.jsx)("a", {
        href: link,
        target: "_blank",
        rel: "noreferrer",
        title: link_text,
        className: "tile tile--image-size-regular",
        "data-link-type": link_type,
        children: /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
            className: "tile__container",
            children: [
                /*#__PURE__*/ (0, $9HB6H.jsxs)("header", {
                    className: "tile__header",
                    children: [
                        image && /*#__PURE__*/ (0, $9HB6H.jsx)("img", {
                            src: image,
                            alt: name
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                            className: "h6",
                            children: name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                    className: "tile__content",
                    children: /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                        children: desc
                    })
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)("footer", {
                    className: "tile__footer"
                })
            ]
        })
    });
}
$73011f57c5b199c6$export$2e2bcd8739ae039.propTypes = {
    tile_content: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object
};



var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");
var $40949a42b0e934f1$export$a0e4cd1069957a24 = function getStageRecommendations() {
    var _this_props = this.props, dimensions = _this_props.dimensions, userData = _this_props.userData, highscoreContent = _this_props.highscoreContent;
    /**
	 * 1. Classify the result of the dimension in stage
	 */ var userStages = {};
    Object.keys(userData.dimensions).map(function(d) {
        // Make sure a score for the dimension exists
        if ('score' in userData.dimensions[d] && userData.dimensions[d].score !== false) {
            var score = userData.dimensions[d].score;
            // If any stage exists in this dimension check in which stage the user has reached with his score
            var stages = dimensions[d].stages;
            if (stages.length) for(var i = 0; i < stages.length; i++){
                // Divides the number of existing stages into steps of equal size and determines the upper limit for the current stage
                var upperStageLimit = 100 / (stages.length + 1) * (i + 1);
                if (score <= upperStageLimit) {
                    // Check if score is smaller than the upper stage limit
                    userStages[d] = {
                        index: i,
                        ratio: (i + 1) / (stages.length + 1)
                    };
                    break;
                } else if (i === stages.length - 1) // If the score was always higher than the previous stage limits it must be in the highest stage
                userStages[d] = {
                    ratio: 1
                };
            }
        }
    });
    // Only continue if any dimension score could be classified in a stage
    if (!Object.keys(userStages).length) return {};
    /**
	 * 2. Check in which dimension the user is in the lowest stage
	 */ var highestStageValue = 1, lowStageDimensions = [];
    for(var dimension in userStages){
        var value = userStages[dimension].ratio;
        var obj = {
            dimension: dimension,
            priority: dimensions[dimension].priority
        };
        // Check if value if lower than the currently set highest value
        if (value < highestStageValue) {
            highestStageValue = value;
            lowStageDimensions = [
                obj
            ];
        } else if (value === highestStageValue) lowStageDimensions.push(obj);
    }
    /**
	 * 3. Return the recommendations from this stage / If the user is already in the highest stage return the highscore text
	 */ if (highestStageValue === 1) // User is in the highest stage in all dimensions
    // Return the highscore recommendation object
    return highscoreContent;
    else {
        // There is a single lowest stage of all dimensions
        // OR there are multiple stages that are equally low (potentially all stages even have the same value)
        var d = lowStageDimensions[0].dimension;
        if (lowStageDimensions.length > 1) {
            // Check the dimension's priorities.
            // Hint: If there are multiple dimensions with equally high priorities the recommendation will be delivered from the first dimension in the loop
            var maxPriority = 0;
            lowStageDimensions.forEach(function(obj, i) {
                if (obj.priority > maxPriority) {
                    d = lowStageDimensions[i].dimension;
                    maxPriority = obj.priority;
                }
            });
        }
        return dimensions[d].stages[userStages[d].index];
    }
};
var $40949a42b0e934f1$export$b141de964f0a90c1 = function getRandomInt(max) {
    return Math.floor(Math.random() * max);
};
var $40949a42b0e934f1$export$52411745da118fc8 = function getContact() {
    var _this_props = this.props, contacts = _this_props.contacts, userData = _this_props.userData;
    if ('contact' in userData) return userData.contact in contacts ? contacts[userData.contact] : false;
    else {
        var length = Object.keys(contacts).length;
        if (!length) // There are no contacts to show so immediately return
        return false;
        else if (length > 1) {
            // Choose any contact by random and save it in the userData
            var randomKey = Object.keys(contacts)[$40949a42b0e934f1$export$b141de964f0a90c1(length)];
            this.props.updateUserContact(randomKey);
            return contacts[randomKey];
        } else // Return the only contact
        return contacts[Object.keys(contacts)[0]];
    }
};
var $40949a42b0e934f1$export$56eb8157210847c9 = function updateUserContact(contactKey) {
    this.setState({
        userData: (0, $hApvp._)((0, $kWfK0._)({}, this.state.userData), {
            contact: contactKey
        })
    });
};


var $429e62a3d31a56cf$export$35062f12cb0d3a15 = function getRecommendedContent() {
    var _this_props = this.props, score_recommendations = _this_props.recommended_content, userData = _this_props.userData, slides = _this_props.slides;
    var contents = [];
    /**
	 * 1. Score Based Recommended Content
	 */ if (score_recommendations) {
        if (score_recommendations.length > 1) // Get the recommendation based on the user's score
        for(var i = 0; i < score_recommendations.length; i++){
            var upperLimit = 100 / score_recommendations.length * (i + 1);
            if (userData.score < upperLimit) {
                contents.push(score_recommendations[i]);
                break;
            }
        }
        else // Add the one and only recommended content
        contents.push(score_recommendations[0]);
    }
    /**
	 * 2. Answer Based Recommended Content
	 */ var answer_recommendations = [];
    Object.keys(userData.dimensions).map(function(d) {
        Object.keys(userData.dimensions[d].results).map(function(id) {
            // Get the related slide for the question with the current ID
            var slide = slides[slides.indexOf(slides.filter(function(s) {
                return s.ID === parseInt(id);
            })[0])];
            // Get the selected answer(s)
            var selection;
            if (slide.input_type === 'scale' && slide.scale_options.type === 'percentage') // Exception for percentage scales, since the 'answers' key doesn't represent the answer index but the absolute slider value
            selection = userData.dimensions[d].results[id].answerIndex;
            else selection = userData.dimensions[d].results[id].answers;
            // Convert number to array to make it 'loopable'
            if (Number.isInteger(selection)) selection = [
                selection
            ];
            // Check if there are any recommendations for each given answer
            selection.forEach(function(value) {
                if (slide.answers[value].recommended_content) answer_recommendations.push(slide.answers[value].recommended_content);
            });
        });
    });
    if (answer_recommendations.length) // If there are multiple answer based recommendations choose a single recommendation by random
    contents.push(answer_recommendations.length > 1 ? answer_recommendations[(0, $40949a42b0e934f1$export$b141de964f0a90c1)(answer_recommendations.length)] : answer_recommendations[0]);
    return contents;
};



var $5cT1S = parcelRequire("5cT1S");
var $e16ad2ef1a7f9b40$var$NextSteps = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(NextSteps, _React_Component);
    function NextSteps(props) {
        (0, $4QweW._)(this, NextSteps);
        var _this;
        _this = (0, $ehF45._)(this, NextSteps, [
            props
        ]), (0, $6tY97._)(_this, "componentDidMount", function() {
            var _this_props = _this.props, dimensions = _this_props.dimensions, userData = _this_props.userData;
            /**
		 * Handle HubSpot form data
		 */ var wrapper = document.querySelector('.maturity-score');
            var hiddenFormMeta = {
                uid: 'input[name="itdms_uid"]',
                score: 'input[name="itdms_score"]',
                dimension: 'input[name="itdms_dimension"]'
            };
            if ((0, $5cT1S.getUID)() && wrapper.querySelector(hiddenFormMeta.uid)) wrapper.querySelector(hiddenFormMeta.uid).value = (0, $5cT1S.getUID)();
            if ('score' in userData && wrapper.querySelector(hiddenFormMeta.score)) wrapper.querySelector(hiddenFormMeta.score).value = userData.score;
            if (wrapper.querySelector(hiddenFormMeta.dimension)) {
                var dimensionScores = [];
                Object.keys(userData.dimensions).map(function(key) {
                    if (dimensions[key].include_in_score) dimensionScores.push("".concat(dimensions[key].name, ": ").concat(userData.dimensions[key].score));
                });
                wrapper.querySelector(hiddenFormMeta.dimension).value = dimensionScores.join('\n');
            }
        });
        _this.getRecommendedContent = $429e62a3d31a56cf$export$35062f12cb0d3a15.bind(_this);
        return _this;
    }
    (0, $6hK4i._)(NextSteps, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, headline = _this_props.headline, subline = _this_props.subline, custom_content = _this_props.custom_content;
                var recommendations = this.getRecommendedContent();
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "ms-form__next",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsx)("h2", {
                            children: headline
                        }),
                        subline && /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                            children: subline
                        }),
                        recommendations && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "tile-grid",
                            "data-row-elms": "4",
                            children: Object.keys(recommendations).map(function(key) {
                                var rec = recommendations[key];
                                var tile_content = {
                                    name: rec.title,
                                    desc: rec.link_text,
                                    link_type: rec.link_type,
                                    link: rec.link,
                                    image: rec.image
                                };
                                return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $73011f57c5b199c6$export$2e2bcd8739ae039), {
                                    tile_content: tile_content
                                }, key);
                            })
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "ms-form__custom-content",
                            dangerouslySetInnerHTML: {
                                __html: custom_content
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return NextSteps;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $e16ad2ef1a7f9b40$export$2e2bcd8739ae039 = $e16ad2ef1a7f9b40$var$NextSteps;
$e16ad2ef1a7f9b40$var$NextSteps.propTypes = {
    custom_content: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    headline: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    slides: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).any,
    subline: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");
var $32fed3bba8842c5f$var$Image = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Image, _React_Component);
    function Image() {
        (0, $4QweW._)(this, Image);
        return (0, $ehF45._)(this, Image, arguments);
    }
    (0, $6hK4i._)(Image, [
        {
            key: "render",
            value: function render() {
                var image = this.props.image;
                return /*#__PURE__*/ (0, $9HB6H.jsx)("img", {
                    src: 'large' in image.sizes ? image.sizes.large.url : image.url,
                    alt: ""
                });
            }
        }
    ]);
    return Image;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $32fed3bba8842c5f$export$2e2bcd8739ae039 = $32fed3bba8842c5f$var$Image;
$32fed3bba8842c5f$var$Image.propTypes = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");
var $427009064b9728dc$var$Dropdown = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Dropdown, _React_Component);
    function Dropdown(props) {
        (0, $4QweW._)(this, Dropdown);
        var _this;
        _this = (0, $ehF45._)(this, Dropdown, [
            props
        ]), (0, $6tY97._)(_this, "toggleSelect", function() {
            _this.setState({
                active: !_this.state.active
            });
        }), (0, $6tY97._)(_this, "changeOption", function(key, label) {
            _this.selectRef.current.innerHTML = label;
            _this.input.current.value = parseInt(key);
            _this.input.current.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        });
        _this.state = {
            active: false
        };
        _this.selectRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createRef();
        _this.input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createRef();
        return _this;
    }
    (0, $6hK4i._)(Dropdown, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, name = _this_props.name, options = _this_props.options, defaultValue = _this_props.defaultValue, placeholder = _this_props.placeholder, handleChange = _this_props.handleChange;
                var selectValues = [];
                Object.keys(options).map(function(key) {
                    return selectValues.push(options[key].label);
                });
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: 'dropdown' + (this.state.active ? ' active' : ''),
                    onClick: function(e) {
                        return _this.toggleSelect(e);
                    },
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                            className: "dropdown__select",
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                    ref: this.selectRef,
                                    children: defaultValue !== false ? selectValues[defaultValue] : placeholder
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsx)("i", {
                                    className: "select__icon"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("ul", {
                            className: "dropdown__menu",
                            children: Object.keys(options).map(function(key) {
                                return /*#__PURE__*/ (0, $9HB6H.jsx)("li", {
                                    className: defaultValue === parseInt(key) ? 'active' : '',
                                    onClick: function() {
                                        return _this.changeOption(key, options[key].label);
                                    },
                                    children: options[key].label
                                }, "option_".concat(key));
                            })
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("input", {
                            type: "text",
                            ref: this.input,
                            name: name,
                            onInput: handleChange,
                            value: defaultValue
                        })
                    ]
                });
            }
        }
    ]);
    return Dropdown;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $427009064b9728dc$export$2e2bcd8739ae039 = $427009064b9728dc$var$Dropdown;
$427009064b9728dc$var$Dropdown.propTypes = {
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number
    ]),
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).array,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");
var $2d3b2531d0e2536f$var$Radio = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Radio, _React_Component);
    function Radio() {
        (0, $4QweW._)(this, Radio);
        return (0, $ehF45._)(this, Radio, arguments);
    }
    (0, $6hK4i._)(Radio, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, id = _this_props.id, name = _this_props.name, title = _this_props.title, checked = _this_props.checked, handleChange = _this_props.handleChange;
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "input",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsx)("label", {
                            htmlFor: id,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("input", {
                            type: "radio",
                            name: name,
                            id: id,
                            onChange: handleChange,
                            defaultChecked: checked
                        })
                    ]
                });
            }
        }
    ]);
    return Radio;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $2d3b2531d0e2536f$export$2e2bcd8739ae039 = $2d3b2531d0e2536f$var$Radio;
$2d3b2531d0e2536f$var$Radio.propTypes = {
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");
function $ea75824a91acdfa9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ea75824a91acdfa9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ea75824a91acdfa9$export$2e2bcd8739ae039(o);
}



function $d733a5f580890cbe$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $63b4cdf407511a16$export$2e2bcd8739ae039(t) {
    var i = (0, $d733a5f580890cbe$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $0708e163b377474d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $63b4cdf407511a16$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $1b1211ceaac608a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b1211ceaac608a8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b1211ceaac608a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0708e163b377474d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b1211ceaac608a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $4b052c91de22d3b4$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $6a9eef385d5795e7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $63b4cdf407511a16$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $6a9eef385d5795e7$export$2e2bcd8739ae039(e, r, t) {
    return r && $6a9eef385d5795e7$var$_defineProperties(e.prototype, r), t && $6a9eef385d5795e7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $162UT = parcelRequire("162UT");
function $bd1a2e8407b8d15a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $162UT.default)(t, e);
}


function $b98d55ebe91acf48$export$2e2bcd8739ae039(t) {
    return $b98d55ebe91acf48$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $b98d55ebe91acf48$export$2e2bcd8739ae039(t);
}


function $e0127bcf9f2bdf65$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e0127bcf9f2bdf65$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




var $ktpIU = parcelRequire("ktpIU");
function $0451d10dfa531943$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $ktpIU.default)(t);
}


function $ac06abbc181c1025$export$2e2bcd8739ae039(t) {
    var r = (0, $e0127bcf9f2bdf65$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $b98d55ebe91acf48$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $b98d55ebe91acf48$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $0451d10dfa531943$export$2e2bcd8739ae039)(this, e);
    };
}



var $iD6kw = parcelRequire("iD6kw");
/* eslint-disable no-console */ var $119894c7f6ed90f3$var$warned = {};
var $119894c7f6ed90f3$var$preWarningFns = [];
var $119894c7f6ed90f3$export$61616f168f0e5a05 = function preMessage(fn) {
    $119894c7f6ed90f3$var$preWarningFns.push(fn);
};
function $119894c7f6ed90f3$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $119894c7f6ed90f3$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $119894c7f6ed90f3$export$60eef1277fe463e4() {
    $119894c7f6ed90f3$var$warned = {};
}
function $119894c7f6ed90f3$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$119894c7f6ed90f3$var$warned[message]) {
        method(false, message);
        $119894c7f6ed90f3$var$warned[message] = true;
    }
}
function $119894c7f6ed90f3$export$82934adf09101657(valid, message) {
    $119894c7f6ed90f3$export$848feb93d8f32b9b($119894c7f6ed90f3$export$491112666e282270, valid, message);
}
function $119894c7f6ed90f3$export$89ff31684837bbbf(valid, message) {
    $119894c7f6ed90f3$export$848feb93d8f32b9b($119894c7f6ed90f3$export$a92e4c44d367d0af, valid, message);
}
$119894c7f6ed90f3$export$82934adf09101657.preMessage = $119894c7f6ed90f3$export$61616f168f0e5a05;
$119894c7f6ed90f3$export$82934adf09101657.resetWarned = $119894c7f6ed90f3$export$60eef1277fe463e4;
$119894c7f6ed90f3$export$82934adf09101657.noteOnce = $119894c7f6ed90f3$export$89ff31684837bbbf;
var $119894c7f6ed90f3$export$2e2bcd8739ae039 = $119894c7f6ed90f3$export$82934adf09101657;





var $iD6kw = parcelRequire("iD6kw");
var $775f0ad0d2139b6b$var$Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, style = props.style;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        offset = 100 - offset;
    }
    var positonStyle = vertical ? (_ref = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref2, "width", "".concat(length, "%")), _ref2);
    var elStyle = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, style), positonStyle);
    return included ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
var $775f0ad0d2139b6b$export$2e2bcd8739ae039 = $775f0ad0d2139b6b$var$Track;



var $lS58v = parcelRequire("lS58v");

var $86yTs = parcelRequire("86yTs");
function $2dac754b4e590c46$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $86yTs.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}




function $da15e081549872e8$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $7aec61d56f405229$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $da15e081549872e8$export$2e2bcd8739ae039)(r);
}


function $40e77fe90a4faa9f$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $dcc812bcb39bc9be$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $da15e081549872e8$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $da15e081549872e8$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $e4b89f59dcbda4a5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4944783056626d64$export$2e2bcd8739ae039(r) {
    return (0, $7aec61d56f405229$export$2e2bcd8739ae039)(r) || (0, $40e77fe90a4faa9f$export$2e2bcd8739ae039)(r) || (0, $dcc812bcb39bc9be$export$2e2bcd8739ae039)(r) || (0, $e4b89f59dcbda4a5$export$2e2bcd8739ae039)();
}





function $f4e6c3c737c84524$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $b98d55ebe91acf48$export$2e2bcd8739ae039)(t)););
    return t;
}


function $615034f7210a91b8$export$2e2bcd8739ae039() {
    return $615034f7210a91b8$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function _get(e, t, r) {
        var p = (0, $f4e6c3c737c84524$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $615034f7210a91b8$export$2e2bcd8739ae039.apply(null, arguments);
}






var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");
function $45d8c47bc91d25b5$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($kqzqZ))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kqzqZ))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


var $902038315dedde89$exports = {};

var $5djcY = parcelRequire("5djcY");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if ((typeof arg === "undefined" ? "undefined" : (0, $5djcY._)(arg)) !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($902038315dedde89$exports) {
        classNames.default = classNames;
        $902038315dedde89$exports = classNames;
    } else if (typeof define === 'function' && (0, $5djcY._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $iD6kw = parcelRequire("iD6kw");


var $10c4f4a83e9dee46$var$calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, $119894c7f6ed90f3$export$2e2bcd8739ae039)(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var $10c4f4a83e9dee46$var$Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = $10c4f4a83e9dee46$var$calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)({}, reverse ? 'top' : 'bottom', offset)) : (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)({}, reverse ? 'right' : 'left', offset));
        if (isActived) style = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, style), activeDotStyle);
        var pointClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))((_classNames = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), true), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, elements);
};
var $10c4f4a83e9dee46$export$2e2bcd8739ae039 = $10c4f4a83e9dee46$var$Steps;






var $iD6kw = parcelRequire("iD6kw");

var $1d6d53f325a4b603$var$Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(markPoint) === 'object' && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))((_classNames = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text"), true), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
        var bottomStyle = (0, $0708e163b377474d$export$2e2bcd8739ae039)({
            marginBottom: '-50%'
        }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));
        var leftStyle = (0, $0708e163b377474d$export$2e2bcd8739ae039)({
            transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
            msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
        }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, style), markPoint.style) : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("div", {
        className: className
    }, elements);
};
var $1d6d53f325a4b603$export$2e2bcd8739ae039 = $1d6d53f325a4b603$var$Marks;



var $lS58v = parcelRequire("lS58v");








var $iD6kw = parcelRequire("iD6kw");


var $92406aaedd12d98a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(Handle, _React$Component);
    var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(Handle);
    function Handle() {
        var _this;
        (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, Handle);
        _this = _super.apply(this, arguments);
        _this.state = {
            clickFocused: false
        };
        _this.setHandleRef = function(node) {
            _this.handle = node;
        };
        _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        };
        _this.handleMouseDown = function(e) {
            // avoid selecting text during drag
            // https://github.com/ant-design/ant-design/issues/25010
            e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        };
        _this.handleBlur = function() {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        };
        return _this;
    }
    (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(document, 'mouseup', this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref, _ref2;
                var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset = _this$props.offset, style = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(_this$props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex",
                    "ariaLabel",
                    "ariaLabelledBy",
                    "ariaValueTextFormatter"
                ]);
                var className = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))(this.props.className, (0, $0708e163b377474d$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
                var positionStyle = vertical ? (_ref = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);
                var elStyle = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, style), positionStyle);
                var mergedTabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) mergedTabIndex = null;
                var ariaValueText;
                if (ariaValueTextFormatter) ariaValueText = ariaValueTextFormatter(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("div", (0, $lS58v.default)({
                    ref: this.setHandleRef,
                    tabIndex: mergedTabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown // aria attribute
                    ,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled,
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText
                }));
            }
        }
    ]);
    return Handle;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);




var $kqzqZ = parcelRequire("kqzqZ");
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $43559d7c875ecd87$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $43559d7c875ecd87$var$KeyCode.F1 && keyCode <= $43559d7c875ecd87$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $43559d7c875ecd87$var$KeyCode.ALT:
            case $43559d7c875ecd87$var$KeyCode.CAPS_LOCK:
            case $43559d7c875ecd87$var$KeyCode.CONTEXT_MENU:
            case $43559d7c875ecd87$var$KeyCode.CTRL:
            case $43559d7c875ecd87$var$KeyCode.DOWN:
            case $43559d7c875ecd87$var$KeyCode.END:
            case $43559d7c875ecd87$var$KeyCode.ESC:
            case $43559d7c875ecd87$var$KeyCode.HOME:
            case $43559d7c875ecd87$var$KeyCode.INSERT:
            case $43559d7c875ecd87$var$KeyCode.LEFT:
            case $43559d7c875ecd87$var$KeyCode.MAC_FF_META:
            case $43559d7c875ecd87$var$KeyCode.META:
            case $43559d7c875ecd87$var$KeyCode.NUMLOCK:
            case $43559d7c875ecd87$var$KeyCode.NUM_CENTER:
            case $43559d7c875ecd87$var$KeyCode.PAGE_DOWN:
            case $43559d7c875ecd87$var$KeyCode.PAGE_UP:
            case $43559d7c875ecd87$var$KeyCode.PAUSE:
            case $43559d7c875ecd87$var$KeyCode.PRINT_SCREEN:
            case $43559d7c875ecd87$var$KeyCode.RIGHT:
            case $43559d7c875ecd87$var$KeyCode.SHIFT:
            case $43559d7c875ecd87$var$KeyCode.UP:
            case $43559d7c875ecd87$var$KeyCode.WIN_KEY:
            case $43559d7c875ecd87$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $43559d7c875ecd87$var$KeyCode.ZERO && keyCode <= $43559d7c875ecd87$var$KeyCode.NINE) return true;
        if (keyCode >= $43559d7c875ecd87$var$KeyCode.NUM_ZERO && keyCode <= $43559d7c875ecd87$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $43559d7c875ecd87$var$KeyCode.A && keyCode <= $43559d7c875ecd87$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $43559d7c875ecd87$var$KeyCode.SPACE:
            case $43559d7c875ecd87$var$KeyCode.QUESTION_MARK:
            case $43559d7c875ecd87$var$KeyCode.NUM_PLUS:
            case $43559d7c875ecd87$var$KeyCode.NUM_MINUS:
            case $43559d7c875ecd87$var$KeyCode.NUM_PERIOD:
            case $43559d7c875ecd87$var$KeyCode.NUM_DIVISION:
            case $43559d7c875ecd87$var$KeyCode.SEMICOLON:
            case $43559d7c875ecd87$var$KeyCode.DASH:
            case $43559d7c875ecd87$var$KeyCode.EQUALS:
            case $43559d7c875ecd87$var$KeyCode.COMMA:
            case $43559d7c875ecd87$var$KeyCode.PERIOD:
            case $43559d7c875ecd87$var$KeyCode.SLASH:
            case $43559d7c875ecd87$var$KeyCode.APOSTROPHE:
            case $43559d7c875ecd87$var$KeyCode.SINGLE_QUOTE:
            case $43559d7c875ecd87$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $43559d7c875ecd87$var$KeyCode.BACKSLASH:
            case $43559d7c875ecd87$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $43559d7c875ecd87$export$2e2bcd8739ae039 = $43559d7c875ecd87$var$KeyCode;


function $1ba06893bce97b0f$export$597415897f3287c9(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, $kqzqZ.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function $1ba06893bce97b0f$export$f4657b4dc4cc2ea4(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function $1ba06893bce97b0f$export$eaf0efc71c45a02(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function $1ba06893bce97b0f$export$e3e031d5dec39373(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var baseNum = Math.pow(10, $1ba06893bce97b0f$export$e0c74b50bbd10f68(step));
        var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, $4944783056626d64$export$2e2bcd8739ae039)(diffs)))];
}
function $1ba06893bce97b0f$export$e0c74b50bbd10f68(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf('.') >= 0) precision = stepString.length - stepString.indexOf('.') - 1;
    return precision;
}
function $1ba06893bce97b0f$export$642213d516a9b928(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function $1ba06893bce97b0f$export$7e1d3da113d10e8e(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $1ba06893bce97b0f$export$ec6357f54996b379(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function $1ba06893bce97b0f$export$65e4339c6f9d8d24(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function $1ba06893bce97b0f$export$5bea24a9dfe5ab1a(val, props) {
    var step = props.step;
    var closestPoint = isFinite($1ba06893bce97b0f$export$e3e031d5dec39373(val, props)) ? $1ba06893bce97b0f$export$e3e031d5dec39373(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed($1ba06893bce97b0f$export$e0c74b50bbd10f68(step)));
}
function $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $1ba06893bce97b0f$export$e5722e0a8bbb32d9(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function $1ba06893bce97b0f$export$3bef836a1fb84ee6(e, vertical, reverse) {
    var increase = 'increase';
    var decrease = 'decrease';
    var method = increase;
    switch(e.keyCode){
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).END:
            return function(value, props) {
                return props.max;
            };
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, $43559d7c875ecd87$export$2e2bcd8739ae039).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return $1ba06893bce97b0f$export$e5722e0a8bbb32d9(method, value, props);
    };
}


/* eslint-disable @typescript-eslint/no-explicit-any */ function $523d09c1bbbd2d95$var$noop() {}
function $523d09c1bbbd2d95$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_Component) {
        (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(ComponentEnhancer, _Component);
        var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(ComponentEnhancer);
        function ComponentEnhancer(props) {
            var _this;
            (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, ComponentEnhancer);
            _this = _super.call(this, props);
            _this.onDown = function(e, position) {
                var p = position;
                var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
                var bounds = _this.state.bounds;
                var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
                var inPoint = $1ba06893bce97b0f$export$597415897f3287c9(e, _this.handlesRefs);
                _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n, i) {
                    var v = !i ? n >= bounds[i] : true;
                    return i === value.length - 1 ? n <= bounds[i] : v;
                }).some(function(c) {
                    return !c;
                });
                if (_this.dragTrack) {
                    _this.dragOffset = p;
                    _this.startBounds = (0, $4944783056626d64$export$2e2bcd8739ae039)(bounds);
                } else {
                    if (!inPoint) _this.dragOffset = 0;
                    else {
                        var handlePosition = $1ba06893bce97b0f$export$ec6357f54996b379(isVertical, e.target);
                        _this.dragOffset = p - handlePosition;
                        p = handlePosition;
                    }
                    _this.onStart(p);
                }
            };
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                _this.removeDocumentEvents();
                var isVertical = _this.props.vertical;
                var position = $1ba06893bce97b0f$export$642213d516a9b928(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if ($1ba06893bce97b0f$export$eaf0efc71c45a02(e)) return;
                var isVertical = _this.props.vertical;
                var position = $1ba06893bce97b0f$export$7e1d3da113d10e8e(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentTouchEvents();
                $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e);
            };
            _this.onFocus = function(e) {
                var _this$props2 = _this.props, onFocus = _this$props2.onFocus, vertical = _this$props2.vertical;
                if ($1ba06893bce97b0f$export$597415897f3287c9(e, _this.handlesRefs) && !_this.dragTrack) {
                    var handlePosition = $1ba06893bce97b0f$export$ec6357f54996b379(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                if (!_this.dragTrack) _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $1ba06893bce97b0f$export$642213d516a9b928(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onTouchMove = function(e) {
                if ($1ba06893bce97b0f$export$eaf0efc71c45a02(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $1ba06893bce97b0f$export$7e1d3da113d10e8e(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && $1ba06893bce97b0f$export$597415897f3287c9(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                }); // eslint-disable-next-line react/no-unused-state
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, $119894c7f6ed90f3$export$2e2bcd8739ae039)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
            _this.handlesRefs = {};
            return _this;
        }
        (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, $615034f7210a91b8$export$2e2bcd8739ae039)((0, $b98d55ebe91acf48$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, $615034f7210a91b8$export$2e2bcd8739ae039)((0, $b98d55ebe91acf48$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(this.document, 'touchmove', this.onTouchMove);
                    this.onTouchUpListener = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(this.document, 'touchend', this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(this.document, 'mousemove', this.onMouseMove);
                    this.onMouseUpListener = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(this.document, 'mouseup', this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable @typescript-eslint/no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    var _this$handlesRefs$;
                    if (this.props.disabled) return;
                    (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 || _this$handlesRefs$.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (this.props.disabled) return;
                    Object.keys(this.handlesRefs).forEach(function(key) {
                        var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
                        (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 || (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 || _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
                    var ratio = (value - min) / (max - min);
                    return Math.max(0, ratio * 100);
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
                    var _get$call = (0, $615034f7210a91b8$export$2e2bcd8739ae039)((0, $b98d55ebe91acf48$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))(prefixCls, (_classNames = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, className, className), _classNames));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? $523d09c1bbbd2d95$var$noop : this.onTouchStart,
                        onMouseDown: disabled ? $523d09c1bbbd2d95$var$noop : this.onMouseDown,
                        onMouseUp: disabled ? $523d09c1bbbd2d95$var$noop : this.onMouseUp,
                        onKeyDown: disabled ? $523d09c1bbbd2d95$var$noop : this.onKeyDown,
                        onFocus: disabled ? $523d09c1bbbd2d95$var$noop : this.onFocus,
                        onBlur: disabled ? $523d09c1bbbd2d95$var$noop : this.onBlur,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("div", {
                        className: "".concat(prefixCls, "-rail"),
                        style: (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, maximumTrackStyle), railStyle)
                    }), tracks, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $10c4f4a83e9dee46$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $1d6d53f325a4b603$export$2e2bcd8739ae039), {
                        className: "".concat(prefixCls, "-mark"),
                        onClickLabel: disabled ? $523d09c1bbbd2d95$var$noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, Component.defaultProps), {}, {
        prefixCls: 'rc-slider',
        className: '',
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(props) {
            var index = props.index, restProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(props, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $92406aaedd12d98a$export$2e2bcd8739ae039), (0, $lS58v.default)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: $523d09c1bbbd2d95$var$noop,
        onChange: $523d09c1bbbd2d95$var$noop,
        onAfterChange: $523d09c1bbbd2d95$var$noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _a;
}



var $d72cd91ac291ffa5$var$Slider = /*#__PURE__*/ function(_React$Component) {
    (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(Slider);
    /* eslint-enable */ function Slider(props) {
        var _this;
        (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            return [];
        };
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, $119894c7f6ed90f3$export$2e2bcd8739ae039)(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
        (0, $119894c7f6ed90f3$export$2e2bcd8739ae039)(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(Slider, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange = _this$props.onChange;
                if (!('min' in this.props || 'max' in this.props)) return;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue === prevState.value) return;
                 // eslint-disable-next-line
                this.setState({
                    value: nextValue
                });
                if (!(min === prevProps.min && max === prevProps.max) && $1ba06893bce97b0f$export$f4657b4dc4cc2ea4(theValue, this.props)) onChange(nextValue);
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                var nextState = state.value > this.props.max ? (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, state), {}, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $1ba06893bce97b0f$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                var minPoint = this.props.startPoint || this.props.min;
                return this.state.value > minPoint ? minPoint : this.state.value;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                if (this.state.value < this.props.startPoint) return this.props.startPoint;
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, this.props), nextProps);
                var val = $1ba06893bce97b0f$export$65e4339c6f9d8d24(v, mergedProps);
                return $1ba06893bce97b0f$export$5bea24a9dfe5ab1a(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
                var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: "".concat(prefixCls, "-handle"),
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    ariaLabel: ariaLabelForHandle,
                    ariaLabelledBy: ariaLabelledByForHandle,
                    ariaValueTextFormatter: ariaValueTextFormatterForHandle,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
                var mergedTrackStyle = trackStyle[0] || trackStyle;
                var track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $775f0ad0d2139b6b$export$2e2bcd8739ae039), {
                    className: "".concat(prefixCls, "-track"),
                    vertical: vertical,
                    included: included,
                    offset: trackOffset,
                    reverse: reverse,
                    length: offset - trackOffset,
                    style: (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, minimumTrackStyle), mergedTrackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $d72cd91ac291ffa5$export$2e2bcd8739ae039 = (0, $523d09c1bbbd2d95$export$2e2bcd8739ae039)($d72cd91ac291ffa5$var$Slider);










var $iD6kw = parcelRequire("iD6kw");




var $9866bb6bfecd9337$var$_trimAlignValue = function trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = $1ba06893bce97b0f$export$65e4339c6f9d8d24(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return $1ba06893bce97b0f$export$5bea24a9dfe5ab1a(valNotConflict, props);
};
var $9866bb6bfecd9337$var$Range = /*#__PURE__*/ function(_React$Component) {
    (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(Range, _React$Component);
    var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(Range);
    function Range(props) {
        var _this;
        (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, Range);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            var bounds = _this.getValue();
            var value = _this.calcValueByPos(position);
            var closestBound = _this.getClosestBound(value);
            var index = _this.getBoundNeedMoving(value, closestBound);
            var prevValue = bounds[index];
            if (value === prevValue) return null;
            var nextBounds = (0, $4944783056626d64$export$2e2bcd8739ae039)(bounds);
            nextBounds[index] = value;
            return nextBounds;
        };
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (!handle) _this.dragTrack = false;
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(void 0, (0, $4944783056626d64$export$2e2bcd8739ae039)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return $9866bb6bfecd9337$var$_trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(Range, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "getSliderLength",
            value: function getSliderLength() {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props = this.props, onChange = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
                if (!('min' in this.props || 'max' in this.props)) return;
                if (min === prevProps.min && max === prevProps.max) return;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return $1ba06893bce97b0f$export$f4657b4dc4cc2ea4(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return $1ba06893bce97b0f$export$65e4339c6f9d8d24(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        'handle',
                        'recent'
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, this.state), state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props, state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = (0, $4944783056626d64$export$2e2bcd8739ae039)(state.bounds);
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position, dragTrack, startBounds) {
                $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e);
                var state = this.state, props = this.props;
                var maxValue = props.max || 100;
                var minValue = props.min || 0;
                if (dragTrack) {
                    var pos = props.vertical ? -position : position;
                    pos = props.reverse ? -pos : pos;
                    var max = maxValue - Math.max.apply(Math, (0, $4944783056626d64$export$2e2bcd8739ae039)(startBounds));
                    var min = minValue - Math.min.apply(Math, (0, $4944783056626d64$export$2e2bcd8739ae039)(startBounds));
                    var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
                    var nextBounds = startBounds.map(function(v) {
                        return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
                    });
                    if (state.bounds.map(function(c, i) {
                        return c === nextBounds[i];
                    }).some(function(c) {
                        return !c;
                    })) this.onChange({
                        bounds: nextBounds
                    });
                    return;
                }
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $1ba06893bce97b0f$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $1ba06893bce97b0f$export$3f9ffdaf2961f43f(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = $9866bb6bfecd9337$var$_trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; i += 1)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
                var cache = this.internalPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this.internalPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this.internalPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = (0, $4944783056626d64$export$2e2bcd8739ae039)(state.bounds);
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        // eslint-disable-next-line no-param-reassign
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                } // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                 // push the handle
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
                return $9866bb6bfecd9337$var$_trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = "".concat(prefixCls, "-handle");
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var mergedTabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) mergedTabIndex = null;
                    var dragging = handle === i;
                    return handleGenerator({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))((_classNames = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, handleClassName, true), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        dragging: dragging,
                        offset: offsets[i],
                        value: v,
                        index: i,
                        tabIndex: mergedTabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        },
                        ariaLabel: ariaLabelGroupForHandles[i],
                        ariaLabelledBy: ariaLabelledByGroupForHandles[i],
                        ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))((_classNames2 = {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track"), true), (0, $0708e163b377474d$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $775f0ad0d2139b6b$export$2e2bcd8739ae039), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!('value' in props || 'min' in props || 'max' in props)) return null;
                var value = props.value || state.bounds;
                var nextBounds = value.map(function(v, i) {
                    return $9866bb6bfecd9337$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        bounds: state.bounds,
                        props: props
                    });
                });
                if (state.bounds.length === nextBounds.length) {
                    if (nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                } else nextBounds = value.map(function(v, i) {
                    return $9866bb6bfecd9337$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        props: props
                    });
                });
                return (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, state), {}, {
                    bounds: nextBounds
                });
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
/* eslint-enable */ $9866bb6bfecd9337$var$Range.displayName = 'Range';
$9866bb6bfecd9337$var$Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    draggableTrack: false,
    tabIndex: [],
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
};
var $9866bb6bfecd9337$export$2e2bcd8739ae039 = (0, $523d09c1bbbd2d95$export$2e2bcd8739ae039)($9866bb6bfecd9337$var$Range);




var $lS58v = parcelRequire("lS58v");








var $iD6kw = parcelRequire("iD6kw");

var $lS58v = parcelRequire("lS58v");

var $iD6kw = parcelRequire("iD6kw");

var $lS58v = parcelRequire("lS58v");




var $iD6kw = parcelRequire("iD6kw");


var $lS58v = parcelRequire("lS58v");



var $ktpIU = parcelRequire("ktpIU");




var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");
var $f91fc991ef4317d7$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $f91fc991ef4317d7$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $f91fc991ef4317d7$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $f91fc991ef4317d7$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $f91fc991ef4317d7$var$rafUUID = 0;
var $f91fc991ef4317d7$var$rafIds = new Map();
function $f91fc991ef4317d7$var$cleanup(id) {
    $f91fc991ef4317d7$var$rafIds.delete(id);
}
var $f91fc991ef4317d7$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $f91fc991ef4317d7$var$rafUUID += 1;
    var id = $f91fc991ef4317d7$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $f91fc991ef4317d7$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $f91fc991ef4317d7$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $f91fc991ef4317d7$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$f91fc991ef4317d7$var$wrapperRaf.cancel = function(id) {
    var realId = $f91fc991ef4317d7$var$rafIds.get(id);
    $f91fc991ef4317d7$var$cleanup(id);
    return $f91fc991ef4317d7$var$caf(realId);
};
var $f91fc991ef4317d7$export$2e2bcd8739ae039 = $f91fc991ef4317d7$var$wrapperRaf;


function $c2f48dfe2c4ac7c3$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}




var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");
function $460d2bf0cfa06e5f$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $460d2bf0cfa06e5f$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(node) === 'object' && $460d2bf0cfa06e5f$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($460d2bf0cfa06e5f$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $460d2bf0cfa06e5f$export$2e2bcd8739ae039(node) {
    var domNode = $460d2bf0cfa06e5f$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($kqzqZ))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($kqzqZ))), node);
    }
    return null;
}




var $iD6kw = parcelRequire("iD6kw");
var $9927bb1d6e14e2e0$exports = {};
'use strict';

$9927bb1d6e14e2e0$exports = (parcelRequire("l23zI"));



var $iD6kw = parcelRequire("iD6kw");
function $b1c449bafcc29f99$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $iD6kw.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $1a1439271e7037d0$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $1a1439271e7037d0$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $1a1439271e7037d0$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $1a1439271e7037d0$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $1a1439271e7037d0$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $1a1439271e7037d0$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $1a1439271e7037d0$var$REACT_FRAGMENT_TYPE);
}


var $7d1487c029c498a5$var$ReactMajorVersion = Number((0, $iD6kw.version).split('.')[0]);
var $7d1487c029c498a5$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $7d1487c029c498a5$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $7d1487c029c498a5$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $7d1487c029c498a5$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $b1c449bafcc29f99$export$2e2bcd8739ae039)(function() {
        return $7d1487c029c498a5$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $7d1487c029c498a5$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($7d1487c029c498a5$var$isReactElement(nodeOrComponent) && $7d1487c029c498a5$var$ReactMajorVersion >= 19) return true;
    var type = (0, $9927bb1d6e14e2e0$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $9927bb1d6e14e2e0$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $9927bb1d6e14e2e0$exports.ForwardRef)) return false;
    return true;
};
function $7d1487c029c498a5$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $iD6kw.isValidElement)(node) && !(0, $1a1439271e7037d0$export$2e2bcd8739ae039)(node);
}
var $7d1487c029c498a5$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $7d1487c029c498a5$var$isReactElement(node) && $7d1487c029c498a5$export$c1cec34af06bcf7(node);
};
var $7d1487c029c498a5$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $7d1487c029c498a5$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};




var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");
function $9795901e58320687$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


var $a2a77e10342ccc91$var$Portal = /*#__PURE__*/ (0, $iD6kw.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $iD6kw.useRef)();
    var containerRef = (0, $iD6kw.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $iD6kw.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $iD6kw.useRef)(false);
    if (!initRef.current && (0, $9795901e58320687$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $iD6kw.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $iD6kw.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kqzqZ))).createPortal(children, containerRef.current) : null;
});
var $a2a77e10342ccc91$export$2e2bcd8739ae039 = $a2a77e10342ccc91$var$Portal;




function $2b7c505fc67bfb1b$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $2b7c505fc67bfb1b$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $2b7c505fc67bfb1b$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($2b7c505fc67bfb1b$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}



var $lS58v = parcelRequire("lS58v");

function $699fdc1008450434$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $85aac964c7209252$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $7efbf88d8781b24c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f662ed85e1f779a6$export$2e2bcd8739ae039(r, e) {
    return (0, $699fdc1008450434$export$2e2bcd8739ae039)(r) || (0, $85aac964c7209252$export$2e2bcd8739ae039)(r, e) || (0, $dcc812bcb39bc9be$export$2e2bcd8739ae039)(r, e) || (0, $7efbf88d8781b24c$export$2e2bcd8739ae039)();
}




var $iD6kw = parcelRequire("iD6kw");
var $ccb62fbbf82dc1fa$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $lS58v = parcelRequire("lS58v");


var $iD6kw = parcelRequire("iD6kw");









var $iD6kw = parcelRequire("iD6kw");


var $iD6kw = parcelRequire("iD6kw");
var $1a243695dbc8fcf9$var$_excluded = [
    "children"
];
var $1a243695dbc8fcf9$export$841858b892ce1f4c = /*#__PURE__*/ $iD6kw.createContext({});
function $1a243695dbc8fcf9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(_ref, $1a243695dbc8fcf9$var$_excluded);
    return /*#__PURE__*/ $iD6kw.createElement($1a243695dbc8fcf9$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $iD6kw = parcelRequire("iD6kw");
var $1d59115a70ee702c$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($iD6kw.Component);
var $1d59115a70ee702c$export$2e2bcd8739ae039 = $1d59115a70ee702c$var$DomWrapper;






var $iD6kw = parcelRequire("iD6kw");
function $d570de310f07ae39$export$2e2bcd8739ae039(callback) {
    var fnRef = $iD6kw.useRef();
    fnRef.current = callback;
    var memoFn = $iD6kw.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $iD6kw = parcelRequire("iD6kw");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $0badc1c2e3baef5c$var$useInternalLayoutEffect = (0, $9795901e58320687$export$2e2bcd8739ae039)() ? $iD6kw.useLayoutEffect : $iD6kw.useEffect;
var $0badc1c2e3baef5c$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $iD6kw.useRef(true);
    $0badc1c2e3baef5c$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $0badc1c2e3baef5c$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $0badc1c2e3baef5c$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $0badc1c2e3baef5c$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $0badc1c2e3baef5c$export$2e2bcd8739ae039 = $0badc1c2e3baef5c$var$useLayoutEffect;




var $iD6kw = parcelRequire("iD6kw");
function $83475d5f0d729f94$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $iD6kw.useRef(false);
    var _React$useState = $iD6kw.useState(defaultValue), _React$useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $iD6kw.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $0ffee5e02e4eb014$var$hasValue(value) {
    return value !== undefined;
}
function $0ffee5e02e4eb014$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $83475d5f0d729f94$export$2e2bcd8739ae039)(function() {
        if ($0ffee5e02e4eb014$var$hasValue(value)) return value;
        else if ($0ffee5e02e4eb014$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $d570de310f07ae39$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $83475d5f0d729f94$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $0badc1c2e3baef5c$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $0badc1c2e3baef5c$export$9283e56bae2f7b0f)(function() {
        if (!$0ffee5e02e4eb014$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $d570de310f07ae39$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $b84fba4befb63bd2$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $0932ecc44c9c52bd$export$2e2bcd8739ae039(r) {
    return (0, $699fdc1008450434$export$2e2bcd8739ae039)(r) || (0, $40e77fe90a4faa9f$export$2e2bcd8739ae039)(r) || (0, $dcc812bcb39bc9be$export$2e2bcd8739ae039)(r) || (0, $7efbf88d8781b24c$export$2e2bcd8739ae039)();
}



function $eb5e5bda2a190e40$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $0932ecc44c9c52bd$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $4944783056626d64$export$2e2bcd8739ae039)(entity);
    else clone = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $eb5e5bda2a190e40$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $eb5e5bda2a190e40$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $b84fba4befb63bd2$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $eb5e5bda2a190e40$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $eb5e5bda2a190e40$var$isObject(obj) {
    return (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $eb5e5bda2a190e40$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $eb5e5bda2a190e40$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $eb5e5bda2a190e40$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $eb5e5bda2a190e40$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $b84fba4befb63bd2$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $eb5e5bda2a190e40$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $b84fba4befb63bd2$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $eb5e5bda2a190e40$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $eb5e5bda2a190e40$export$2e2bcd8739ae039(clone, path, $eb5e5bda2a190e40$var$createEmpty(value));
                    $eb5e5bda2a190e40$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $4944783056626d64$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $eb5e5bda2a190e40$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}








var $iD6kw = parcelRequire("iD6kw");

function $71e521a40ee06989$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $iD6kw.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $iD6kw.useRef(defaultValue);
    var getValue = (0, $d570de310f07ae39$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $d570de310f07ae39$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $iD6kw = parcelRequire("iD6kw");
var $fd7fc72b4c323302$export$de71442bbf2143da = 'none';
var $fd7fc72b4c323302$export$4fc3521687bcacd2 = 'appear';
var $fd7fc72b4c323302$export$5d6af549241fe2e8 = 'enter';
var $fd7fc72b4c323302$export$59b1c493d29f68e4 = 'leave';
var $fd7fc72b4c323302$export$40b34dd77d5522bf = 'none';
var $fd7fc72b4c323302$export$1b792916a5fac4fc = 'prepare';
var $fd7fc72b4c323302$export$9563153dd25a3ce8 = 'start';
var $fd7fc72b4c323302$export$e205886172277ec6 = 'active';
var $fd7fc72b4c323302$export$3a846c3d2fac10b8 = 'end';
var $fd7fc72b4c323302$export$98351fa4e6b4f204 = 'prepared';



var $iD6kw = parcelRequire("iD6kw");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $8b3ca4c4a9058c28$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $8b3ca4c4a9058c28$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $8b3ca4c4a9058c28$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $8b3ca4c4a9058c28$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $8b3ca4c4a9058c28$var$vendorPrefixes = $8b3ca4c4a9058c28$export$6e8b350b1a8958a0((0, $9795901e58320687$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $8b3ca4c4a9058c28$var$style = {};
if ((0, $9795901e58320687$export$2e2bcd8739ae039)()) {
    var $8b3ca4c4a9058c28$var$_document$createEleme = document.createElement('div');
    $8b3ca4c4a9058c28$var$style = $8b3ca4c4a9058c28$var$_document$createEleme.style;
}
var $8b3ca4c4a9058c28$var$prefixedEventNames = {};
function $8b3ca4c4a9058c28$export$a032e4f39350c1d8(eventName) {
    if ($8b3ca4c4a9058c28$var$prefixedEventNames[eventName]) return $8b3ca4c4a9058c28$var$prefixedEventNames[eventName];
    var prefixMap = $8b3ca4c4a9058c28$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $8b3ca4c4a9058c28$var$style) {
                $8b3ca4c4a9058c28$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $8b3ca4c4a9058c28$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $8b3ca4c4a9058c28$var$internalAnimationEndName = $8b3ca4c4a9058c28$export$a032e4f39350c1d8('animationend');
var $8b3ca4c4a9058c28$var$internalTransitionEndName = $8b3ca4c4a9058c28$export$a032e4f39350c1d8('transitionend');
var $8b3ca4c4a9058c28$export$d28133ed3ad06c8b = !!($8b3ca4c4a9058c28$var$internalAnimationEndName && $8b3ca4c4a9058c28$var$internalTransitionEndName);
var $8b3ca4c4a9058c28$export$760cc9769c51b738 = $8b3ca4c4a9058c28$var$internalAnimationEndName || 'animationend';
var $8b3ca4c4a9058c28$export$44baea64b8602e3c = $8b3ca4c4a9058c28$var$internalTransitionEndName || 'transitionend';
function $8b3ca4c4a9058c28$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $9c485ed84fe877dc$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $iD6kw.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $8b3ca4c4a9058c28$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $8b3ca4c4a9058c28$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $8b3ca4c4a9058c28$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $8b3ca4c4a9058c28$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $iD6kw.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $iD6kw = parcelRequire("iD6kw");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $b8b99551aa0edb06$var$useIsomorphicLayoutEffect = (0, $9795901e58320687$export$2e2bcd8739ae039)() ? (0, $iD6kw.useLayoutEffect) : (0, $iD6kw.useEffect);
var $b8b99551aa0edb06$export$2e2bcd8739ae039 = $b8b99551aa0edb06$var$useIsomorphicLayoutEffect;





var $iD6kw = parcelRequire("iD6kw");




var $iD6kw = parcelRequire("iD6kw");
var $6b0c0341277d40ee$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $iD6kw.useRef(null);
    function cancelNextFrame() {
        (0, $f91fc991ef4317d7$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $f91fc991ef4317d7$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $iD6kw.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $fa2e509a77ef21e8$var$FULL_STEP_QUEUE = [
    (0, $fd7fc72b4c323302$export$1b792916a5fac4fc),
    (0, $fd7fc72b4c323302$export$9563153dd25a3ce8),
    (0, $fd7fc72b4c323302$export$e205886172277ec6),
    (0, $fd7fc72b4c323302$export$3a846c3d2fac10b8)
];
var $fa2e509a77ef21e8$var$SIMPLE_STEP_QUEUE = [
    (0, $fd7fc72b4c323302$export$1b792916a5fac4fc),
    (0, $fd7fc72b4c323302$export$98351fa4e6b4f204)
];
var $fa2e509a77ef21e8$export$c2029bf6cfdbc28a = false;
var $fa2e509a77ef21e8$export$dbee1e282e8c4830 = true;
function $fa2e509a77ef21e8$export$39e04e72f972b885(step) {
    return step === (0, $fd7fc72b4c323302$export$e205886172277ec6) || step === (0, $fd7fc72b4c323302$export$3a846c3d2fac10b8);
}
var $fa2e509a77ef21e8$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $83475d5f0d729f94$export$2e2bcd8739ae039)((0, $fd7fc72b4c323302$export$40b34dd77d5522bf)), _useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $6b0c0341277d40ee$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $fd7fc72b4c323302$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $fa2e509a77ef21e8$var$SIMPLE_STEP_QUEUE : $fa2e509a77ef21e8$var$FULL_STEP_QUEUE;
    (0, $b8b99551aa0edb06$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $fd7fc72b4c323302$export$40b34dd77d5522bf) && step !== (0, $fd7fc72b4c323302$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $fa2e509a77ef21e8$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $iD6kw.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $ce9d978f2726fd7e$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $83475d5f0d729f94$export$2e2bcd8739ae039)(), _useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $71e521a40ee06989$export$2e2bcd8739ae039)((0, $fd7fc72b4c323302$export$de71442bbf2143da)), _useSyncState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $83475d5f0d729f94$export$2e2bcd8739ae039)(null), _useState4 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $iD6kw.useRef)(false);
    var deadlineRef = (0, $iD6kw.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $iD6kw.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $fd7fc72b4c323302$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $d570de310f07ae39$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $fd7fc72b4c323302$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $fd7fc72b4c323302$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $fd7fc72b4c323302$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $fd7fc72b4c323302$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $9c485ed84fe877dc$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $fd7fc72b4c323302$export$4fc3521687bcacd2:
                return (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)({}, (0, $fd7fc72b4c323302$export$1b792916a5fac4fc), onAppearPrepare), (0, $fd7fc72b4c323302$export$9563153dd25a3ce8), onAppearStart), (0, $fd7fc72b4c323302$export$e205886172277ec6), onAppearActive);
            case 0, $fd7fc72b4c323302$export$5d6af549241fe2e8:
                return (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)({}, (0, $fd7fc72b4c323302$export$1b792916a5fac4fc), onEnterPrepare), (0, $fd7fc72b4c323302$export$9563153dd25a3ce8), onEnterStart), (0, $fd7fc72b4c323302$export$e205886172277ec6), onEnterActive);
            case 0, $fd7fc72b4c323302$export$59b1c493d29f68e4:
                return (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)({}, (0, $fd7fc72b4c323302$export$1b792916a5fac4fc), onLeavePrepare), (0, $fd7fc72b4c323302$export$9563153dd25a3ce8), onLeaveStart), (0, $fd7fc72b4c323302$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $iD6kw.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $fa2e509a77ef21e8$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $fd7fc72b4c323302$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $fd7fc72b4c323302$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $fa2e509a77ef21e8$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $fd7fc72b4c323302$export$e205886172277ec6) && currentStatus !== (0, $fd7fc72b4c323302$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $fd7fc72b4c323302$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $fa2e509a77ef21e8$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $fa2e509a77ef21e8$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $iD6kw.useRef)(null);
    // Update with new status
    (0, $b8b99551aa0edb06$export$2e2bcd8739ae039)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $fd7fc72b4c323302$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $fd7fc72b4c323302$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $fd7fc72b4c323302$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $fd7fc72b4c323302$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $fd7fc72b4c323302$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $iD6kw.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $fd7fc72b4c323302$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $fd7fc72b4c323302$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $fd7fc72b4c323302$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $fd7fc72b4c323302$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $iD6kw.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $iD6kw.useRef(false);
    (0, $iD6kw.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $fd7fc72b4c323302$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $fd7fc72b4c323302$export$1b792916a5fac4fc] && step === (0, $fd7fc72b4c323302$export$9563153dd25a3ce8)) mergedStyle = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $5353637ba3bb15bf$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $iD6kw.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $iD6kw.useContext((0, $1a243695dbc8fcf9$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $iD6kw.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $iD6kw.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $460d2bf0cfa06e5f$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $ce9d978f2726fd7e$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $iD6kw.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $iD6kw.useCallback(function(node) {
            nodeRef.current = node;
            (0, $7d1487c029c498a5$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $fd7fc72b4c323302$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $fd7fc72b4c323302$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $fa2e509a77ef21e8$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $fd7fc72b4c323302$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $8b3ca4c4a9058c28$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))((0, $8b3ca4c4a9058c28$export$27c72201b1d09951)(motionName, status), (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $0708e163b377474d$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $iD6kw.isValidElement(motionChildren) && (0, $7d1487c029c498a5$export$c1cec34af06bcf7)(motionChildren)) {
            var originNodeRef = (0, $7d1487c029c498a5$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $iD6kw.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $iD6kw.createElement((0, $1d59115a70ee702c$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $5353637ba3bb15bf$export$2e2bcd8739ae039 = $5353637ba3bb15bf$export$e265d52a86a9f199((0, $8b3ca4c4a9058c28$export$d28133ed3ad06c8b));



var $lS58v = parcelRequire("lS58v");





var $ktpIU = parcelRequire("ktpIU");




var $iD6kw = parcelRequire("iD6kw");



var $dbc056dd313962da$export$3904baa009bc026e = 'add';
var $dbc056dd313962da$export$851162f0adad2cbc = 'keep';
var $dbc056dd313962da$export$c8b3fb08b68cfc85 = 'remove';
var $dbc056dd313962da$export$2ac1bd1808d2e43a = 'removed';
function $dbc056dd313962da$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $dbc056dd313962da$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($dbc056dd313962da$export$c47fd798e598c85c);
}
function $dbc056dd313962da$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $dbc056dd313962da$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $dbc056dd313962da$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $dbc056dd313962da$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $dbc056dd313962da$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $dbc056dd313962da$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $dbc056dd313962da$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $dbc056dd313962da$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $dbc056dd313962da$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $2530d124008fe395$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $2530d124008fe395$var$_excluded2 = [
    "status"
];
var $2530d124008fe395$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $2530d124008fe395$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5353637ba3bb15bf$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, entity), {}, {
                            status: (0, $dbc056dd313962da$export$2ac1bd1808d2e43a)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $dbc056dd313962da$export$2ac1bd1808d2e43a);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(_this$props, $2530d124008fe395$var$_excluded);
                    var Component = component || $iD6kw.Fragment;
                    var motionProps = {};
                    $2530d124008fe395$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $iD6kw.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(_ref2, $2530d124008fe395$var$_excluded2);
                        var visible = status === (0, $dbc056dd313962da$export$3904baa009bc026e) || status === (0, $dbc056dd313962da$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $iD6kw.createElement(CSSMotion, (0, $lS58v.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $dbc056dd313962da$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $dbc056dd313962da$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $dbc056dd313962da$export$2ac1bd1808d2e43a) && entity.status === (0, $dbc056dd313962da$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($iD6kw.Component);
    (0, $0708e163b377474d$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $2530d124008fe395$export$2e2bcd8739ae039 = $2530d124008fe395$export$fcfc62c1d33d5e2e((0, $8b3ca4c4a9058c28$export$d28133ed3ad06c8b));



var $085a120a08a20c85$export$2e2bcd8739ae039 = (0, $5353637ba3bb15bf$export$2e2bcd8739ae039);


function $639733b56106983d$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $5ffac8d802db55a8$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $639733b56106983d$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $iD6kw.createElement((0, $085a120a08a20c85$export$2e2bcd8739ae039), (0, $lS58v.default)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $iD6kw.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $lS58v = parcelRequire("lS58v");



var $iD6kw = parcelRequire("iD6kw");
// export this package's api


function $b08054daa26e3d88$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b08054daa26e3d88$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b08054daa26e3d88$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b08054daa26e3d88$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b08054daa26e3d88$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b08054daa26e3d88$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b08054daa26e3d88$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b08054daa26e3d88$var$_typeof(obj);
}
function $b08054daa26e3d88$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b08054daa26e3d88$var$vendorPrefix;
var $b08054daa26e3d88$var$jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function $b08054daa26e3d88$var$getVendorPrefix() {
    if ($b08054daa26e3d88$var$vendorPrefix !== undefined) return $b08054daa26e3d88$var$vendorPrefix;
    $b08054daa26e3d88$var$vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for(var key in $b08054daa26e3d88$var$jsCssMap)if (key + testProp in style) $b08054daa26e3d88$var$vendorPrefix = key;
    return $b08054daa26e3d88$var$vendorPrefix;
}
function $b08054daa26e3d88$var$getTransitionName() {
    return $b08054daa26e3d88$var$getVendorPrefix() ? "".concat($b08054daa26e3d88$var$getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function $b08054daa26e3d88$var$getTransformName() {
    return $b08054daa26e3d88$var$getVendorPrefix() ? "".concat($b08054daa26e3d88$var$getVendorPrefix(), "Transform") : 'transform';
}
function $b08054daa26e3d88$var$setTransitionProperty(node, value) {
    var name = $b08054daa26e3d88$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') node.style.transitionProperty = value;
    }
}
function $b08054daa26e3d88$var$setTransform(node, value) {
    var name = $b08054daa26e3d88$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') node.style.transform = value;
    }
}
function $b08054daa26e3d88$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$b08054daa26e3d88$var$getTransitionName()];
}
function $b08054daa26e3d88$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($b08054daa26e3d88$var$getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $b08054daa26e3d88$var$matrix2d = /matrix\((.*)\)/;
var $b08054daa26e3d88$var$matrix3d = /matrix3d\((.*)\)/;
function $b08054daa26e3d88$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($b08054daa26e3d88$var$getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match($b08054daa26e3d88$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $b08054daa26e3d88$var$setTransform(node, "matrix(".concat(arr.join(','), ")"));
        } else {
            var match3d = transform.match($b08054daa26e3d88$var$matrix3d)[1];
            arr = match3d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $b08054daa26e3d88$var$setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    } else $b08054daa26e3d88$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $b08054daa26e3d88$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $b08054daa26e3d88$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $b08054daa26e3d88$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $b08054daa26e3d88$var$css(el, name, v) {
    var value = v;
    if ($b08054daa26e3d88$var$_typeof(name) === 'object') {
        for(var i in name)if (name.hasOwnProperty(i)) $b08054daa26e3d88$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $b08054daa26e3d88$var$getComputedStyleX(el, name);
}
function $b08054daa26e3d88$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $b08054daa26e3d88$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $b08054daa26e3d88$var$getScrollLeft(w) {
    return $b08054daa26e3d88$var$getScroll(w);
}
function $b08054daa26e3d88$var$getScrollTop(w) {
    return $b08054daa26e3d88$var$getScroll(w, true);
}
function $b08054daa26e3d88$var$getOffset(el) {
    var pos = $b08054daa26e3d88$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $b08054daa26e3d88$var$getScrollLeft(w);
    pos.top += $b08054daa26e3d88$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $b08054daa26e3d88$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $b08054daa26e3d88$var$getDocument(node) {
    if ($b08054daa26e3d88$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $b08054daa26e3d88$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = $b08054daa26e3d88$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $b08054daa26e3d88$var$_RE_NUM_NO_PX = new RegExp("^(".concat($b08054daa26e3d88$var$RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var $b08054daa26e3d88$var$RE_POS = /^(top|right|bottom|left)$/;
var $b08054daa26e3d88$var$CURRENT_STYLE = 'currentStyle';
var $b08054daa26e3d88$var$RUNTIME_STYLE = 'runtimeStyle';
var $b08054daa26e3d88$var$LEFT = 'left';
var $b08054daa26e3d88$var$PX = 'px';
function $b08054daa26e3d88$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$b08054daa26e3d88$var$CURRENT_STYLE] && elem[$b08054daa26e3d88$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($b08054daa26e3d88$var$_RE_NUM_NO_PX.test(ret) && !$b08054daa26e3d88$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$b08054daa26e3d88$var$LEFT];
        var rsLeft = elem[$b08054daa26e3d88$var$RUNTIME_STYLE][$b08054daa26e3d88$var$LEFT];
        // prevent flashing of content
        elem[$b08054daa26e3d88$var$RUNTIME_STYLE][$b08054daa26e3d88$var$LEFT] = elem[$b08054daa26e3d88$var$CURRENT_STYLE][$b08054daa26e3d88$var$LEFT];
        // Put in the new values to get a computed value out
        style[$b08054daa26e3d88$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $b08054daa26e3d88$var$PX;
        // Revert the changed values
        style[$b08054daa26e3d88$var$LEFT] = left;
        elem[$b08054daa26e3d88$var$RUNTIME_STYLE][$b08054daa26e3d88$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') $b08054daa26e3d88$var$getComputedStyleX = window.getComputedStyle ? $b08054daa26e3d88$var$_getComputedStyle : $b08054daa26e3d88$var$_getComputedStyleIE;
function $b08054daa26e3d88$var$getOffsetDirection(dir, option) {
    if (dir === 'left') return option.useCssRight ? 'right' : dir;
    return option.useCssBottom ? 'bottom' : dir;
}
function $b08054daa26e3d88$var$oppositeOffsetDirection(dir) {
    if (dir === 'left') return 'right';
    else if (dir === 'right') return 'left';
    else if (dir === 'top') return 'bottom';
    else if (dir === 'bottom') return 'top';
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $b08054daa26e3d88$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($b08054daa26e3d88$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $b08054daa26e3d88$var$getOffsetDirection('left', option);
    var verticalProperty = $b08054daa26e3d88$var$getOffsetDirection('top', option);
    var oppositeHorizontalProperty = $b08054daa26e3d88$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $b08054daa26e3d88$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') presetH = 999;
    if (verticalProperty !== 'top') presetV = 999;
    var originalTransition = '';
    var originalOffset = $b08054daa26e3d88$var$getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = $b08054daa26e3d88$var$getTransitionProperty(elem) || '';
        $b08054daa26e3d88$var$setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $b08054daa26e3d88$var$forceRelayout(elem);
    var old = $b08054daa26e3d88$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $b08054daa26e3d88$var$getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $b08054daa26e3d88$var$css(elem, originalStyle);
    // force relayout
    $b08054daa26e3d88$var$forceRelayout(elem);
    if ('left' in offset || 'top' in offset) $b08054daa26e3d88$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $b08054daa26e3d88$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $b08054daa26e3d88$var$css(elem, ret);
}
function $b08054daa26e3d88$var$setTransform$1(elem, offset) {
    var originalOffset = $b08054daa26e3d88$var$getOffset(elem);
    var originalXY = $b08054daa26e3d88$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ('top' in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $b08054daa26e3d88$var$setTransformXY(elem, resultXY);
}
function $b08054daa26e3d88$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $b08054daa26e3d88$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $b08054daa26e3d88$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $b08054daa26e3d88$var$getTransformName() in document.body.style) $b08054daa26e3d88$var$setTransform$1(elem, offset);
    else $b08054daa26e3d88$var$setLeftTop(elem, offset, option);
}
function $b08054daa26e3d88$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $b08054daa26e3d88$var$isBorderBoxFn(elem) {
    return $b08054daa26e3d88$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $b08054daa26e3d88$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
];
var $b08054daa26e3d88$var$CONTENT_INDEX = -1;
var $b08054daa26e3d88$var$PADDING_INDEX = 2;
var $b08054daa26e3d88$var$BORDER_INDEX = 1;
var $b08054daa26e3d88$var$MARGIN_INDEX = 0;
function $b08054daa26e3d88$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $b08054daa26e3d88$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === 'border') cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($b08054daa26e3d88$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $b08054daa26e3d88$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$b08054daa26e3d88$var$each([
    'Width',
    'Height'
], function(name) {
    $b08054daa26e3d88$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $b08054daa26e3d88$var$domUtils["viewport".concat(name)](d));
    };
    $b08054daa26e3d88$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $b08054daa26e3d88$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($b08054daa26e3d88$var$isWindow(elem)) return name === 'width' ? $b08054daa26e3d88$var$domUtils.viewportWidth(elem) : $b08054daa26e3d88$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $b08054daa26e3d88$var$domUtils.docWidth(elem) : $b08054daa26e3d88$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $b08054daa26e3d88$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $b08054daa26e3d88$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $b08054daa26e3d88$var$BORDER_INDEX : $b08054daa26e3d88$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $b08054daa26e3d88$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $b08054daa26e3d88$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $b08054daa26e3d88$var$BORDER_INDEX) return val;
        return val + (extra === $b08054daa26e3d88$var$PADDING_INDEX ? -$b08054daa26e3d88$var$getPBMWidth(elem, [
            'border'
        ], which) : $b08054daa26e3d88$var$getPBMWidth(elem, [
            'margin'
        ], which));
    }
    return cssBoxValue + $b08054daa26e3d88$var$getPBMWidth(elem, $b08054daa26e3d88$var$BOX_MODELS.slice(extra), which);
}
var $b08054daa26e3d88$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $b08054daa26e3d88$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $b08054daa26e3d88$var$getWH.apply(undefined, args);
    else $b08054daa26e3d88$var$swap(elem, $b08054daa26e3d88$var$cssShow, function() {
        val = $b08054daa26e3d88$var$getWH.apply(undefined, args);
    });
    return val;
}
$b08054daa26e3d88$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $b08054daa26e3d88$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $b08054daa26e3d88$var$getWHIgnoreDisplay(el, name, includeMargin ? $b08054daa26e3d88$var$MARGIN_INDEX : $b08054daa26e3d88$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $b08054daa26e3d88$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $b08054daa26e3d88$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $b08054daa26e3d88$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which);
                return $b08054daa26e3d88$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $b08054daa26e3d88$var$getWHIgnoreDisplay(elem, name, $b08054daa26e3d88$var$CONTENT_INDEX);
    };
});
function $b08054daa26e3d88$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $b08054daa26e3d88$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $b08054daa26e3d88$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') $b08054daa26e3d88$var$setOffset(el, value, option || {});
        else return $b08054daa26e3d88$var$getOffset(el);
    },
    isWindow: $b08054daa26e3d88$var$isWindow,
    each: $b08054daa26e3d88$var$each,
    css: $b08054daa26e3d88$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $b08054daa26e3d88$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $b08054daa26e3d88$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $b08054daa26e3d88$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$b08054daa26e3d88$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$b08054daa26e3d88$var$mix($b08054daa26e3d88$var$utils, $b08054daa26e3d88$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $b08054daa26e3d88$var$getParent = $b08054daa26e3d88$var$utils.getParent;
function $b08054daa26e3d88$var$getOffsetParent(element) {
    if ($b08054daa26e3d88$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $b08054daa26e3d88$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $b08054daa26e3d88$var$utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) return element.nodeName.toLowerCase() === 'html' ? null : $b08054daa26e3d88$var$getParent(element);
    for(parent = $b08054daa26e3d88$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $b08054daa26e3d88$var$getParent(parent)){
        positionStyle = $b08054daa26e3d88$var$utils.css(parent, 'position');
        if (positionStyle !== 'static') return parent;
    }
    return null;
}
var $b08054daa26e3d88$var$getParent$1 = $b08054daa26e3d88$var$utils.getParent;
function $b08054daa26e3d88$var$isAncestorFixed(element) {
    if ($b08054daa26e3d88$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $b08054daa26e3d88$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $b08054daa26e3d88$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $b08054daa26e3d88$var$getParent$1(parent)){
        var positionStyle = $b08054daa26e3d88$var$utils.css(parent, 'position');
        if (positionStyle === 'fixed') return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $b08054daa26e3d88$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $b08054daa26e3d88$var$getOffsetParent(element);
    var doc = $b08054daa26e3d88$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $b08054daa26e3d88$var$utils.css(el, 'overflow') !== 'visible') {
            var pos = $b08054daa26e3d88$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $b08054daa26e3d88$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$b08054daa26e3d88$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $b08054daa26e3d88$var$utils.css(element, 'position');
        if (position === 'absolute') element.style.position = 'fixed';
    }
    var scrollX = $b08054daa26e3d88$var$utils.getWindowScrollLeft(win);
    var scrollY = $b08054daa26e3d88$var$utils.getWindowScrollTop(win);
    var viewportWidth = $b08054daa26e3d88$var$utils.viewportWidth(win);
    var viewportHeight = $b08054daa26e3d88$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === 'hidden') documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $b08054daa26e3d88$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $b08054daa26e3d88$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $b08054daa26e3d88$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $b08054daa26e3d88$var$utils.mix(pos, size);
}
function $b08054daa26e3d88$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$b08054daa26e3d88$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $b08054daa26e3d88$var$utils.offset(node);
        w = $b08054daa26e3d88$var$utils.outerWidth(node);
        h = $b08054daa26e3d88$var$utils.outerHeight(node);
    } else {
        var win = $b08054daa26e3d88$var$utils.getWindow(node);
        offset = {
            left: $b08054daa26e3d88$var$utils.getWindowScrollLeft(win),
            top: $b08054daa26e3d88$var$utils.getWindowScrollTop(win)
        };
        w = $b08054daa26e3d88$var$utils.viewportWidth(win);
        h = $b08054daa26e3d88$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $b08054daa26e3d88$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') y += h / 2;
    else if (V === 'b') y += h;
    if (H === 'c') x += w / 2;
    else if (H === 'r') x += w;
    return {
        left: x,
        top: y
    };
}
function $b08054daa26e3d88$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $b08054daa26e3d88$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $b08054daa26e3d88$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $b08054daa26e3d88$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $b08054daa26e3d88$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $b08054daa26e3d88$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $b08054daa26e3d88$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $b08054daa26e3d88$var$flip(points, reg, map) {
    var ret = [];
    $b08054daa26e3d88$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $b08054daa26e3d88$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $b08054daa26e3d88$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $b08054daa26e3d88$var$normalizeOffset(offset, el) {
    offset[0] = $b08054daa26e3d88$var$convertOffset(offset[0], el.width);
    offset[1] = $b08054daa26e3d88$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $b08054daa26e3d88$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $b08054daa26e3d88$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $b08054daa26e3d88$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $b08054daa26e3d88$var$normalizeOffset(offset, elRegion);
    $b08054daa26e3d88$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $b08054daa26e3d88$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $b08054daa26e3d88$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($b08054daa26e3d88$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $b08054daa26e3d88$var$flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
                // 偏移量也反下
                var newOffset = $b08054daa26e3d88$var$flipOffset(offset, 0);
                var newTargetOffset = $b08054daa26e3d88$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $b08054daa26e3d88$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$b08054daa26e3d88$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($b08054daa26e3d88$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $b08054daa26e3d88$var$flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
                // 偏移量也反下
                var _newOffset = $b08054daa26e3d88$var$flipOffset(offset, 1);
                var _newTargetOffset = $b08054daa26e3d88$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $b08054daa26e3d88$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$b08054daa26e3d88$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $b08054daa26e3d88$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $b08054daa26e3d88$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $b08054daa26e3d88$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $b08054daa26e3d88$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $b08054daa26e3d88$var$flip(points, /[lr]/gi, {
                l: 'r',
                r: 'l'
            });
            if (isStillFailY) _newPoints2 = $b08054daa26e3d88$var$flip(points, /[tb]/gi, {
                t: 'b',
                b: 't'
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $b08054daa26e3d88$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $b08054daa26e3d88$var$utils.css(source, 'width', $b08054daa26e3d88$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $b08054daa26e3d88$var$utils.css(source, 'height', $b08054daa26e3d88$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $b08054daa26e3d88$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $b08054daa26e3d88$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $b08054daa26e3d88$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $b08054daa26e3d88$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $b08054daa26e3d88$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $b08054daa26e3d88$var$getRegion(target);
    var isTargetNotOutOfVisible = !$b08054daa26e3d88$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $b08054daa26e3d88$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$b08054daa26e3d88$export$ec21431d5ee6c534.__getOffsetParent = $b08054daa26e3d88$var$getOffsetParent;
$b08054daa26e3d88$export$ec21431d5ee6c534.__getVisibleRectForElement = $b08054daa26e3d88$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $b08054daa26e3d88$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $b08054daa26e3d88$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $b08054daa26e3d88$var$utils.getWindowScrollLeft(win);
    var scrollY = $b08054daa26e3d88$var$utils.getWindowScrollTop(win);
    var viewportWidth = $b08054daa26e3d88$var$utils.viewportWidth(win);
    var viewportHeight = $b08054daa26e3d88$var$utils.viewportHeight(win);
    if ('pageX' in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ('pageY' in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        'cc'
    ];
    return $b08054daa26e3d88$var$doAlign(el, tgtRegion, $b08054daa26e3d88$var$_objectSpread2($b08054daa26e3d88$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $b08054daa26e3d88$export$2e2bcd8739ae039 = $b08054daa26e3d88$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $3f466113f203e002$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $119894c7f6ed90f3$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(a) === 'object' && (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $3f466113f203e002$export$2e2bcd8739ae039 = $3f466113f203e002$var$isEqual;



var $9ff5b332bc575c4f$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $iD6kw = parcelRequire("iD6kw");

var $iD6kw = parcelRequire("iD6kw");
var $ebf45a4b8427ca39$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $2f9cfb579bd5227e$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function get() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $2f9cfb579bd5227e$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $2f9cfb579bd5227e$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $2f9cfb579bd5227e$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($2f9cfb579bd5227e$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $2f9cfb579bd5227e$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $2f9cfb579bd5227e$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $2f9cfb579bd5227e$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $2f9cfb579bd5227e$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $2f9cfb579bd5227e$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $2f9cfb579bd5227e$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $2f9cfb579bd5227e$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $2f9cfb579bd5227e$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $2f9cfb579bd5227e$var$throttle(this.refresh.bind(this), $2f9cfb579bd5227e$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$2f9cfb579bd5227e$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($2f9cfb579bd5227e$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$2f9cfb579bd5227e$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $2f9cfb579bd5227e$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $2f9cfb579bd5227e$var$defineConfigurable = function defineConfigurable(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $2f9cfb579bd5227e$var$getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $2f9cfb579bd5227e$var$global$1;
};
// Placeholder of an empty content rectangle.
var $2f9cfb579bd5227e$var$emptyRect = $2f9cfb579bd5227e$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $2f9cfb579bd5227e$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $2f9cfb579bd5227e$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $2f9cfb579bd5227e$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $2f9cfb579bd5227e$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $2f9cfb579bd5227e$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $2f9cfb579bd5227e$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $2f9cfb579bd5227e$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $2f9cfb579bd5227e$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $2f9cfb579bd5227e$var$emptyRect;
    var styles = $2f9cfb579bd5227e$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $2f9cfb579bd5227e$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $2f9cfb579bd5227e$var$toFloat(styles.width), height = $2f9cfb579bd5227e$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $2f9cfb579bd5227e$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $2f9cfb579bd5227e$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$2f9cfb579bd5227e$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $2f9cfb579bd5227e$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $2f9cfb579bd5227e$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $2f9cfb579bd5227e$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $2f9cfb579bd5227e$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $2f9cfb579bd5227e$var$isDocumentElement(target) {
    return target === $2f9cfb579bd5227e$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $2f9cfb579bd5227e$var$getContentRect(target) {
    if (!$2f9cfb579bd5227e$var$isBrowser) return $2f9cfb579bd5227e$var$emptyRect;
    if ($2f9cfb579bd5227e$var$isSVGGraphicsElement(target)) return $2f9cfb579bd5227e$var$getSVGContentRect(target);
    return $2f9cfb579bd5227e$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $2f9cfb579bd5227e$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $2f9cfb579bd5227e$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $2f9cfb579bd5227e$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $2f9cfb579bd5227e$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $2f9cfb579bd5227e$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $2f9cfb579bd5227e$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $2f9cfb579bd5227e$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $2f9cfb579bd5227e$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $2f9cfb579bd5227e$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $2f9cfb579bd5227e$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $2f9cfb579bd5227e$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $2f9cfb579bd5227e$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $2f9cfb579bd5227e$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $2f9cfb579bd5227e$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $2f9cfb579bd5227e$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $2f9cfb579bd5227e$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $2f9cfb579bd5227e$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $2f9cfb579bd5227e$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $2f9cfb579bd5227e$var$ResizeObserverController.getInstance();
        var observer = new $2f9cfb579bd5227e$var$ResizeObserverSPI(callback, controller, this);
        $2f9cfb579bd5227e$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $2f9cfb579bd5227e$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $2f9cfb579bd5227e$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $2f9cfb579bd5227e$var$index = function() {
    // Export existing implementation if available.
    if (typeof $2f9cfb579bd5227e$var$global$1.ResizeObserver !== 'undefined') return $2f9cfb579bd5227e$var$global$1.ResizeObserver;
    return $2f9cfb579bd5227e$var$ResizeObserver;
}();
var $2f9cfb579bd5227e$export$2e2bcd8739ae039 = $2f9cfb579bd5227e$var$index;



function $2edf7d1827c049f4$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ('clientX' in next && 'clientY' in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $2edf7d1827c049f4$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $c2f48dfe2c4ac7c3$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === 'function') activeElement.focus();
}
function $2edf7d1827c049f4$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $2f9cfb579bd5227e$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $e7b3036bd67766d0$var$getElement(func) {
    if (typeof func !== 'function') return null;
    return func();
}
function $e7b3036bd67766d0$var$getPoint(point) {
    if ((0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(point) !== 'object' || !point) return null;
    return point;
}
var $e7b3036bd67766d0$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $ebf45a4b8427ca39$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $e7b3036bd67766d0$var$getElement(latestTarget);
            var _point = $e7b3036bd67766d0$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $9ff5b332bc575c4f$export$2e2bcd8739ae039)(_element)) _result = (0, $b08054daa26e3d88$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $b08054daa26e3d88$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $2edf7d1827c049f4$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useState(), _React$useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useState(), _React$useState4 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $0badc1c2e3baef5c$export$2e2bcd8739ae039)(function() {
        setElement($e7b3036bd67766d0$var$getElement(target));
        setPoint($e7b3036bd67766d0$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $2edf7d1827c049f4$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $3f466113f203e002$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useEffect(function() {
        var cancelFn = (0, $2edf7d1827c049f4$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useEffect(function() {
        var cancelFn = (0, $2edf7d1827c049f4$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(window, 'resize', _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).cloneElement(childNode, {
        ref: (0, $7d1487c029c498a5$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $e7b3036bd67766d0$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).forwardRef($e7b3036bd67766d0$var$Align);
$e7b3036bd67766d0$var$RcAlign.displayName = 'Align';
var $e7b3036bd67766d0$export$2e2bcd8739ae039 = $e7b3036bd67766d0$var$RcAlign;


var $c195314cf099e3c5$export$2e2bcd8739ae039 = (0, $e7b3036bd67766d0$export$2e2bcd8739ae039);





function $16b9f9773a019e5a$export$2e2bcd8739ae039(e, d) {
    this.v = e, this.k = d;
}


function $ed6f213134e1130c$export$2e2bcd8739ae039(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    $ed6f213134e1130c$export$2e2bcd8739ae039 = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $ed6f213134e1130c$export$2e2bcd8739ae039(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, $ed6f213134e1130c$export$2e2bcd8739ae039(e, r, n, t);
}


function $2f869db9aab419e7$export$2e2bcd8739ae039() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        _$i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ((0, $ed6f213134e1130c$export$2e2bcd8739ae039)(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(u, "constructor", GeneratorFunctionPrototype), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(GeneratorFunctionPrototype, o, "GeneratorFunction"), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(u), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(u, o, "Generator"), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(u, n, function() {
        return this;
    }), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(u, "toString", function() {
        return "[object Generator]";
    }), ($2f869db9aab419e7$export$2e2bcd8739ae039 = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}





function $fb4d3a24fd0fa132$export$2e2bcd8739ae039(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof (0, $16b9f9773a019e5a$export$2e2bcd8739ae039) ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ((0, $ed6f213134e1130c$export$2e2bcd8739ae039)($fb4d3a24fd0fa132$export$2e2bcd8739ae039.prototype), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)($fb4d3a24fd0fa132$export$2e2bcd8739ae039.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), (0, $ed6f213134e1130c$export$2e2bcd8739ae039)(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}


function $5ece0bafa5b99d54$export$2e2bcd8739ae039(r, e, t, o, n) {
    return new (0, $fb4d3a24fd0fa132$export$2e2bcd8739ae039)((0, $2f869db9aab419e7$export$2e2bcd8739ae039)().w(r, e, t, o), n || Promise);
}


function $4757d7d5ba0309e8$export$2e2bcd8739ae039(n, e, r, t, o) {
    var a = (0, $5ece0bafa5b99d54$export$2e2bcd8739ae039)(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}




function $c5ca03fc71d5edef$export$2e2bcd8739ae039(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}



function $fcd80a8472f02945$export$2e2bcd8739ae039(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError((0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(e) + " is not iterable");
}


function $8fc6f7eab391ed28$export$2e2bcd8739ae039() {
    "use strict";
    var r = (0, $2f869db9aab419e7$export$2e2bcd8739ae039)(), e = r.m($8fc6f7eab391ed28$export$2e2bcd8739ae039), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, (0, $fcd80a8472f02945$export$2e2bcd8739ae039)(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return ($8fc6f7eab391ed28$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new (0, $16b9f9773a019e5a$export$2e2bcd8739ae039)(r, e);
            },
            AsyncIterator: (0, $fb4d3a24fd0fa132$export$2e2bcd8739ae039),
            async: function async(r, e, t, o, u) {
                return (n(e) ? (0, $5ece0bafa5b99d54$export$2e2bcd8739ae039) : (0, $4757d7d5ba0309e8$export$2e2bcd8739ae039))(a(r), e, t, o, u);
            },
            keys: (0, $c5ca03fc71d5edef$export$2e2bcd8739ae039),
            values: (0, $fcd80a8472f02945$export$2e2bcd8739ae039)
        };
    })();
}


function $1ffcb8026440c8c9$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $1ffcb8026440c8c9$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $1ffcb8026440c8c9$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $1ffcb8026440c8c9$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}




var $iD6kw = parcelRequire("iD6kw");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $c6e6e46ab2f3779f$var$StatusQueue = [
    'measure',
    'alignPre',
    'align',
    null,
    'motion'
];
var $c6e6e46ab2f3779f$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $83475d5f0d729f94$export$2e2bcd8739ae039)(null), _useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $iD6kw.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $f91fc991ef4317d7$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $f91fc991ef4317d7$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $iD6kw.useEffect)(function() {
        setStatus('measure');
    }, [
        visible
    ]); // Go next status
    (0, $iD6kw.useEffect)(function() {
        switch(status){
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $f91fc991ef4317d7$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1ffcb8026440c8c9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $8fc6f7eab391ed28$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $8fc6f7eab391ed28$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $c6e6e46ab2f3779f$var$StatusQueue.indexOf(status);
                        nextStatus = $c6e6e46ab2f3779f$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $iD6kw.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $iD6kw = parcelRequire("iD6kw");
var $e4e167210ccdee29$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $iD6kw.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $iD6kw.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf('minHeight') !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf('width') !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf('minWidth') !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $0ff8e1573e0d2285$var$PopupInner = /*#__PURE__*/ $iD6kw.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $iD6kw.useRef)();
    var elementRef = (0, $iD6kw.useRef)();
    var _useState = (0, $iD6kw.useState)(), _useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $e4e167210ccdee29$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $c6e6e46ab2f3779f$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $iD6kw.useState)(0), _useState4 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $iD6kw.useRef)();
    (0, $0badc1c2e3baef5c$export$2e2bcd8739ae039)(function() {
        if (status === 'alignPre') setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === 'align') onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $0badc1c2e3baef5c$export$2e2bcd8739ae039)(function() {
        if (status === 'align') {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, (0, $639733b56106983d$export$7b8936ddc277a29a)(props));
    [
        'onAppearEnd',
        'onEnterEnd',
        'onLeaveEnd'
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $iD6kw.useEffect(function() {
        if (!motion.motionName && status === 'motion') goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $iD6kw.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($iD6kw.Children.count(children) > 1) childNode = /*#__PURE__*/ $iD6kw.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $iD6kw.createElement((0, $085a120a08a20c85$export$2e2bcd8739ae039), (0, $lS58v.default)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $iD6kw.createElement((0, $c195314cf099e3c5$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $iD6kw.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$0ff8e1573e0d2285$var$PopupInner.displayName = 'PopupInner';
var $0ff8e1573e0d2285$export$2e2bcd8739ae039 = $0ff8e1573e0d2285$var$PopupInner;



var $lS58v = parcelRequire("lS58v");


var $iD6kw = parcelRequire("iD6kw");


var $60895f3caf6775e5$var$MobilePopupInner = /*#__PURE__*/ $iD6kw.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $iD6kw.useRef(); // ========================= Refs =========================
    $iD6kw.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($iD6kw.Children.count(children) > 1) childNode = /*#__PURE__*/ $iD6kw.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $iD6kw.createElement((0, $085a120a08a20c85$export$2e2bcd8739ae039), (0, $lS58v.default)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $iD6kw.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$60895f3caf6775e5$var$MobilePopupInner.displayName = 'MobilePopupInner';
var $60895f3caf6775e5$export$2e2bcd8739ae039 = $60895f3caf6775e5$var$MobilePopupInner;


var $acfe3e928d2b0cfe$var$_excluded = [
    "visible",
    "mobile"
];
var $acfe3e928d2b0cfe$var$Popup = /*#__PURE__*/ $iD6kw.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(_ref, $acfe3e928d2b0cfe$var$_excluded);
    var _useState = (0, $iD6kw.useState)(visible), _useState2 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $iD6kw.useState)(false), _useState4 = (0, $f662ed85e1f779a6$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $iD6kw.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $ccb62fbbf82dc1fa$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $iD6kw.createElement((0, $60895f3caf6775e5$export$2e2bcd8739ae039), (0, $lS58v.default)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $iD6kw.createElement((0, $0ff8e1573e0d2285$export$2e2bcd8739ae039), (0, $lS58v.default)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $iD6kw.createElement("div", null, /*#__PURE__*/ $iD6kw.createElement((0, $5ffac8d802db55a8$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$acfe3e928d2b0cfe$var$Popup.displayName = 'Popup';
var $acfe3e928d2b0cfe$export$2e2bcd8739ae039 = $acfe3e928d2b0cfe$var$Popup;



var $iD6kw = parcelRequire("iD6kw");
var $49e1c07b2daac50c$var$TriggerContext = /*#__PURE__*/ $iD6kw.createContext(null);
var $49e1c07b2daac50c$export$2e2bcd8739ae039 = $49e1c07b2daac50c$var$TriggerContext;


function $25df894be634b032$var$noop() {}
function $25df894be634b032$var$returnEmptyString() {
    return '';
}
function $25df894be634b032$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $25df894be634b032$var$ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu'
];
function $25df894be634b032$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "popupRef", /*#__PURE__*/ $iD6kw.createRef());
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "triggerRef", /*#__PURE__*/ $iD6kw.createRef());
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "portalContainer", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "attachId", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "clickOutsideHandler", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "touchOutsideHandler", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "mouseDownTimeout", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "focusTime", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "preClickTime", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "preTouchTime", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "delayTimer", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "hasPopupMouseDown", void 0);
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents('onMouseEnter', e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onMouseMove", function(e) {
                _this.fireEvents('onMouseMove', e);
                _this.setPoint(e);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onMouseLeave", function(e) {
                _this.fireEvents('onMouseLeave', e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $c2f48dfe2c4ac7c3$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onFocus", function(e) {
                _this.fireEvents('onFocus', e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onMouseDown", function(e) {
                _this.fireEvents('onMouseDown', e);
                _this.preClickTime = Date.now();
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onTouchStart", function(e) {
                _this.fireEvents('onTouchStart', e);
                _this.preTouchTime = Date.now();
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onBlur", function(e) {
                _this.fireEvents('onBlur', e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents('onContextMenu', e);
                _this.setPopupVisible(true, e);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onClick", function(event) {
                _this.fireEvents('onClick', event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $c2f48dfe2c4ac7c3$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $c2f48dfe2c4ac7c3$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $460d2bf0cfa06e5f$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($kqzqZ))).findDOMNode((0, $ktpIU.default)(_this));
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $2b7c505fc67bfb1b$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(' ');
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $iD6kw.createElement((0, $acfe3e928d2b0cfe$export$2e2bcd8739ae039), (0, $lS58v.default)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === 'function' ? popup() : popup);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "attachParent", function(popupContainer) {
                (0, $f91fc991ef4317d7$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $f91fc991ef4317d7$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = 'absolute';
                    popupContainer.style.top = '0';
                    popupContainer.style.left = '0';
                    popupContainer.style.width = '100%';
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $0708e163b377474d$export$2e2bcd8739ae039)((0, $ktpIU.default)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ('popupVisible' in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $25df894be634b032$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(currentDocument, 'mousedown', this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(currentDocument, 'touchstart', this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(currentDocument, 'scroll', this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $45d8c47bc91d25b5$export$2e2bcd8739ae039)(window, 'blur', this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $f91fc991ef4317d7$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $2b7c505fc67bfb1b$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!('popupVisible' in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $iD6kw.Children.only(children);
                    var newChildProps = {
                        key: 'trigger'
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains('onClick');
                        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
                        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains('onFocus');
                        newChildProps.onBlur = this.createTwoChains('onBlur');
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $7d1487c029c498a5$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $7d1487c029c498a5$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $iD6kw.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $iD6kw.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $iD6kw.createElement((0, $49e1c07b2daac50c$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($iD6kw.Component);
    (0, $0708e163b377474d$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $49e1c07b2daac50c$export$2e2bcd8739ae039));
    (0, $0708e163b377474d$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: $25df894be634b032$var$returnEmptyString,
        getDocument: $25df894be634b032$var$returnDocument,
        onPopupVisibleChange: $25df894be634b032$var$noop,
        afterPopupVisibleChange: $25df894be634b032$var$noop,
        onPopupAlign: $25df894be634b032$var$noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $25df894be634b032$export$2e2bcd8739ae039 = $25df894be634b032$export$55e99723d7f71b47((0, $a2a77e10342ccc91$export$2e2bcd8739ae039));


var $8d4e41e4bddcedc0$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $8d4e41e4bddcedc0$var$targetOffset = [
    0,
    0
];
var $8d4e41e4bddcedc0$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $8d4e41e4bddcedc0$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $8d4e41e4bddcedc0$var$targetOffset
    }
};
var $8d4e41e4bddcedc0$export$2e2bcd8739ae039 = $8d4e41e4bddcedc0$export$803cd8101b6c182b;



var $iD6kw = parcelRequire("iD6kw");

function $9990dbdd49342cf8$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $iD6kw.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($902038315dedde89$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $iD6kw.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $iD6kw.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === 'function' ? children() : children));
}


var $f8ed5218c264345d$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $f8ed5218c264345d$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(props, $f8ed5218c264345d$var$_excluded);
    var domRef = (0, $iD6kw.useRef)(null);
    (0, $iD6kw.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $iD6kw.createElement((0, $9990dbdd49342cf8$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === 'boolean') destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $ea75824a91acdfa9$export$2e2bcd8739ae039)(destroyTooltipOnHide) === 'object') {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $iD6kw.createElement((0, $25df894be634b032$export$2e2bcd8739ae039), (0, $lS58v.default)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $8d4e41e4bddcedc0$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $f8ed5218c264345d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iD6kw.forwardRef)($f8ed5218c264345d$var$Tooltip);



var $fec4cd9b0f60c66f$export$2e2bcd8739ae039 = (0, $f8ed5218c264345d$export$2e2bcd8739ae039);




var $9866ffb4fcd8a2dc$var$SliderTooltip = /*#__PURE__*/ $iD6kw.forwardRef(function(props, ref) {
    var visible = props.visible, overlay = props.overlay;
    var innerRef = $iD6kw.useRef(null);
    var tooltipRef = (0, $7d1487c029c498a5$export$ab452c34e8e05029)(ref, innerRef);
    var rafRef = $iD6kw.useRef(null);
    function cancelKeepAlign() {
        (0, $f91fc991ef4317d7$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function keepAlign() {
        rafRef.current = (0, $f91fc991ef4317d7$export$2e2bcd8739ae039)(function() {
            var _innerRef$current;
            (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.forcePopupAlign();
        });
    }
    $iD6kw.useEffect(function() {
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        visible,
        overlay
    ]);
    return /*#__PURE__*/ $iD6kw.createElement((0, $fec4cd9b0f60c66f$export$2e2bcd8739ae039), (0, $lS58v.default)({
        ref: tooltipRef
    }, props));
});
var $9866ffb4fcd8a2dc$export$2e2bcd8739ae039 = $9866ffb4fcd8a2dc$var$SliderTooltip;



function $f235c188328ef41a$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_React$Component) {
        (0, $bd1a2e8407b8d15a$export$2e2bcd8739ae039)(ComponentWrapper, _React$Component);
        var _super = (0, $ac06abbc181c1025$export$2e2bcd8739ae039)(ComponentWrapper);
        function ComponentWrapper() {
            var _this;
            (0, $4b052c91de22d3b4$export$2e2bcd8739ae039)(this, ComponentWrapper);
            _this = _super.apply(this, arguments);
            _this.state = {
                visibles: {}
            };
            _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)((0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, prevState.visibles), {}, (0, $0708e163b377474d$export$2e2bcd8739ae039)({}, index, visible))
                    };
                });
            };
            _this.handleWithTooltip = function(_ref) {
                var value = _ref.value, dragging = _ref.dragging, index = _ref.index, disabled = _ref.disabled, restProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(_ref, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = (0, $2dac754b4e590c46$export$2e2bcd8739ae039)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $9866ffb4fcd8a2dc$export$2e2bcd8739ae039), (0, $lS58v.default)({}, restTooltipProps, {
                    getTooltipContainer: getTooltipContainer,
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement((0, $92406aaedd12d98a$export$2e2bcd8739ae039), (0, $lS58v.default)({}, restProps, {
                    style: (0, $1b1211ceaac608a8$export$2e2bcd8739ae039)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            };
            return _this;
        }
        (0, $6a9eef385d5795e7$export$2e2bcd8739ae039)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement(Component, (0, $lS58v.default)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component), _a.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {},
        getTooltipContainer: function getTooltipContainer(node) {
            return node.parentNode;
        }
    }, _a;
}



var $5036435048c78e31$var$InternalSlider = (0, $d72cd91ac291ffa5$export$2e2bcd8739ae039);
$5036435048c78e31$var$InternalSlider.Range = (0, $9866bb6bfecd9337$export$2e2bcd8739ae039);
$5036435048c78e31$var$InternalSlider.Handle = (0, $92406aaedd12d98a$export$2e2bcd8739ae039);
$5036435048c78e31$var$InternalSlider.createSliderWithTooltip = (0, $f235c188328ef41a$export$2e2bcd8739ae039);
var $5036435048c78e31$export$2e2bcd8739ae039 = $5036435048c78e31$var$InternalSlider;



var $iD6kw = parcelRequire("iD6kw");
var $5b3e37cc591483d1$var$Range = /*#__PURE__*/ function(_React_PureComponent) {
    "use strict";
    (0, $c2MhV._)(Range, _React_PureComponent);
    function Range(props) {
        (0, $4QweW._)(this, Range);
        var _this;
        _this = (0, $ehF45._)(this, Range, [
            props
        ]), (0, $6tY97._)(_this, "componentDidMount", function() {
            _this.props.handleChange(_this.state.startValue);
        });
        /**
		 * Use the constructor to push marks and startValue into state
		 * so it can be used in componentDidMount to trigger the onChange method
		 * (range input always has a kind of 'active' state so the user could
		 * just accept the current value and continue in the form)
		 */ var _this_props = _this.props, options = _this_props.options, type = _this_props.scaleOptions.type, defaultValue = _this_props.defaultValue;
        // Set marks
        var marks = {};
        if (type === 'fixed') {
            var steps = 100 / (options.length - 1);
            for(var i = 0, value = 0; i < options.length; i++, value += steps)marks[value] = options[i].label;
        } else // type: percentage
        marks = {
            0: '0 %',
            100: '100 %'
        };
        // Set start value
        var startValue;
        if (type === 'fixed') {
            var steps1 = 100 / (options.length - 1);
            if (defaultValue) startValue = steps1 * defaultValue;
            else // Check if the number of options is even
            startValue = options.length % 2 === 0 ? steps1 * Math.ceil(options.length / 2) : 50;
        } else // type: percentage
        startValue = defaultValue ? defaultValue : 50;
        _this.state = {
            marks: marks,
            startValue: startValue
        };
        return _this;
    }
    (0, $6hK4i._)(Range, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, _this_props_scaleOptions = _this_props.scaleOptions, type = _this_props_scaleOptions.type, knob_type = _this_props_scaleOptions.knob_type, tooltip = _this_props_scaleOptions.tooltip, background = _this_props_scaleOptions.background, reverse = _this_props_scaleOptions.reverse, handleChange = _this_props.handleChange;
                var Handle = (0, $5036435048c78e31$export$2e2bcd8739ae039).Handle;
                var handle = function(props) {
                    var value = props.value, dragging = props.dragging, index = props.index, restProps = (0, $1DiK7._)(props, [
                        "value",
                        "dragging",
                        "index"
                    ]);
                    var tooltipText = tooltip.replace('[value]', type === 'percentage' ? value : _this.state.marks[value]);
                    return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $9866ffb4fcd8a2dc$export$2e2bcd8739ae039), {
                        prefixCls: "rc-slider-tooltip",
                        overlay: tooltipText,
                        visible: dragging,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $9HB6H.jsx)(Handle, (0, $kWfK0._)({
                            value: value
                        }, restProps))
                    }, index);
                };
                var attributes = {
                    className: "knob-type--".concat(knob_type),
                    included: background,
                    reverse: reverse,
                    marks: this.state.marks,
                    step: type === 'fixed' ? null : 1,
                    onChange: handleChange,
                    defaultValue: this.state.startValue
                };
                return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $5036435048c78e31$export$2e2bcd8739ae039), (0, $kWfK0._)({}, attributes, tooltip && {
                    handle: handle
                }));
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).PureComponent);
var $5b3e37cc591483d1$export$2e2bcd8739ae039 = $5b3e37cc591483d1$var$Range;
$5b3e37cc591483d1$var$Range.propTypes = {
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).any,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).any,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).any,
    scaleOptions: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).any
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");
var $d9fd09e9e40ac326$var$Toggle = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Toggle, _React_Component);
    function Toggle() {
        (0, $4QweW._)(this, Toggle);
        return (0, $ehF45._)(this, Toggle, arguments);
    }
    (0, $6hK4i._)(Toggle, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, id = _this_props.id, name = _this_props.name, title = _this_props.title, checked = _this_props.checked, handleChange = _this_props.handleChange;
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "input",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsx)("label", {
                            htmlFor: id,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("input", {
                            type: "checkbox",
                            name: name,
                            id: id,
                            onChange: handleChange,
                            checked: checked
                        })
                    ]
                });
            }
        }
    ]);
    return Toggle;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $d9fd09e9e40ac326$export$2e2bcd8739ae039 = $d9fd09e9e40ac326$var$Toggle;
$d9fd09e9e40ac326$var$Toggle.propTypes = {
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};


var $d03b1a42095698b4$var$Question = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Question, _React_Component);
    function Question() {
        (0, $4QweW._)(this, Question);
        var _this;
        _this = (0, $ehF45._)(this, Question, arguments), (0, $6tY97._)(_this, "getAnswer", function(question, type) {
            var answers = question.answers;
            var userInput = _this.props.userInput;
            var answer;
            switch(type){
                case 'scale':
                    answer = /*#__PURE__*/ (0, $9HB6H.jsx)((0, $5b3e37cc591483d1$export$2e2bcd8739ae039), {
                        options: answers,
                        scaleOptions: question.scale_options,
                        defaultValue: userInput,
                        handleChange: _this.props.handleSliderChange
                    }, question.ID);
                    break;
                case 'dropdown':
                    answer = /*#__PURE__*/ (0, $9HB6H.jsx)((0, $427009064b9728dc$export$2e2bcd8739ae039), {
                        name: question.ID,
                        options: answers,
                        defaultValue: userInput,
                        placeholder: question.dropdown_options.placeholder,
                        handleChange: _this.props.handleChange
                    }, question.ID);
                    break;
                default:
                    answer = Object.keys(answers).map(function(key) {
                        var uniqueKey = question.ID + '_' + key;
                        var props = {
                            id: key,
                            name: question.ID,
                            title: answers[key].label,
                            checked: type === 'single' ? userInput === parseInt(key) : userInput && userInput.length ? userInput.includes(parseInt(key)) : false,
                            handleChange: _this.props.handleChange
                        };
                        return type === 'single' ? /*#__PURE__*/ (0, $9HB6H.jsx)((0, $2d3b2531d0e2536f$export$2e2bcd8739ae039), (0, $kWfK0._)({}, props), uniqueKey) : /*#__PURE__*/ (0, $9HB6H.jsx)((0, $d9fd09e9e40ac326$export$2e2bcd8739ae039), (0, $kWfK0._)({}, props), uniqueKey);
                    });
            }
            return answer;
        });
        return _this;
    }
    (0, $6hK4i._)(Question, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, question = _this_props.question, labels = _this_props.labels;
                var type = question.input_type;
                var answer_count = question.answers.length > 1 ? question.answers.length : 0;
                var hint = '';
                switch(type){
                    case 'multiple':
                        hint = labels.multiple_hint;
                        break;
                    case 'single':
                        hint = labels.appropriate_answer;
                        break;
                    case 'scale':
                        hint = question.scale_options.type === 'fixed' ? labels.appropriate_answer : labels.estimate_in_percent;
                        break;
                }
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "ms-form__question",
                    "data-type": type,
                    "data-count": answer_count,
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                            className: "ms-form__headlines",
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsx)("h4", {
                                    children: question.title
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsx)("h5", {
                                    children: hint !== '' && "(".concat(hint, ")")
                                })
                            ]
                        }),
                        question.image && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "ms-form__header-image",
                            children: question.image && /*#__PURE__*/ (0, $9HB6H.jsx)((0, $32fed3bba8842c5f$export$2e2bcd8739ae039), {
                                image: question.image
                            })
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "ms-form__answers",
                            children: /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                className: "ms-form__answers__".concat(type),
                                children: this.getAnswer(question, type)
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Question;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $d03b1a42095698b4$export$2e2bcd8739ae039 = $d03b1a42095698b4$var$Question;
$d03b1a42095698b4$var$Question.propTypes = {
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    handleSliderChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    question: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).array
    ])
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");


var $a9cb228b2906bac6$var$Result = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Result, _React_Component);
    function Result(props) {
        (0, $4QweW._)(this, Result);
        var _this;
        _this = (0, $ehF45._)(this, Result, [
            props
        ]), (0, $6tY97._)(_this, "getCircle", function(viewBoxSize, className) {
            var size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '31.831';
            var spacer = (viewBoxSize - size) / 2;
            var half_the_size = size / 2;
            return /*#__PURE__*/ (0, $9HB6H.jsx)("path", {
                className: className,
                d: "M".concat(half_the_size + spacer, " ").concat(spacer, "a ").concat(half_the_size, " ").concat(half_the_size, " 0 0 1 0 ").concat(size, "a ").concat(half_the_size, " ").concat(half_the_size, " 0 0 1 0 -").concat(size)
            });
        }), (0, $6tY97._)(_this, "getBulletPoints", function(bullets) {
            return Object.keys(bullets).map(function(key, index) {
                return /*#__PURE__*/ (0, $9HB6H.jsx)("li", {
                    children: bullets[index].bullet
                }, index);
            });
        });
        _this.getStageRecommendations = $40949a42b0e934f1$export$a0e4cd1069957a24.bind(_this);
        _this.getContact = $40949a42b0e934f1$export$52411745da118fc8.bind(_this);
        return _this;
    }
    (0, $6hK4i._)(Result, [
        {
            key: "render",
            value: function render() {
                var viewBoxSize = 40;
                var _this_props = this.props, userData = _this_props.userData, image = _this_props.image, labels = _this_props.labels;
                var style = {
                    '--percentage': "".concat(userData.score, ", 100")
                };
                var recommendations = this.getStageRecommendations();
                var contact = this.getContact();
                var expert_headline = labels["expert_headline_".concat(contact.gender)];
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "ms-form__result",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                            className: "ms-form__score",
                            "data-color-scheme": "highlight",
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                                    className: "ms-form__percentage",
                                    style: style,
                                    children: [
                                        image && /*#__PURE__*/ (0, $9HB6H.jsx)((0, $32fed3bba8842c5f$export$2e2bcd8739ae039), {
                                            image: image
                                        }),
                                        /*#__PURE__*/ (0, $9HB6H.jsxs)("svg", {
                                            className: "value",
                                            viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize),
                                            children: [
                                                this.getCircle(viewBoxSize, 'circle-bg', 40),
                                                this.getCircle(viewBoxSize, 'circle-line'),
                                                this.getCircle(viewBoxSize, 'circle'),
                                                /*#__PURE__*/ (0, $9HB6H.jsx)("text", {
                                                    className: "text",
                                                    x: "50%",
                                                    y: "55%",
                                                    dominantBaseline: "middle",
                                                    textAnchor: "middle",
                                                    children: userData.score
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                recommendations.intro && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                    className: "ms-form__statement",
                                    children: /*#__PURE__*/ (0, $9HB6H.jsx)("h4", {
                                        className: "text-subline",
                                        children: recommendations.intro
                                    })
                                })
                            ]
                        }),
                        recommendations.text && /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                            className: "ms-form__recommendation",
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsx)("h4", {
                                    className: "ms-form__expert-headline",
                                    children: expert_headline
                                }),
                                contact.image && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                    className: "ms-form__expert-image",
                                    children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $32fed3bba8842c5f$export$2e2bcd8739ae039), {
                                        image: contact.image
                                    })
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                                    className: "ms-form__expert-text",
                                    children: [
                                        /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: recommendations.text
                                            }
                                        }),
                                        recommendations.bullet_points && /*#__PURE__*/ (0, $9HB6H.jsx)("ul", {
                                            children: this.getBulletPoints(recommendations.bullet_points)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                    className: "ms-form__expert-ending",
                                    children: /*#__PURE__*/ (0, $9HB6H.jsxs)("p", {
                                        children: [
                                            labels.contact_greeting,
                                            /*#__PURE__*/ (0, $9HB6H.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $9HB6H.jsxs)("strong", {
                                                children: [
                                                    contact.first_name,
                                                    " ",
                                                    contact.last_name
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return Result;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $a9cb228b2906bac6$export$2e2bcd8739ae039 = $a9cb228b2906bac6$var$Result;
$a9cb228b2906bac6$var$Result.propTypes = {
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    image: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).any,
    highscoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    contacts: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    updateUserContact: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func
};



var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $3b7fd172429eb18a$var$Section = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Section, _React_Component);
    function Section() {
        (0, $4QweW._)(this, Section);
        return (0, $ehF45._)(this, Section, arguments);
    }
    (0, $6hK4i._)(Section, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, image = _this_props.image, title = _this_props.title, text = _this_props.text;
                return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                    className: "ms-form__intro",
                    children: [
                        image && /*#__PURE__*/ (0, $9HB6H.jsx)((0, $32fed3bba8842c5f$export$2e2bcd8739ae039), {
                            image: image
                        }),
                        title && /*#__PURE__*/ (0, $9HB6H.jsx)("h3", {
                            children: title
                        }),
                        text && /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                            className: "text-subline-sm",
                            dangerouslySetInnerHTML: {
                                __html: text
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return Section;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $3b7fd172429eb18a$export$2e2bcd8739ae039 = $3b7fd172429eb18a$var$Section;
$3b7fd172429eb18a$var$Section.propTypes = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};


var $3d59b98f9d9f579d$var$Slide = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(Slide, _React_Component);
    function Slide(props) {
        (0, $4QweW._)(this, Slide);
        var _this;
        _this = (0, $ehF45._)(this, Slide, [
            props
        ]), (0, $6tY97._)(_this, "getSlideContent", function(type) {
            var _this_props = _this.props, contacts = _this_props.contacts, slide = _this_props.slide, slides = _this_props.slides, labels = _this_props.labels, handleChange = _this_props.handleChange, handleSliderChange = _this_props.handleSliderChange, dimensions = _this_props.dimensions, userInput = _this_props.userInput, userData = _this_props.userData;
            switch(type){
                case 'content':
                    return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $3b7fd172429eb18a$export$2e2bcd8739ae039), {
                        image: slide.image,
                        title: slide.title,
                        text: slide.text
                    });
                case 'question':
                    return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $d03b1a42095698b4$export$2e2bcd8739ae039), {
                        userInput: userInput,
                        question: slide,
                        labels: labels,
                        handleChange: handleChange,
                        handleSliderChange: handleSliderChange
                    });
                case 'results':
                    return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $a9cb228b2906bac6$export$2e2bcd8739ae039), {
                        labels: labels,
                        image: slide.image,
                        highscoreContent: slide.highscore,
                        dimensions: dimensions,
                        userData: userData,
                        contacts: contacts,
                        updateUserContact: _this.props.updateUserContact
                    });
                case 'next_steps':
                    return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $e16ad2ef1a7f9b40$export$2e2bcd8739ae039), (0, $hApvp._)((0, $kWfK0._)({}, slide), {
                        userData: userData,
                        slides: slides,
                        dimensions: dimensions
                    }));
            }
        });
        return _this;
    }
    (0, $6hK4i._)(Slide, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                    id: "slide",
                    className: "ms-form__slide",
                    children: this.getSlideContent(this.props.slide.type)
                });
            }
        }
    ]);
    return Slide;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $3d59b98f9d9f579d$export$2e2bcd8739ae039 = $3d59b98f9d9f579d$var$Slide;
$3d59b98f9d9f579d$var$Slide.propTypes = {
    contacts: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    handleSliderChange: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    slide: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    slides: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).array,
    updateUserContact: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).array
    ])
};



var $5cT1S = parcelRequire("5cT1S");
var $a9c69060b5b6b116$export$b3b42fd4816dc25f = function dbPushData() {
    var nextSlide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if ((0, $5cT1S.getUID)()) {
        var state = this.state;
        var uID = (0, $5cT1S.getUID)();
        var formData = {
            forms: {
                form_id: state.id,
                form_name: state.title,
                location: window.location.hostname + window.location.pathname,
                user_id: uID,
                completed: +(state.userData.progress >= state.slides.indexOf(state.slides.filter(function(slide) {
                    return slide.type === 'results';
                })[0])),
                progress: state.userData.progress,
                last_slide: state.position
            }
        };
        // If user switched to next slide
        if (nextSlide) {
            /**
			 * Check if scores can be sent to the database
			 */ // Loop dimensions in userData and check which of those have a valid score
            var dimensionScore = [];
            Object.keys(state.userData.dimensions).map(function(d) {
                if ('score' in state.userData.dimensions[d] && state.userData.dimensions[d].score !== false) // Build string, for example: "Collect: 34"
                dimensionScore.push(state.dimensions[d].name + ': ' + state.userData.dimensions[d].score);
            });
            formData.forms.dimension_score = dimensionScore.join('|');
            // Check if a total score exists
            if ('score' in state.userData && state.userData.score !== false) formData.forms.total_score = state.userData.score;
            /**
			 * Questions
			 */ var questions = [];
            /**
			 * Questions: Check previous slide
			 */ if (state.position > 0) {
                var prevSlide = state.slides[state.position - 1];
                if (prevSlide.type === 'question') {
                    var prevQuestion = {
                        form_id: state.id,
                        user_id: uID,
                        // end_timestamp
                        question_id: prevSlide.ID,
                        question_type: prevSlide.input_type,
                        dimension: prevSlide.dimension,
                        question_text: prevSlide.title
                    };
                    var results = state.userData.dimensions[prevSlide.dimension].results[prevSlide.ID];
                    var answerText;
                    if (prevSlide.input_type === 'scale' && prevSlide.scale_options.type === 'percentage') answerText = results.answers;
                    else if (Array.isArray(results.answers)) {
                        var answers = [];
                        results.answers.forEach(function(val) {
                            answers.push(prevSlide.answers[val].label);
                        });
                        answerText = answers.join('|');
                    } else answerText = prevSlide.answers[results.answers].label;
                    prevQuestion.answer = answerText;
                    if ('score' in results) prevQuestion.answer_score = results.score;
                    questions.push(prevQuestion);
                }
            }
            /**
			 * Questions: Check current slide
			 */ var currentSlide = state.slides[state.position];
            if (currentSlide.type === 'question') questions.push({
                form_id: state.id,
                user_id: uID,
                question_id: currentSlide.ID,
                question_type: currentSlide.input_type,
                dimension: currentSlide.dimension,
                question_text: currentSlide.title
            });
            if (questions.length) formData.questions = questions;
        }
        /**
		 * Send data
		 */ $a9c69060b5b6b116$export$4cf66ea383b0b3ac(formData, state);
    }
};
var $a9c69060b5b6b116$export$4cf66ea383b0b3ac = function dbFetch(data, state) {
    fetch(state.apiRout.itdms_ajax + '?action=' + window.itdms_ajax.db_action, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
};



var $hiya6 = parcelRequire("hiya6");

var $7c6n8 = parcelRequire("7c6n8");


var $6jIiv = parcelRequire("6jIiv");

var $5cT1S = parcelRequire("5cT1S");
var $fffbb00cb3f51917$var$App = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(App, _React_Component);
    function App(props) {
        (0, $4QweW._)(this, App);
        var _this;
        _this = (0, $ehF45._)(this, App, [
            props
        ]), (0, $6tY97._)(_this, "getInitialState", function() {
            return {
                position: 0,
                userData: {
                    dimensions: {},
                    score: false,
                    progress: 0
                }
            };
        }), (0, $6tY97._)(_this, "fetchPostData", function() {
            fetch(_this.props.api).then(function(response) {
                return response.json();
            }).then(function(json) {
                if (json) // Update state in two steps
                // 1. Push form data
                _this.setState(json, function() {
                    // 2. Fetch user data from session storage
                    _this.setState((0, $hApvp._)((0, $kWfK0._)({}, _this.getSessionData()), {
                        loaded: true
                    }));
                });
                else console.error(json);
            });
        });
        _this.state = (0, $kWfK0._)({
            loaded: false
        }, _this.getInitialState());
        // Bind imported functions
        _this.handleChange = $hiya6.handleChange.bind(_this);
        _this.handleSliderChange = $hiya6.handleSliderChange.bind(_this);
        _this.afterChangeHandled = $hiya6.afterChangeHandled.bind(_this);
        _this.goToExactSlide = $7c6n8.goToExactSlide.bind(_this);
        _this.goToPrevSlide = $7c6n8.goToPrevSlide.bind(_this);
        _this.goToNextSlide = $7c6n8.goToNextSlide.bind(_this);
        _this.onSlideChange = $7c6n8.onSlideChange.bind(_this);
        _this.restartSurvey = $7c6n8.restartSurvey.bind(_this);
        _this.getQuestionScore = $6jIiv.getQuestionScore.bind(_this);
        _this.calcUserScore = $6jIiv.calcUserScore.bind(_this);
        _this.calcDimensionScore = $6jIiv.calcDimensionScore.bind(_this);
        _this.calcTotalScore = $6jIiv.calcTotalScore.bind(_this);
        _this.generateUID = $5cT1S.generateUID.bind(_this);
        _this.trackUser = $5cT1S.trackUser.bind(_this);
        _this.getSessionData = $5cT1S.getSessionData.bind(_this);
        _this.getStorageFormKey = $5cT1S.getStorageFormKey.bind(_this);
        _this.updateSessionData = $5cT1S.updateSessionData.bind(_this);
        _this.updateUserContact = (0, $40949a42b0e934f1$export$56eb8157210847c9).bind(_this);
        _this.dbPushData = $a9c69060b5b6b116$export$b3b42fd4816dc25f.bind(_this);
        return _this;
    }
    (0, $6hK4i._)(App, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Fetch form data from REST API
                this.fetchPostData();
                // Generate user ID
                this.generateUID();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.state.loaded) // Update session storage to possibly restore the current state
                this.updateSessionData();
            }
        },
        {
            key: "render",
            value: function render() {
                var state = this.state;
                if (state.loaded) {
                    var slide = state.slides[state.position];
                    var progress = 'progress' in slide ? slide.progress : false;
                    var userInput = false;
                    if (slide.type === 'question') {
                        var _state_userData_dimensions_d_results, _state_userData_dimensions_d;
                        var d = slide.dimension;
                        userInput = ((_state_userData_dimensions_d = state.userData.dimensions[d]) === null || _state_userData_dimensions_d === void 0 ? void 0 : (_state_userData_dimensions_d_results = _state_userData_dimensions_d.results) === null || _state_userData_dimensions_d_results === void 0 ? void 0 : _state_userData_dimensions_d_results[slide.ID]) ? state.userData.dimensions[d].results[slide.ID].answers : false;
                    }
                    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                        className: "ms-form",
                        children: [
                            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $3d59b98f9d9f579d$export$2e2bcd8739ae039), {
                                updateUserContact: this.updateUserContact,
                                contacts: state.contacts,
                                dimensions: state.dimensions,
                                userData: state.userData,
                                userInput: userInput,
                                slide: slide,
                                labels: this.state.labels,
                                handleChange: this.handleChange,
                                handleSliderChange: this.handleSliderChange,
                                slides: state.slides
                            }),
                            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $242be4aa1e7f6b6f$export$2e2bcd8739ae039), {
                                resultsSlide: state.slides.indexOf(state.slides.filter(function(slide) {
                                    return slide.type === 'results';
                                })[0]),
                                slide: slide,
                                position: state.position,
                                slideCount: Object.keys(state.slides).length,
                                dimensions: state.dimensions,
                                progress: progress,
                                labels: this.state.labels,
                                restartBtnCallback: this.restartSurvey,
                                prevBtnCallback: this.goToPrevSlide,
                                nextBtnCallback: this.goToNextSlide,
                                goToSlideCallback: this.goToExactSlide,
                                userData: state.userData
                            })
                        ]
                    });
                } else return null;
            }
        }
    ]);
    return App;
}((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Component);
var $fffbb00cb3f51917$export$2e2bcd8739ae039 = $fffbb00cb3f51917$var$App;
$fffbb00cb3f51917$var$App.propTypes = {
    api: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};


var $ad9238f33d0911ec$var$el = document.querySelector('.maturity-score');
if ($ad9238f33d0911ec$var$el) {
    var $ad9238f33d0911ec$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($kwI20))).createRoot($ad9238f33d0911ec$var$el);
    $ad9238f33d0911ec$var$root.render(/*#__PURE__*/ (0, $9HB6H.jsx)((0, $fffbb00cb3f51917$export$2e2bcd8739ae039), {
        api: $ad9238f33d0911ec$var$el.getAttribute('data-rest-endpoint'),
        track: $ad9238f33d0911ec$var$el.getAttribute('data-track'),
        version: $ad9238f33d0911ec$var$el.getAttribute('data-version')
    }));
}

})();
//# sourceMappingURL=maturity_score.min.js.map
